import { ActivatedRoute, Router } from "@angular/router";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { DxDataGridComponent, DxTextBoxComponent } from "devextreme-angular";
import {
  FormControl,
  FormGroup,
  ValidationErrors,
  Validators,
} from "@angular/forms";

import { AppConstant } from "./../../../app.const";
import { DxSelectBoxComponent } from "devextreme-angular/ui/select-box";
import { OnDestroy } from '@angular/core';
import { SalesService } from "./../sales.service";
import { SwalComponent } from "@sweetalert2/ngx-sweetalert2";
import notify from "devextreme/ui/notify";
import { rangeValidator } from "./../../../template/shared/validators/range.validator";
import { stepValidator } from "./../../../template/shared/validators/steps.validator";
import { ApiCallStatusService } from "src/app/services/api-call-status.service";
import Swal, { SweetAlertResult } from "sweetalert2";

declare var $: any;
@Component({
  selector: "app-job-order",
  templateUrl: "./job-order.component.html",
  styleUrls: ["./job-order.component.scss"],
})
export class JobOrderComponent implements OnInit, OnDestroy {
   showSalesInput: boolean = false;
  shapesList: any[];
  @Input() dataSource: any;
  @Output() optSelected: EventEmitter<any> = new EventEmitter();
  customerId: any;
  @Input() hideSubmitBtn: boolean;
  customerBranchId: any;

  // BOOLEAN

  comboPricePopup: boolean;
  comboCoatingPrice: boolean;
  comboTintPrice: boolean;
  comboMirrorPrice: boolean;
  comboFittingPrice: boolean;
  loadingIndicator: boolean;
  toggleFrame: boolean;
  isEdit: boolean;
  loadingItemCatalog: boolean;
  allRequiredErrorShow: boolean;
  loadingSphRange: boolean;
  loadingAddfRange: boolean;
  loadingCylRange: boolean;
  sphRightTooltip: boolean;
  cylRightTooltip: boolean;
  sphLeftTooltip: boolean;
  cylLeftTooltip: boolean;
  ipdrTooltip: boolean;
  ipdlTooltip: boolean;
  loadingMaterials: boolean;
  loadingLeftIndex: boolean;
  loadingFocal: boolean;
  loadingFilters: boolean;
  isDefaultCoating: boolean;
  frameTypeLoading: boolean;
  loadingPoNumber: boolean;
  loadingCustomerType: boolean;
  loadingCustomerContact: boolean;
  loadingUoms: boolean;
  loadingRightIndex: boolean;
  loadingRightItemCatalog: boolean;
  loadingCustomer: boolean;
  loadingCuts: boolean;
  // holdSalesOrder: boolean;
  isPricePanel: boolean;
  rxProcessRole: boolean;
  isCopySaleOrder: boolean;
  complainStatus: boolean;
  // END BOOLEAN

  // NUMBER TYPE
  $rightOval: number;
  $leftOval: number;
  $hcPrice: number;
  $specialLogo: number;
  isComboPrice: boolean;
  $lensePrice: number;
  $coatingPrice: number;
  $tintPrice: number;
  $leftPrismPrice: number;
  $fittingPrice: number;
  $leftCtPrice: number;
  $leftEtPrice: number;
  $leftBaseCurvePrice: number;
  $rightBaseCurvePrice: number;
  $rightEtPrice: number;
  $mirrorPrice: number;
  $rightCtPrice: number;
  $rightPrismPrice: number;
  $leftDecPrice: number;
  $rightDecPrice: number;
  $engraveName: number;
  $discountPrice: number;
  $tailorMadePrice: number;
  $additionalPrice: number;
  $lensePriceRight: number;
  $lensePriceLeft: number;
  $tempFittingPrice: number;
  $tempRightCtPrice: number;
  $tempLeftCtPrice: number;
  $tempRightEtPrice: number;
  $tempLeftEtPrice: number;
  $tempMirrorPrice: number;
  $tempLeftBaseCurvePrice: number;
  $tempRightBaseCurvePrice: number;
  $tempLeftDecPrice: number;
  $tempRightDecPrice: number;
  $tempTailorMadePrice: number;
  $tempEngraveName: number;
  $tempSpecialLogo: number;
  $tempHcPrice: number;
  $tempLeftOval: number;
  $tempRightOval: number;
  $rightFittingPrice: number;
  $tempRightFittingPrice: number;
  rightFocalId: number;
  focalId: number;
  $selectedOtherServicePrice: number;
  $tempSelectedOtherServicePrice: number;
  $Total: number;
  $subTotalLeft: number;
  $subTotalRight: number;
  // END NUMBER TYPE

  // ANY AND ARRAY TYPE
  allCompanyBranches: any;
  allModels: any;
  allFrameType: any;
  brandMasterList: any[];
  colorMasterList: any[];
  priceSource: any;
  selectedItemCatalogObject: any;
  comboPriceSelectedData: any;
  allFrameCondition: any[];
  allLensShape: any;
  isTailorMade: boolean;
  isFitting: boolean;
  urgencyTypeList: any[];
  itemCatalogList: any;
  filterDesignTechs: any;
  designTechs: any;
  filteredFocalIds: any[];
  focalIdsList: any[];
  allMaterials: any;
  bothSidesForm: FormGroup;
  brandsList: any[];
  allFilters: any[];
  coatingBrands: any;
  leftFocalId: any;
  sphRightSearchCtrl: any;
  cylRightSearchCtrl: any;
  sphLeftSearchCtrl: any;
  cylLeftSearchCtrl: any;
  addfRightSearchCtrl: any;
  addfLeftSearchCtrl: any;
  allowedExtensions: RegExp;
  comboPriceList: any[];
  fittingList: any[];
  sphRangeList: any;
  leftCylRangeList: any;
  frameBrandList: any;
  addfRangeList: any[];
  leftIndexList: any;
  $tempCoatingPrice: any;
  $tempTintPrice: any;
  $tempLeftPrismPrice: any;
  $tempRightPrismPrice: any;
  $tempLensePriceLeft: any;
  $tempLensePriceRight: any;
  lenseError: any;
  allMaterialsForFitting: any[];
  salesOrderId: any;
  selectedCustomerContactEvent: any;
  salesOrderButton: { icon: string; type: string; onClick: () => void };
  selectedCustomerType: any;
  tempCustomerTypeList: any[];
  tempCustomerList: any;
  salesOrderData: any;
  customerTypelist: any[];
  customerList: any;
  fileredCustomerList: any;
  customerContactList: any;
  label: string;
  jobListing: any;
  lensSide: any;
  data: any;
  salesOrderType: any;
  cutUnCutsList: any[];
  selectedTemplate: any;
  otherServicesList: any[];
  allTints: any[];
  selectedTintObject: any;
  allSoAttribute: any;
  allColors: any[];
  allCoating: any[];
  allHCoating: any[];
  allMirrors: any[];
  otherServicesData: any[];
  engravesList: any[];
  appCons: AppConstant;
  rightCylRangeList: any[];
  isAdmin: any;
  isSupervisor: any;
  // END ANY AND ARRAY TYPE

  // VIEW CHILD
  @ViewChild("rxInformation") rxInformation: ElementRef;
  @ViewChild("requirement") requirement: ElementRef;
  @ViewChild("prism") prism: ElementRef;
  @ViewChild("frame") frame: ElementRef;
  @ViewChild("baseCurveInput") baseCurveInput: ElementRef;
  @ViewChild("prismInInput") prismInInput: ElementRef;
  @ViewChild("coatInput") coatInput: DxSelectBoxComponent;
  @ViewChild("minTHKInput") minTHKInput: ElementRef;
  @ViewChild("sptScrollElement") sptScrollElement: ElementRef;
  @ViewChild("customerInformation") customerInformation: ElementRef;
  @ViewChild("saveSwal") private saveSwal: SwalComponent;
  @ViewChild("ponumberTextbox") ponumberTextbox: DxTextBoxComponent;
  @ViewChild("frameBrand") frameBrand: DxSelectBoxComponent;
  // END VIEW CHILD

  // STRING TYPE
  imageView: string | ArrayBuffer;
  $msgLensePrice: string;
  type: string;
  invalidFile: boolean;
  isCoatingNotRequired: boolean;
  // END STRING


  @ViewChild("tempGrid") tempGrid: DxDataGridComponent;
  $tempCoatingPriceLeft: number;
  $tempMirrorPriceLeft: number;
  $tempTintPriceLeft: number;
  $coatingPriceLeft: number;
  $mirrorPriceLeft: number;
  $tintPriceLeft: number;
  $tempCoatingPriceRight: number;
  $tempMirrorPriceRight: number;
  $tempTintPriceRight: number;
  $coatingPriceRight: number;
  $mirrorPriceRight: number;
  $tintPriceRight: number;
 

  constructor(
    private _salesService: SalesService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
      private apiCallStatusSrvs:ApiCallStatusService
  ) {}
   isApiInProgress$ = this.apiCallStatusSrvs.isApiInProgress$;
  ngOnInit() {
    
    $('#main-content').css({'background': 'rgb(249 250 255)'});
    this.isAdmin = JSON.parse(localStorage.getItem('userData')).isAdmin;
    this.isSupervisor = JSON.parse(localStorage.getItem('userData')).isSupervisor;
    this.focalId = 0;
    this.$selectedOtherServicePrice = 0;
    this.$tempSelectedOtherServicePrice = 0;
    this.$Total = 0;
    this.$lensePrice = 0;
    this.$coatingPrice = 0;
    this.$tintPrice = 0;
    this.$leftPrismPrice = 0;
    this.$fittingPrice = 0;
    this.$leftCtPrice = 0;
    this.$leftEtPrice = 0;
    this.$leftBaseCurvePrice = 0;
    this.$rightBaseCurvePrice = 0;
    this.$rightEtPrice = 0;
    this.$mirrorPrice = 0;
    this.$rightCtPrice = 0;
    this.$rightPrismPrice = 0;
    this.$leftDecPrice = 0;
    this.$rightDecPrice = 0;
    this.$engraveName = 0;
    this.$discountPrice = 0;
    this.$tailorMadePrice = 0;
    this.$additionalPrice = 0;
    this.$lensePriceRight = 0;
    this.$lensePriceLeft = 0;
    this.$subTotalLeft = 0;
    this.$subTotalRight = 0;
    this.appCons = new AppConstant();
    this.type = "add";
    this.salesOrderId = this.activatedRoute.snapshot.params.id;

    // GET ALL CALL
    this.getInitForm();
    this.getInitCall();
    this.initReset();
    
    if (this.salesOrderId) {
      this.getAllSalesOrderBySalesOrderId(this.salesOrderId);
    } else {
      // INIT VRIABLES
      this.changeTemplate();
    }

    // BUTTON OPTION
    this.salesOrderButton = {
      icon: "./assets/img/search.png",
      type: "default",
      onClick: () => {
        const salesId = this.bothSidesForm?.get("salesId")?.value;
        // Validate: Required, Numeric, Minimum 5 digits
    if (!salesId || isNaN(salesId) || salesId.toString().length < 5) {
      notify(
        {
          message: "Please enter a valid Sales Order number (minimum 5 digits).",
          type: "error",
          width: 300,
          displayTime: 3000
        },
        "error"
      );
      return;
    }
        // this.salesOrderId = this.bothSidesForm.get("salesId").value;
        this.isCopySaleOrder = true;
        this.getAllSalesOrderBySalesOrderId(
          this.bothSidesForm.get("salesId").value
        );
      },
    };
    this._salesService.registerTabIndex();
    this.sideNavScroller();
  }
 toggleSalesInput(): void {
  this.showSalesInput = !this.showSalesInput;
}




blockNonNumeric(e: any): void {
  const key = e.event.key;

  // Allow control keys (backspace, arrows)
  if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'].includes(key)) {
    return;
  }

  // Block if not a digit
  if (!/^\d$/.test(key)) {
    notify(
      {
        message: "Only digits (0–9) are allowed.",
        type: "error",
        width: 300,
        displayTime: 2000
      },
      "error"
    );
    e.event.preventDefault();
  }
}



onSalesIdChanged(e: any): void {
  const value = e.value?.toString() || '';
  if (!/^\d*$/.test(value)) {
    notify(
      {
        message: "Only numeric input is allowed.",
        type: "error",
        width: 300,
        displayTime: 2000
      },
      "error"
    );

    // Remove non-numeric characters
    const cleaned = value.replace(/\D/g, '');
    this.bothSidesForm.get('salesId')?.setValue(cleaned);
  }
}
ngAfterViewInit(): void {
  const input = document.getElementById('salesOrderInput');
  if (input) {
    input.addEventListener('paste', (event: ClipboardEvent) => {
      const pastedData = event.clipboardData?.getData('text') || '';
      if (!/^\d+$/.test(pastedData)) {
        event.preventDefault();
        notify(
          {
            message: "Only numbers are allowed when pasting.",
            type: "error",
            width: 300,
            displayTime: 2000
          },
          "error"
        );
      }
    });
  }
}
blockIllegalKeys(e: any): void {
  const key = e.event.key;

  if (['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete'].includes(key)) {
    return;
  }

  // Let Ctrl/Command shortcuts pass
  if (e.event.ctrlKey || e.event.metaKey) {
    return;
  }

  if (!/^\d$/.test(key)) {
    notify(
      {
        message: "Only digits (0–9) are allowed.",
        type: "error",
        width: 300,
        displayTime: 2000
      },
      "error"
    );
    e.event.preventDefault();
  }
}

cleanSalesId(e: any): void {
  const value = e.value?.toString() || '';
  const cleaned = value.replace(/\D/g, '');
  if (value !== cleaned) {
    this.bothSidesForm.get('salesId')?.setValue(cleaned);
  }
}

 /**
  * @name getRedo
  * @param {boolean}
  * @return void
  */
  getRedo(isRedo: boolean) {
    if (isRedo) {
      this.loadingIndicator = true;
      this._salesService
      .isComplainApproved(this.bothSidesForm.get("salesId").value)
      .then((response: any) => {
        if (response.data.completed) {
          this.loadingIndicator = false;
          this.complainStatus = true;
          // RESOLVE TRUE
        } else {
          this.loadingIndicator = false;
          this.complainStatus = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
        }
      })
      .catch((error) => {
        this.loadingIndicator = false;
        this.complainStatus = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
    }
  }
/**
   * @name sideNavScroller
   * @description order price table up and down with window
   */
  sideNavScroller() {
    let lastScrollTop = 0;
    $('#main-content').scroll((event) => {
      let st = $('#main-content').scrollTop();
      $('.right-nav table').css({'margin-top': st + 'px'});
      // if (st > lastScrollTop) {
      //     // downscroll code
      //     $('.right-nav table').css({'margin-top': st + 'px'});

      // } else {
      //   $('.right-nav table').css({'margin-top': st'0px'});
      //     // upscroll code
      // }
      lastScrollTop = st;
    });
  }


  /**
   * @name changeTemplate
   * @return void
   * @description role selected template
   */
  changeTemplate(): void {
    if (this.selectedTemplate == "both") {
      // item catalog required left and right frame and fitting is required
      this.enabledLeftSide();
      this.enableddRightSide();
      this.bothSidesForm
        .get("itemCatalogFilters")
        .get("brandMasterId")
        .setValidators([Validators.required]);
      this.bothSidesForm
        .get("itemCatalogGroupId")
        .setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("fittingTypeId")
      //   .setValidators([Validators.required]);
      // this.bothSidesForm.get("frameType").setValidators([Validators.required]);
      this.bothSidesForm.get("qtyLeft").setValidators([Validators.required]);
      if (!this.isTailorMade &&  this.bothSidesForm.get("cutUncutLensId").value !== 1) {
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([
            Validators.required,
            rangeValidator(48, 80, "p"),
            stepValidator(1),
          ]);
      }
      if (!this.isTailorMade &&  this.bothSidesForm.get("cutUncutLensId").value !== 1) {
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([
            Validators.required,
            rangeValidator(48, 80, "p"),
            stepValidator(1),
          ]);
      }
      this.bothSidesForm.get("qtyRight").setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("rightFittingTypeId")
      //   .setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("rightFrameTypeId")
      //   .setValidators([Validators.required]);

      this.isOvalRightChange(this.bothSidesForm.get("isOvalRight").value);
      this.isOvalLeftChange(this.bothSidesForm.get("isOvalLeft").value);
      this.checkETCt(
        this.bothSidesForm.get("etRight").value,
        "etRight",
        "ctRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("ctRight").value,
        "ctRight",
        "etRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("decinRight").value,
        "decinRight",
        "decoutRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("decoutRight").value,
        "decoutRight",
        "decinRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("etLeft").value,
        "etLeft",
        "ctLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("ctLeft").value,
        "ctLeft",
        "etLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("decinLeft").value,
        "decinLeft",
        "decoutLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("decoutLeft").value,
        "decoutLeft",
        "decinLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismInRight").value,
        "prismInRight",
        "prismOutRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismOutRight").value,
        "prismOutRight",
        "prismInRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismUpRight").value,
        "prismUpRight",
        "prismDownRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismDownRight").value,
        "prismDownRight",
        "prismUpRight"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismInLeft").value,
        "prismInLeft",
        "prismOutLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismOutLeft").value,
        "prismOutLeft",
        "prismInLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismUpLeft").value,
        "prismUpLeft",
        "prismDownLeft"
      );
      this.checkETCt(
        this.bothSidesForm.get("prismDownLeft").value,
        "prismDownLeft",
        "prismUpLeft"
      );
    }
    if (this.selectedTemplate == "left") {
      // item catalog required left and frame and fitting is required
      this.disabledRightSide();
      this.enabledLeftSide();
      this.bothSidesForm
        .get("itemCatalogFilters")
        .get("brandMasterId")
        .setValidators([Validators.required]);
      this.bothSidesForm
        .get("itemCatalogGroupId")
        .setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("fittingTypeId")
      //   .setValidators([Validators.required]);
      // this.bothSidesForm.get("frameType").setValidators([Validators.required]);
      this.bothSidesForm.get("qtyLeft").setValidators([Validators.required]);
      if (!this.isTailorMade && this.bothSidesForm.get("cutUncutLensId").value !== 1) {
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([
            Validators.required,
            rangeValidator(48, 80, "p"),
            stepValidator(1),
          ]);
      }
      
      this.bothSidesForm.get("qtyRight").clearValidators();
      // this.bothSidesForm.get("rightFittingTypeId").clearValidators();
      // this.bothSidesForm.get("rightFrameTypeId").clearValidators();
      this.bothSidesForm.get("diameterRight").clearValidators();
      this.bothSidesForm
        .get("diameterRight")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        // ADDITIONAL REQUIREMENT
        this.isOvalLeftChange(this.bothSidesForm.get("isOvalLeft").value);
        this.checkETCt(
          this.bothSidesForm.get("etLeft").value,
          "etLeft",
          "ctLeft"
        );
        this.checkETCt(
          this.bothSidesForm.get("ctLeft").value,
          "ctLeft",
          "etLeft"
        );
        this.checkETCt(
          this.bothSidesForm.get("decinLeft").value,
          "decinLeft",
          "decoutLeft"
        );
        this.checkETCt(
          this.bothSidesForm.get("decoutLeft").value,
          "decoutLeft",
          "decinLeft"
        );
         // PRISAM
         this.checkETCt(
          this.bothSidesForm.get("prismInLeft").value,
          "prismInLeft",
          "prismOutLeft"
        );
        this.checkETCt(
          this.bothSidesForm.get("prismOutLeft").value,
          "prismOutLeft",
          "prismInLeft"
        );
        this.checkETCt(
          this.bothSidesForm.get("prismUpLeft").value,
          "prismUpLeft",
          "prismDownLeft"
        );
        this.checkETCt(
          this.bothSidesForm.get("prismDownLeft").value,
          "prismDownLeft",
          "prismUpLeft"
        );
    }
    if (this.selectedTemplate == "right") {
      this.disabledLeftSide();
      this.enableddRightSide();
      // item catalog required right frame and fitting is required
      this.bothSidesForm.get("qtyRight").setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("fittingTypeId")
      //   .setValidators([Validators.required]);
      // this.bothSidesForm.get("frameType").setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("rightFittingTypeId")
      //   .setValidators([Validators.required]);
      // this.bothSidesForm
      //   .get("rightFrameTypeId")
      //   .setValidators([Validators.required]);
      if (!this.isTailorMade &&  this.bothSidesForm.get("cutUncutLensId").value !== 1) {
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([
            Validators.required,
            rangeValidator(48, 80, "p"),
            stepValidator(1),
          ]);
      }
      this.bothSidesForm
        .get("itemCatalogFilters")
        .get("brandMasterId")
        .clearValidators();
      this.bothSidesForm.get("itemCatalogGroupId").clearValidators();
      this.bothSidesForm.get("qtyLeft").clearValidators();
      // this.bothSidesForm.get("fittingTypeId").clearValidators();
      // this.bothSidesForm.get("frameType").clearValidators();
      this.bothSidesForm.get("diameterLeft").clearValidators();
      this.bothSidesForm
        .get("diameterLeft")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);

         // ADDITIONAL REQUIREMENT
    this.isOvalRightChange(this.bothSidesForm.get("isOvalRight").value);
    this.checkETCt(
      this.bothSidesForm.get("etRight").value,
      "etRight",
      "ctRight"
    );
    this.checkETCt(
      this.bothSidesForm.get("ctRight").value,
      "ctRight",
      "etRight"
    );
    this.checkETCt(
      this.bothSidesForm.get("decinRight").value,
      "decinRight",
      "decoutRight"
    );
    this.checkETCt(
      this.bothSidesForm.get("decoutRight").value,
      "decoutRight",
      "decinRight"
    );
    // END
    // PRISAM
    this.checkETCt(
      this.bothSidesForm.get("prismInRight").value,
      "prismInRight",
      "prismOutRight"
    );
    this.checkETCt(
      this.bothSidesForm.get("prismOutRight").value,
      "prismOutRight",
      "prismInRight"
    );
    this.checkETCt(
      this.bothSidesForm.get("prismUpRight").value,
      "prismUpRight",
      "prismDownRight"
    );
    this.checkETCt(
      this.bothSidesForm.get("prismDownRight").value,
      "prismDownRight",
      "prismUpRight"
    );
    // END
    }
    this.bothSidesForm
      .get("itemCatalogFilters")
      .get("brandMasterId")
      .updateValueAndValidity();


   
   
    this.bothSidesForm.get("itemCatalogGroupId").updateValueAndValidity();
    this.bothSidesForm.get("qtyLeft").updateValueAndValidity();
    this.bothSidesForm.get("qtyRight").updateValueAndValidity();
    // this.bothSidesForm.get("fittingTypeId").updateValueAndValidity();
    // this.bothSidesForm.get("frameType").updateValueAndValidity();
    // this.bothSidesForm.get("rightFittingTypeId").updateValueAndValidity();
    // this.bothSidesForm.get("rightFrameTypeId").updateValueAndValidity();
    this.bothSidesForm.get("diameterRight").updateValueAndValidity();
    this.bothSidesForm.get("diameterLeft").updateValueAndValidity();
  }

  /**
   * @name disabledLeftSide
   * @return void
   * @description control disabled
   */
  disabledLeftSide(): void {
    this.bothSidesForm.get("sphLeft").disable();
    this.bothSidesForm.get("cylLeft").disable();
    this.bothSidesForm.get("axisLeft").disable();
    this.bothSidesForm.get("addfLeft").disable();
    this.bothSidesForm.get("qtyLeft").disable();
    this.bothSidesForm.get("diameterLeft").disable();
    this.bothSidesForm.get("ipdl").disable();
    this.bothSidesForm.get("lhft").disable();
    this.bothSidesForm.get("isOvalLeft").disable();
    this.bothSidesForm.get("ovalWidthLeft").disable();
    this.bothSidesForm.get("ovalHeightLeft").disable();
    
    this.bothSidesForm.get("baseCurveLeft").disable();
    this.bothSidesForm.get("etLeft").disable();
    this.bothSidesForm.get("ctLeft").disable();
    this.bothSidesForm.get("decinLeft").disable();
    this.bothSidesForm.get("decoutLeft").disable();

    this.bothSidesForm.get("prismInLeft").disable();
    this.bothSidesForm.get("prismOutLeft").disable();
    this.bothSidesForm.get("prismUpLeft").disable();
    this.bothSidesForm.get("prismDownLeft").disable();
    this.bothSidesForm.get("prismValueLeft").disable();
    this.bothSidesForm.get("prismAxisLeft").disable();

    
    this.bothSidesForm.get("sphLeft").setValue(null);
    this.bothSidesForm.get("cylLeft").setValue(null);
    this.bothSidesForm.get("axisLeft").setValue(null);
    this.bothSidesForm.get("addfLeft").setValue(null);
    this.bothSidesForm.get("qtyLeft").setValue(null);
    this.bothSidesForm.get("diameterLeft").setValue(null);
    this.bothSidesForm.get("ipdl").setValue(null);
    this.bothSidesForm.get("lhft").setValue(null);
    this.bothSidesForm.get("isOvalLeft").setValue(false);
    this.bothSidesForm.get("ovalWidthLeft").setValue(null);
    this.bothSidesForm.get("ovalHeightLeft").setValue(null);

    this.bothSidesForm.get("baseCurveLeft").setValue(null);
    this.bothSidesForm.get("etLeft").setValue(null);
    this.bothSidesForm.get("ctLeft").setValue(null);
    this.bothSidesForm.get("decinLeft").setValue(null);
    this.bothSidesForm.get("decoutLeft").setValue(null);

    this.bothSidesForm.get("prismInLeft").setValue(null);
    this.bothSidesForm.get("prismOutLeft").setValue(null);
    this.bothSidesForm.get("prismUpLeft").setValue(null);
    this.bothSidesForm.get("prismDownLeft").setValue(null);
    this.bothSidesForm.get("prismValueLeft").setValue(null);
    this.bothSidesForm.get("prismAxisLeft").setValue(null);
    this.$lensePriceLeft = 0;
    this.$leftPrismPrice = 0;
    this.$leftCtPrice = 0;
    this.$leftEtPrice= 0;
    this.$leftBaseCurvePrice= 0;
    this.$leftDecPrice = 0;
    this.$leftOval = 0;
  }
    /**
   * @name enabledLeftSide
   * @return void
   * @description control enable
   */
  enabledLeftSide(): void {
    this.bothSidesForm.get("sphLeft").enable();
    this.bothSidesForm.get("cylLeft").enable();
    this.bothSidesForm.get("axisLeft").enable();
    this.bothSidesForm.get("addfLeft").enable();
    this.bothSidesForm.get("qtyLeft").enable();
    this.bothSidesForm.get("diameterLeft").enable();
    this.bothSidesForm.get("ipdl").enable();
    this.bothSidesForm.get("lhft").enable();
    this.bothSidesForm.get("isOvalLeft").enable();
    this.bothSidesForm.get("ovalWidthLeft").enable();
    this.bothSidesForm.get("ovalHeightLeft").enable();

    this.bothSidesForm.get("baseCurveLeft").enable();
    this.bothSidesForm.get("etLeft").enable();
    this.bothSidesForm.get("ctLeft").enable();
    this.bothSidesForm.get("decinLeft").enable();
    this.bothSidesForm.get("decoutLeft").enable();

    this.bothSidesForm.get("prismInLeft").enable();
    this.bothSidesForm.get("prismOutLeft").enable();
    this.bothSidesForm.get("prismUpLeft").enable();
    this.bothSidesForm.get("prismDownLeft").enable();
    this.bothSidesForm.get("prismValueLeft").enable();
    this.bothSidesForm.get("prismAxisLeft").enable();
   
    const itemInterval = setInterval(() => {
      if (this.brandMasterList.length > 0) {
        if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
          if (JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyBranchId == 13) {
            let obj = this.brandMasterList.find(o => o.brandName == 'PRIVO');
            if (obj) {
              this.bothSidesForm
            .get("itemCatalogFilters")
            .get("brandMasterId")
            .setValue(obj.brandMasterId);
            }
          } else {
            this.bothSidesForm
            .get("itemCatalogFilters")
            .get("brandMasterId")
            .setValue(this.brandMasterList[0].brandMasterId);
          }
          if (this.type  == 'add') { 
            this.getViewItemCatalog();
          }
        }
      
         
        
        clearInterval(itemInterval);
      }
    }, 1000);
  }

   /**
   * @name disabledRightSide
   * @return void
   * @description control disabled
   */
  disabledRightSide(): void {
    this.bothSidesForm.get("sphRight").disable();
    this.bothSidesForm.get("cylRight").disable();
    this.bothSidesForm.get("axisRight").disable();
    this.bothSidesForm.get("addfRight").disable();
    this.bothSidesForm.get("qtyRight").disable();
    this.bothSidesForm.get("diameterRight").disable();
    this.bothSidesForm.get("ipdr").disable();
    this.bothSidesForm.get("rhft").disable();
    this.bothSidesForm.get("isOvalRight").disable();
    this.bothSidesForm.get("ovalWidthRight").disable();
    this.bothSidesForm.get("ovalHeightRight").disable();

    this.bothSidesForm.get("baseCurveRight").disable();
    this.bothSidesForm.get("etRight").disable();
    this.bothSidesForm.get("ctRight").disable();
    this.bothSidesForm.get("decinRight").disable();
    this.bothSidesForm.get("decoutRight").disable();

    this.bothSidesForm.get("prismInRight").disable();
    this.bothSidesForm.get("prismOutRight").disable();
    this.bothSidesForm.get("prismUpRight").disable();
    this.bothSidesForm.get("prismDownRight").disable();
    this.bothSidesForm.get("prismValueRight").disable();
    this.bothSidesForm.get("prismAxisRight").disable();
    
    this.bothSidesForm.get("sphRight").setValue(null);
    this.bothSidesForm.get("cylRight").setValue(null);
    this.bothSidesForm.get("axisRight").setValue(null);
    this.bothSidesForm.get("addfRight").setValue(null);
    this.bothSidesForm.get("qtyRight").setValue(null);
    this.bothSidesForm.get("diameterRight").setValue(null);
    this.bothSidesForm.get("ipdr").setValue(null);
    this.bothSidesForm.get("rhft").setValue(null);
    this.bothSidesForm.get("isOvalRight").setValue(false);
    this.bothSidesForm.get("ovalWidthRight").setValue(null);
    this.bothSidesForm.get("ovalHeightRight").setValue(null);

    this.bothSidesForm.get("baseCurveRight").setValue(null);
    this.bothSidesForm.get("etRight").setValue(null);
    this.bothSidesForm.get("ctRight").setValue(null);
    this.bothSidesForm.get("decinRight").setValue(null);
    this.bothSidesForm.get("decoutRight").setValue(null);

    this.bothSidesForm.get("prismInRight").setValue(null);
    this.bothSidesForm.get("prismOutRight").setValue(null);
    this.bothSidesForm.get("prismUpRight").setValue(null);
    this.bothSidesForm.get("prismDownRight").setValue(null);
    this.bothSidesForm.get("prismValueRight").setValue(null);
    this.bothSidesForm.get("prismAxisRight").setValue(null);
    
    this.$lensePriceRight = 0;
    this.$rightPrismPrice = 0;
    this.$rightCtPrice = 0;
    this.$rightEtPrice = 0;
    this.$rightBaseCurvePrice = 0;
    this.$rightDecPrice = 0;
    this.$rightOval = 0;
  }
    /**
   * @name enableddRightSide
   * @return void
   * @description control enable
   */
  enableddRightSide(): void {
    this.bothSidesForm.get("sphRight").enable();
    this.bothSidesForm.get("cylRight").enable();
    this.bothSidesForm.get("axisRight").enable();
    this.bothSidesForm.get("addfRight").enable();
    this.bothSidesForm.get("qtyRight").enable();
    this.bothSidesForm.get("diameterRight").enable();
    this.bothSidesForm.get("ipdr").enable();
    this.bothSidesForm.get("rhft").enable();
    this.bothSidesForm.get("isOvalRight").enable();
    this.bothSidesForm.get("ovalWidthRight").enable();
    this.bothSidesForm.get("ovalHeightRight").enable();

    this.bothSidesForm.get("baseCurveRight").enable();
    this.bothSidesForm.get("etRight").enable();
    this.bothSidesForm.get("ctRight").enable();
    this.bothSidesForm.get("decinRight").enable();
    this.bothSidesForm.get("decoutRight").enable();

    this.bothSidesForm.get("prismInRight").enable();
    this.bothSidesForm.get("prismOutRight").enable();
    this.bothSidesForm.get("prismUpRight").enable();
    this.bothSidesForm.get("prismDownRight").enable();
    this.bothSidesForm.get("prismValueRight").enable();
    this.bothSidesForm.get("prismAxisRight").enable();
  }
  /**
   * @name getInitForm
   * @param {Ojbect} Array of Object
   * @return void
   * @description Init Form State
   */
  getInitForm(dataSource?: any) {
    this.bothSidesForm = new FormGroup({
      leftSalesOrderJobId: new FormControl(
        dataSource ? dataSource.leftSalesOrderJobId : 0,
        []
      ),
      rightSalesOrderJobId: new FormControl(
        dataSource ? dataSource.rightSalesOrderJobId : 0,
        []
      ),
      salesOrderTypeId: new FormControl(5, []),
      asRedo: new FormControl(false, []),
      salesId: new FormControl(dataSource ? dataSource.salesOrderId : "", []),
      salesOrderId: new FormControl(dataSource ? dataSource.salesOrderId : 0, []),
      customerId: new FormControl(0, []),
      customerBranchId: new FormControl(
        dataSource ? dataSource.customerBranchId : "",
        [Validators.required]
      ),
      urgencyTypeId: new FormControl(
        dataSource ? dataSource.urgencyTypeId : 2,
        []
      ),
      customerTypeId: new FormControl(
        dataSource ? dataSource.customerTypeId : "",
        [Validators.required]
      ),
      instruction: new FormControl(
        dataSource ? dataSource.instruction : "",
        []
      ),
      remarks: new FormControl(dataSource ? dataSource.remarks : "", []),
      ponumber: new FormControl(dataSource ? dataSource.ponumber : "", []),
      brandMasterId: new FormControl(
        dataSource ? dataSource.brandMasterId : 0,
        []
      ),
      companyBranchId: new FormControl(
        dataSource ? dataSource.companyBranchId : 0,
        []
      ),
      createdByBranchId: new FormControl(
        JSON.parse(
          localStorage.getItem("selectedCustomerBranch")
        ).companyBranchId,
        []
      ),
      customerContactId: new FormControl(
        dataSource ? dataSource.customerContactId : "",
        []
      ),
      partnerOrderNumber: new FormControl(
        dataSource ? dataSource.partnerOrderNumber : "",
        []
      ),
      isOurLens: new FormControl(
        dataSource ? dataSource.isOurLens : false,
        []
      ),
      // rightIsOurLens: new FormControl(
      //   dataSource ? dataSource.rightIsOurLens : false,
      //   []
      // ),
      cutUncutLensId: new FormControl(
        dataSource ? dataSource.cutUncutLensId : "",
        []
      ),
      rightCutUncutLensId: new FormControl(
        dataSource ? dataSource.rightCutUncutLensId : "",
        []
      ),
      patientName: new FormControl(
        dataSource ? dataSource.patientName : "",
        []
      ),
      // LEFT
      itemCatalogGroupId: new FormControl(
        dataSource ? dataSource.itemCatalogGroupId : "",
        [Validators.required]
      ),
      itemCatalogFilters: new FormGroup({
        brandMasterId: new FormControl(
          dataSource ? dataSource.brandMasterId : 0,
          [Validators.required]
        ),
        materialId: new FormControl(0, []),
        focalId: new FormControl(0, []),
        indexId: new FormControl(0, []),
        filterId: new FormControl(0, []),
      }),
      // END LEFT
   
      salesOrderJobCustomizeInfoId: new FormControl(
        dataSource ? dataSource.salesOrderJobCustomizeInfoId : "",
        []
      ),
      salesOrderFrameFittingId: new FormControl(
        dataSource ? dataSource.salesOrderFrameFittingId : "",
        []
      ),
      leftSalesOrderLensId: new FormControl(
        dataSource ? dataSource.leftSalesOrderLensId : 0,
        []
      ),
      rightSalesOrderLensId: new FormControl(
        dataSource ? dataSource.rightSalesOrderLensId : 0,
        []
      ),
      salesOrderServiceId: new FormControl(
        dataSource ? dataSource.salesOrderServiceId : "",
        []
      ),

      urgencyType: new FormControl(
        dataSource && dataSource.urgencyType ? dataSource.urgencyType : 2,
        []
      ),

      searchLens: new FormControl(dataSource ? dataSource.searchLens : "", []),

      isWaitforSample: new FormControl(
        dataSource ? dataSource.isWaitforSample : "",
        []
      ),
      material: new FormControl(dataSource ? dataSource.material : "", []),
      brandName: new FormControl(dataSource ? dataSource.brandName : "", []),
      filter: new FormControl(dataSource ? dataSource.filter : "", []),
      tech: new FormControl(dataSource ? dataSource.tech : "", []),
      focal: new FormControl(dataSource ? dataSource.focal : "", []),
      coating: new FormControl(dataSource ? dataSource.coating : "", []),
      sphLeft: new FormControl(
        dataSource && dataSource.sphLeft
          ? (dataSource.sphLeft as string).toString()
          : null,
        []
      ),
      cylLeft: new FormControl(
        dataSource && dataSource.cylLeft
          ? (dataSource.cylLeft as string).toString()
          : null,
        []
      ),
      axisLeft: new FormControl(dataSource ? dataSource.axisLeft : "", [
        rangeValidator(1, 180, "p"),
        stepValidator(1)
      ]),
      addfLeft: new FormControl(
        dataSource && dataSource.addfLeft
          ? (dataSource.addfLeft as string).toString()
          : "",
        []
      ),
      qtyLeft: new FormControl(dataSource ? dataSource.qtyLeft : "", [
        Validators.required,
      ]),
      diameterLeft: new FormControl(dataSource ? dataSource.diameterLeft : "", [
        Validators.required, rangeValidator(48, 80, "p"),
        stepValidator(1)
      ]),
      isOvalLeft: new FormControl(
        dataSource ? dataSource.isOvalLeft : false,
        []
      ),
      ovalWidthLeft: new FormControl(
        dataSource ? dataSource.ovalWidthLeft : "",
        [rangeValidator(48, 80, "p"), stepValidator(1)]
      ),
      ovalHeightLeft: new FormControl(
        dataSource ? dataSource.ovalHeightLeft : "",
        [rangeValidator(48, 80, "p"), stepValidator(1)]
      ),
      sphRight: new FormControl(
        dataSource && dataSource.sphRight
          ? (dataSource.sphRight as string).toString()
          : null,
        []
      ),
      cylRight: new FormControl(
        dataSource && dataSource.cylRight
          ? (dataSource.cylRight as string).toString()
          : null,
        []
      ),
      axisRight: new FormControl(dataSource ? dataSource.axisRight : "", [
        rangeValidator(1, 180, "p"),
        stepValidator(1)
      ]),
      addfRight: new FormControl(
        dataSource && dataSource.addfRight
          ? (dataSource.addfRight as string).toString()
          : "",
        []
      ),
      qtyRight: new FormControl(dataSource ? dataSource.qtyRight : "", [
        Validators.required,
      ]),
      diameterRight: new FormControl(
        dataSource ? dataSource.diameterRight : "",
        [Validators.required, rangeValidator(48, 80, "p"), stepValidator(1)]
      ),
      isOvalRight: new FormControl(
        dataSource ? dataSource.isOvalRight : false,
        []
      ),
      ovalWidthRight: new FormControl(
        dataSource ? dataSource.ovalWidthRight : "",
        [rangeValidator(48, 80, "p"), stepValidator(1)]
      ),
      ovalHeightRight: new FormControl(
        dataSource ? dataSource.ovalHeightRight : "",
        [rangeValidator(48, 80, "p"), stepValidator(1)]
      ),

      rhft: new FormControl(dataSource ? dataSource.rhft : "", [
        rangeValidator(10, 40, "p")
      ]),
      lhft: new FormControl(dataSource ? dataSource.lhft : "", [
        rangeValidator(10, 40, "p")
      ]),
      ffv: new FormControl(dataSource ? dataSource.ffv : null, [
        rangeValidator(-1, 6, "b")
      ]),
      bvd: new FormControl(dataSource ? dataSource.bvd : null, [
        rangeValidator(5, 30, "p")
      ]),
      pa: new FormControl(dataSource ? dataSource.pa : null, [
        rangeValidator(-20, 30, "b")
      ]),
      wrap: new FormControl(dataSource ? dataSource.wrap : null, [
        rangeValidator(-5, 30, "b")
      ]),
      nwd: new FormControl(dataSource ? dataSource.nwd : null, [
        rangeValidator(0.2, 0.99, "p")
      ]),
      mid: new FormControl(dataSource ? dataSource.mid : "", [
        rangeValidator(1, 4, "p"),
        stepValidator(1)
      ]),
      age: new FormControl(dataSource ? dataSource.age : "", [
        rangeValidator(20, 100, "p"),
        stepValidator(1)
      ]),
      specialBase: new FormControl(dataSource ? dataSource.specialBase : "", [
        Validators.min(0),
        Validators.pattern(/^\d+(\.\d{1,2})?$/)
      ]),
      baseCurveLeft: new FormControl(
        dataSource ? dataSource.baseCurveLeft : "",
        [rangeValidator(0.5, 10, "p"), stepValidator(0.5)]
      ),
      etLeft: new FormControl(dataSource ? dataSource.etLeft : "", [
        rangeValidator(0.3, 5, "p")
      ]),
      ctLeft: new FormControl(dataSource ? dataSource.ctLeft : "", [
        rangeValidator(1.0, 10, "p")
      ]),
      decinLeft: new FormControl(dataSource ? dataSource.decinLeft : "", [
        rangeValidator(1, 10, "p"),
        stepValidator(1)
      ]),
      decoutLeft: new FormControl(dataSource ? dataSource.decoutLeft : "", [
        rangeValidator(1, 10, "p"),
        stepValidator(1)
      ]),
      baseCurveRight: new FormControl(
        dataSource ? dataSource.baseCurveRight : "",
        [rangeValidator(0.5, 10, "p"), stepValidator(0.5)]
      ),
      etRight: new FormControl(dataSource ? dataSource.etRight : "", [
        rangeValidator(0.3, 5, "p")
      ]),
      ctRight: new FormControl(dataSource ? dataSource.ctRight : "", [
        rangeValidator(1.0, 10, "p")
      ]),
      decinRight: new FormControl(dataSource ? dataSource.decinRight : "", [
        rangeValidator(1, 10, "p"),
        stepValidator(1)
      ]),
      decoutRight: new FormControl(dataSource ? dataSource.decoutRight : "", [
        rangeValidator(1, 10, "p"),
        stepValidator(1)
      ]),

      ipdLeft: new FormControl(dataSource ? dataSource.ipdLeft : "", []),
      prismInLeft: new FormControl(dataSource ? dataSource.prismInLeft : null, [
        rangeValidator(0.5, 18, "p"),
        stepValidator(0.25)
      ]),
      prismOutLeft: new FormControl(
        dataSource ? dataSource.prismOutLeft : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismUpLeft: new FormControl(dataSource ? dataSource.prismUpLeft : null, [
        rangeValidator(0.5, 18, "p"),
        stepValidator(0.25)
      ]),
      prismDownLeft: new FormControl(
        dataSource ? dataSource.prismDownLeft : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismValueLeft: new FormControl(
        dataSource ? dataSource.prismValueLeft : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismAxisLeft: new FormControl(
        dataSource ? dataSource.prismAxisLeft : null,
        [rangeValidator(0, 360, "p"), stepValidator(1)]
      ),
      ipdRight: new FormControl(dataSource ? dataSource.ipdRight : null, []),
      prismInRight: new FormControl(
        dataSource ? dataSource.prismInRight : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismOutRight: new FormControl(
        dataSource ? dataSource.prismOutRight : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismUpRight: new FormControl(
        dataSource ? dataSource.prismUpRight : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismDownRight: new FormControl(
        dataSource ? dataSource.prismDownRight : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismValueRight: new FormControl(
        dataSource ? dataSource.prismValueRight : null,
        [rangeValidator(0.5, 18, "p"), stepValidator(0.25)]
      ),
      prismAxisRight: new FormControl(
        dataSource ? dataSource.prismAxisRight : null,
        [rangeValidator(0, 360, "p"), stepValidator(1)]
      ),

      coat: new FormControl(dataSource ? dataSource.coat : null, []),
      coatingLocation: new FormControl(
        dataSource ? dataSource.coatingLocation : "",
        []
      ),
      backOnly: new FormControl(dataSource ? dataSource.backOnly : "", []),
      hc: new FormControl(dataSource ? dataSource.hc : "", []),
      hcLocation: new FormControl(dataSource ? dataSource.hcLocation : "", []),
      mirror: new FormControl(dataSource ? dataSource.mirror : "", []),
      tintType: new FormControl(dataSource ? dataSource.tintType : "", []),
      tintLocation: new FormControl(
        dataSource ? dataSource.tintLocation : "",
        []
      ),
      color1: new FormControl(dataSource ? dataSource.color1 : "", []),
      color2: new FormControl(dataSource ? dataSource.color2 : "", []),
      percentage: new FormControl(dataSource ? dataSource.percentage : "", [
        rangeValidator(0, 100, "p")
      ]),
      otherServices: new FormControl(
        dataSource ? dataSource.otherServices : "",
        []
      ),
      nameCode: new FormControl(dataSource ? dataSource.nameCode : "", []),
      engraveId: new FormControl(dataSource ? dataSource.engraveId : "", []),
      fitting: new FormControl(dataSource ? dataSource.fitting : false, []), // add or edit fixed value checked
      tailorMade: new FormControl(dataSource ? dataSource.tailorMade : "", []),
      frameType: new FormControl(dataSource ? dataSource.frameType : "", []),
      fittingTypeId: new FormControl(
        dataSource ? dataSource.fittingTypeId : "",
        []
      ),
      rightFrameTypeId: new FormControl(
        dataSource ? dataSource.rightFrameTypeId : "",
        []
      ),
      rightFittingTypeId: new FormControl(
        dataSource ? dataSource.rightFittingTypeId : "",
        []
      ),
      frameCondition: new FormControl(
        dataSource ? dataSource.frameCondition : "",
        []
      ),
      frameBrand: new FormControl(dataSource ? dataSource.frameBrand : "", []),
      frameMaterial: new FormControl(
        dataSource ? dataSource.frameMaterial : "",
        []
      ),
      frameColor: new FormControl(dataSource ? dataSource.frameColor : "", []),
      frameSize: new FormControl(dataSource ? dataSource.frameSize : "", [
        rangeValidator(30, 75, "p")
      ]),
      accurateIPD: new FormControl(
        dataSource ? dataSource.accurateIPD : false,
        []
      ),
      isTracing: new FormControl(
        dataSource ? dataSource.isTracing : false,
        []
      ),
      circumference: new FormControl(
        dataSource ? dataSource.circumference : "",
        []
      ),
      frameModel: new FormControl(dataSource ? dataSource.frameModel : "", []),
      dbl: new FormControl(dataSource ? dataSource.dbl : "", [
        rangeValidator(8, 30, "p")
      ]),
      ipdr: new FormControl(dataSource ? dataSource.ipdr : "", [
        rangeValidator(15, 40, "p")
      ]),
      ipdl: new FormControl(dataSource ? dataSource.ipdl : "", [
        rangeValidator(15, 40, "p")
      ]),
      frameRHFT: new FormControl(dataSource ? dataSource.frameRHFT : "", [
        rangeValidator(10, 50, "p")
      ]),
      frameLHFT: new FormControl(dataSource ? dataSource.frameLHFT : "", [
        rangeValidator(10, 50, "p")
      ]),
      segmentHeight: new FormControl(
        dataSource ? dataSource.segmentHeight : "",
        [rangeValidator(5, 40, "p")]
      ),
      lensReference: new FormControl(
        dataSource ? dataSource.lensShapeName : "",
        []
      ),
      tracingImage: new FormControl(
        dataSource ? dataSource.tracingImage : "",
        []
      ),
      tracingImageName: new FormControl(
        dataSource ? dataSource.tracingImageName : "",
        []
      ),
      shape: new FormControl(dataSource ? dataSource.shape : "", []),
      lensShapeId: new FormControl(
        dataSource ? dataSource.lensShapeId : "",
        []
      ),
      frameAvailable: new FormControl(
        dataSource ? dataSource.frameAvailable : false,
        []
      ),
      tailorWidth: new FormControl(
        dataSource ? dataSource.tailorWidth : "",
        []
      ),
      tailorHeight: new FormControl(
        dataSource ? dataSource.tailorHeight : "",
        []
      ),
      minTHK: new FormControl(dataSource ? dataSource.minTHK : "", []),
      maxTHK: new FormControl(dataSource ? dataSource.maxTHK : "", []),
      thkTample: new FormControl(dataSource ? dataSource.thkTample : "", []),
      thkNose: new FormControl(dataSource ? dataSource.thkNose : "", []),
      isFrameCase: new FormControl(
        dataSource ? dataSource.isFrameCase : "",
        []
      ),
      up: new FormControl(dataSource ? dataSource.up : "", [
        rangeValidator(-10, 10, "b")
      ]),
      down: new FormControl(dataSource ? dataSource.down : "", [
        rangeValidator(-10, 10, "b")
      ]),
      temple: new FormControl(dataSource ? dataSource.temple : "", [
        rangeValidator(-10, 10, "b")
      ]),
      nasel: new FormControl(dataSource ? dataSource.nasel : "", [
        rangeValidator(-10, 10, "b")
      ]),
      fittingLocationId: new FormControl(
        dataSource ? dataSource.fittingLocationId : "",
        []
      ),

      totalAmount: new FormControl(0, []),
      leftLensePrice: new FormControl(null, []),
      rightLensePrice: new FormControl(null, []),
      leftexcludebranddiscount: new FormControl(dataSource ? dataSource.leftexcludebranddiscount : 0, []),
      rightexcludebranddiscount: new FormControl(dataSource ? dataSource.rightexcludebranddiscount : 0, []),
      leftmpldetailId: new FormControl(dataSource ? dataSource.leftmpldetailId : 0, []),
      rightmpldetailId: new FormControl(dataSource ? dataSource.rightmpldetailId : 0, []),
      leftpricingTypeId: new FormControl(dataSource ? dataSource.pricingTypeId : 0, []),
      rightpricingTypeId: new FormControl(dataSource ? dataSource.pricingTypeId : 0, []),
      salesOrderReportFile: new FormControl(dataSource ? dataSource.salesOrderReportFile : null, []),
      rxPrice: new FormControl(null, [])
    });

    if (!this.salesOrderId) {
      this.bothSidesForm.get("ovalHeightRight").disable();
      this.bothSidesForm.get("ovalWidthRight").disable();
      this.bothSidesForm.get("ovalHeightLeft").disable();
      this.bothSidesForm.get("ovalWidthLeft").disable();
    }

   
    if (this.salesOrderId || this.bothSidesForm.get("salesId").value) {
      if(this.bothSidesForm.get("fitting").value) {
        this.isFitting = true;
        this.bothSidesForm.get("frameType").setValidators([Validators.required]);
        this.bothSidesForm.get("fittingTypeId").setValidators([Validators.required]);
        this.bothSidesForm.get("frameType").updateValueAndValidity();
        this.bothSidesForm.get("fittingTypeId").updateValueAndValidity();
      }

      if (this.bothSidesForm.get("tailorMade").value) {
        this.isTailorMade = true;
        this.frameAvailableCheck(this.isTailorMade);
        if (this.isTailorMade && !this.isFitting) {
          this.$fittingPrice = 0;
          this.$tempFittingPrice = 0;
        }
      }

      if (this.isTailorMade) {
        if (this.selectedTemplate == "both" || this.selectedTemplate == "right") {
          this.bothSidesForm
            .get("rhft")
            .setValidators([rangeValidator(10, 40, "p"), Validators.required]);
          this.bothSidesForm
            .get("ipdr")
            .setValidators([rangeValidator(15, 40, "p"), Validators.required]);
        }
        if (this.selectedTemplate == "both" || this.selectedTemplate == "left") {
          this.bothSidesForm
            .get("lhft")
            .setValidators([rangeValidator(10, 40, "p"), Validators.required]);
          this.bothSidesForm
            .get("ipdl")
            .setValidators([rangeValidator(15, 40, "p"), Validators.required]);
        }
          this.bothSidesForm.get("frameType").setValidators([Validators.required]);
        
        this.bothSidesForm
          .get("dbl")
          .setValidators([rangeValidator(8, 30, "p"), Validators.required]);
  
        this.bothSidesForm.get("diameterRight").setValue(null);
        this.bothSidesForm.get("diameterLeft").setValue(null);
        this.bothSidesForm.get("diameterLeft").clearValidators();
        this.bothSidesForm.get("diameterRight").clearValidators();
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterRight").disable();
        this.bothSidesForm.get("diameterLeft").disable();
        this.bothSidesForm.get("isOvalRight").setValue(false);
        this.bothSidesForm.get("isOvalLeft").setValue(false);
        this.bothSidesForm.get("isOvalRight").disable();
        this.bothSidesForm.get("isOvalLeft").disable();
        this.bothSidesForm.get("ovalHeightRight").setValue(null);
        this.bothSidesForm.get("ovalWidthRight").setValue(null);
        this.bothSidesForm.get("ovalHeightLeft").setValue(null);
        this.bothSidesForm.get("ovalWidthLeft").setValue(null);
  
        this.bothSidesForm.get("ovalWidthLeft").clearValidators();
        this.bothSidesForm.get("ovalHeightLeft").clearValidators();
        this.bothSidesForm.get("ovalWidthRight").clearValidators();
        this.bothSidesForm.get("ovalHeightRight").clearValidators();
        this.bothSidesForm.get("ovalWidthLeft").disable();
        this.bothSidesForm.get("ovalHeightLeft").disable();
        this.bothSidesForm.get("ovalWidthRight").disable();
        this.bothSidesForm.get("ovalHeightRight").disable();
        this.bothSidesForm
          .get("ovalWidthLeft")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm
          .get("ovalHeightLeft")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm
          .get("ovalWidthRight")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm
          .get("ovalHeightRight")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.$leftOval = 0;
        this.$tempLeftOval = 0;
        this.$rightOval = 0;
        this.$tempRightOval = 0;
      } else {
        if (!this.isFitting) {
          this.bothSidesForm.get("frameType").clearValidators();
          this.bothSidesForm.get("frameType").setValue(null);
          this.$tempFittingPrice = 0;
          this.$fittingPrice = 0;
          
        }
        this.bothSidesForm.get("lhft").clearValidators();
        this.bothSidesForm
          .get("lhft")
          .setValidators([rangeValidator(10, 40, "p")]);
        this.bothSidesForm.get("rhft").clearValidators();
        this.bothSidesForm
          .get("rhft")
          .setValidators([rangeValidator(10, 40, "p")]);
  
        this.bothSidesForm.get("ipdr").clearValidators();
        this.bothSidesForm.get("ipdl").clearValidators();
        this.bothSidesForm
          .get("ipdr")
          .setValidators([rangeValidator(15, 40, "p")]);
        this.bothSidesForm
          .get("ipdl")
          .setValidators([rangeValidator(15, 40, "p")]);
  
        this.bothSidesForm.get("dbl").clearValidators();
        this.bothSidesForm.get("dbl").setValidators([rangeValidator(8, 30, "p")]);
        this.bothSidesForm.get("dbl").setValue(null);
        this.bothSidesForm.get("lensReference").setValue(null);
        if (!this.isFitting && !this.isTailorMade) {
          this.bothSidesForm.get("up").setValue(null);
          this.bothSidesForm.get("temple").setValue(null);
          this.bothSidesForm.get("down").setValue(null);
          this.bothSidesForm.get("nasel").setValue(null);
        }
        this.bothSidesForm.get("frameAvailable").setValue(false);
        this.bothSidesForm.get("diameterRight").enable();
        this.bothSidesForm.get("diameterLeft").enable();
        this.bothSidesForm.get("diameterLeft").clearValidators();
        this.bothSidesForm.get("diameterRight").clearValidators();
        if (this.selectedTemplate == "both" || this.selectedTemplate == "right") {
          this.bothSidesForm
            .get("diameterRight")
            .setValidators([
              rangeValidator(48, 80, "p"),
              stepValidator(1),
              Validators.required,
            ]);
        }
        if (this.selectedTemplate == "both" || this.selectedTemplate == "left") {
          this.bothSidesForm
            .get("diameterLeft")
            .setValidators([
              rangeValidator(48, 80, "p"),
              stepValidator(1),
              Validators.required,
            ]);
        }
        this.bothSidesForm.get("isOvalRight").enable();
        this.bothSidesForm.get("isOvalLeft").enable();
      }

      this.bothSidesForm.get("lhft").updateValueAndValidity();
      this.bothSidesForm.get("rhft").updateValueAndValidity();
      this.bothSidesForm.get("ipdr").updateValueAndValidity();
      this.bothSidesForm.get("ipdl").updateValueAndValidity();
      this.bothSidesForm.get("dbl").updateValueAndValidity();
      this.bothSidesForm.get("diameterRight").updateValueAndValidity();
      this.bothSidesForm.get("diameterLeft").updateValueAndValidity();
      this.bothSidesForm.get("ovalWidthLeft").updateValueAndValidity();
      this.bothSidesForm.get("ovalHeightLeft").updateValueAndValidity();
      this.bothSidesForm.get("ovalWidthRight").updateValueAndValidity();
      this.bothSidesForm.get("ovalHeightRight").updateValueAndValidity();
      this.bothSidesForm.get("frameType").updateValueAndValidity();
     
      if (this.bothSidesForm.get('isOurLens').value) {
        const event = {
          checked: true
        };
        this.isOurLenseRole(event);
      }
      
        this.getViewItemCatalog();
        this.filtersByItemCatalog(dataSource ? dataSource.itemCatalogGroupId : 0);
        const itemInterval = setInterval(() => {
          if (
            this.itemCatalogList.length > 0 
          ) {
            // tslint:disable-next-line:no-shadowed-variable
            const itemInterval = setInterval(() => {
              if (this.customerList.length > 0) {
                this.getCustomerContactName(this.salesOrderData.customerBranchId);

                clearInterval(itemInterval);
              }
            }, 1000);
            clearInterval(itemInterval);
          }
        }, 1000);
        
    }
  }

  /**
   * @name validatedrequiredRole
   * @return boolean
   */
  get validatedrequiredRoleForIPDR() {
    if (this.bothSidesForm.get("tailorMade").value ||  this.bothSidesForm.get("ipdl").value) {
      this.bothSidesForm
      .get("ipdr")
      .setValidators([rangeValidator(15, 40, "p"), Validators.required]);
      this.bothSidesForm.get("ipdr").updateValueAndValidity();
      return true;
    } else {
      this.bothSidesForm.get("ipdr").clearValidators();
      this.bothSidesForm
      .get("ipdr")
      .setValidators([rangeValidator(15, 40, "p")]);
      this.bothSidesForm.get("ipdr").updateValueAndValidity();
      return false;
    }
  }

  get validatedrequiredRoleForIPDL() {
    if (this.bothSidesForm.get("tailorMade").value ||  this.bothSidesForm.get("ipdr").value) {
      this.bothSidesForm
      .get("ipdl")
      .setValidators([rangeValidator(15, 40, "p"), Validators.required]);
      this.bothSidesForm.get("ipdl").updateValueAndValidity();
      return true;
    } else {
      this.bothSidesForm.get("ipdl").clearValidators();
      this.bothSidesForm
      .get("ipdl")
      .setValidators([rangeValidator(15, 40, "p")]);
      this.bothSidesForm.get("ipdl").updateValueAndValidity();
      return false;
    }
    
  }

  /**
   * @name getInitCall
   * @description get all call dropdown calls
   */
  getInitCall() {
    this.getAllCustomerTypes();
    this.getAllMaterialsByCategory(3);
    this.getAllCompanyBranchByCustomerId(
      JSON.parse(localStorage.getItem("selectedCustomerBranch")).customerId,
      JSON.parse(localStorage.getItem("userData")).id
    );
    this.getAllUrgencyTypes();
    this.getAllCutUncuts();
    this.getAllMaterials();
    this.getAllFocals();
    this.getAllFittingTypes();
    this.getBrand();
    this.getAllFilters();
    this.getAllUrgencyTypes();
    this.getAllFrameCondition();
    this.getAllModel();
    this.getAllEngraves();
    this.getAllFrameBrands();
    this.getAllCompanyBranches();
    // this.getBrandMasterByCategoryId(1);
    this.getAllColorMasters();
    this.getAllFrames();
    // this.getSPH(-35, 30);
    // this.getCYL(-30, +35);
    // this.getADDF(0.25, 6);
    this.getAllShapes();
  }

  /**
   * @name initReset
   * @description init reset
   */
  initReset() {
    if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
      this.selectedTemplate = "both";
      const itemInterval = setInterval(() => {
        if (this.brandMasterList.length > 0) {
          if (JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyBranchId == 13) {
            let obj = this.brandMasterList.find(o => o.brandName == 'PRIVO');
            if (obj) {
              this.bothSidesForm
            .get("itemCatalogFilters")
            .get("brandMasterId")
            .setValue(obj.brandMasterId);
            }
            
          } else {
            this.bothSidesForm
            .get("itemCatalogFilters")
            .get("brandMasterId")
            .setValue(this.brandMasterList[0].brandMasterId);
          }
          
         
          this.getViewItemCatalog();
          // this.setBranchValue(
          //   this.bothSidesForm.get('companyBranchId').value
          // );
          clearInterval(itemInterval);
        }
      }, 1000);
      const companyBranchIdInterval = setInterval(() => {
        if (this.allCompanyBranches.length > 0) {
            this.bothSidesForm.get("companyBranchId").setValue(JSON.parse(localStorage.getItem('selectedCustomerBranch')).plantId);
          this.setBranchValue(this.bothSidesForm.get("companyBranchId").value);
          clearInterval(companyBranchIdInterval);
        }
      }, 1000);
    }

    this._salesService.registerTabIndex();
    this.lenseError = {
      left: null,
      right: null,
    };
    this.allSoAttribute = {
      rhft: false,
      lhft: false,
      ffv: false,
      mid: false,
      bvd: false,
      pa: false,
      wrap: false,
      age: false,
      specialBase: false,
      nwd: false,
     seght: false
    };
    this.selectedTintObject = {};
    this.allHCoating = [];
    this.engravesList = [];
    this.otherServicesData = [];
    this.allMirrors = [];
    this.allTints = [];
    this.allColors = [];
    this.allCoating = [];
    this.cutUnCutsList = [];
    this.customerTypelist = [];
    this.selectedCustomerContactEvent = {};
    this.selectedItemCatalogObject = {};
    this.comboPriceSelectedData = [];
    this.sphRangeList = [];
    this.leftCylRangeList = [];
    this.brandMasterList = [];
    this.colorMasterList = [];
    this.comboPriceList = [];
    this.itemCatalogList = [];
    this.fittingList = [];
    this.frameBrandList = [];
    this.addfRangeList = [];
    this.sphRightSearchCtrl = "";
    this.cylRightSearchCtrl = "";
    this.sphLeftSearchCtrl = "";
    this.cylLeftSearchCtrl = "";
    this.addfRightSearchCtrl = "";
    this.addfLeftSearchCtrl = "";
    this.leftIndexList = [];
    this.allMaterialsForFitting = [];
    this.allCompanyBranches = [];

    this.$lensePrice = 0;
    this.$lensePriceRight = 0;
    this.$lensePriceLeft = 0;
    this.$coatingPrice = 0;
    this.$tintPrice = 0;
    this.$leftPrismPrice = 0;
    this.$rightPrismPrice = 0;
    this.$fittingPrice = 0;
    this.$rightFittingPrice = 0; // not use
    this.$leftCtPrice = 0;
    this.$rightCtPrice = 0;
    this.$leftEtPrice = 0;
    this.$rightEtPrice = 0;
    this.$mirrorPrice = 0;
    this.$leftBaseCurvePrice = 0;
    this.$rightBaseCurvePrice = 0;
    this.$leftDecPrice = 0;
    this.$rightDecPrice = 0;
    this.$tailorMadePrice = 0;
    this.$selectedOtherServicePrice = 0;
    this.$engraveName = 0;
    this.$specialLogo = 0;
    this.$hcPrice = 0;
    this.$leftOval = 0;
    this.$rightOval = 0;
    this.$additionalPrice = 0;
    this.$discountPrice = 0;
    this.$coatingPriceRight = 0;
    this.$mirrorPriceRight = 0;
    this.$tintPriceRight = 0;
    this.$coatingPriceLeft = 0;
    this.$mirrorPriceLeft = 0;
    this.$tintPriceLeft = 0;
    
    // temp
    this.$tempLensePriceRight = 0;
    this.$tempLensePriceLeft = 0;
    this.$tempCoatingPrice = 0;
    this.$tempTintPrice = 0;
    this.$tempLeftPrismPrice = 0;
    this.$tempRightPrismPrice = 0;
    this.$tempFittingPrice = 0;
    this.$tempRightFittingPrice = 0;
    this.$tempLeftCtPrice = 0;
    this.$tempRightCtPrice = 0;
    this.$tempRightEtPrice = 0;
    this.$tempLeftEtPrice = 0;
    this.$tempMirrorPrice = 0;
    this.$tempLeftBaseCurvePrice = 0;
    this.$tempRightBaseCurvePrice = 0;
    this.$tempRightDecPrice = 0;
    this.$tempLeftDecPrice = 0;
    this.$tempTailorMadePrice = 0;
    this.$tempSelectedOtherServicePrice = 0;
    this.$tempEngraveName = 0;
    this.$tempSpecialLogo = 0;
    this.$tempHcPrice = 0;
    this.$tempLeftOval = 0;
    this.$tempRightOval = 0;
    this.$tempCoatingPriceRight = 0;
    this.$tempMirrorPriceRight = 0;
    this.$tempTintPriceRight = 0;
    this.$tempCoatingPriceLeft = 0;
    this.$tempMirrorPriceLeft = 0;
    this.$tempTintPriceLeft = 0;

    this.rxProcessRole = false;
    this.isTailorMade = false;
    this.isFitting = false;
    // this.holdSalesOrder = true;
    this.isCopySaleOrder = false;
    this.isComboPrice = false;
    this.isCoatingNotRequired = false;
  }

  /**
   * @name getAllSalesOrderBySalesOrderId
   * @returns array of object
   * @description sales order request data by id
   */
  getAllSalesOrderBySalesOrderId(saleOrderId: number) {
    this.loadingIndicator = true;
    this._salesService
      .getAllSalesOrderBySalesOrderId(saleOrderId)
      .then((response) => {
      
        if (response.data.completed) {
          if (response.data.payload) {
            this.type = "edit";
            this.salesOrderData = response.data.payload;
            this.data = this.salesOrderData;
            // if (!this.isCopySaleOrder) {
            //   this.holdSalesOrder = this.salesOrderData.holdSalesOrder;
            // }
            
            if (!this.isCopySaleOrder && this.salesOrderData.holdProcess) {
              const option = {
                width: 300,
                displayTime: 5000,
                message: 'Sale Order On Hold',
                type: 'error',
              };
              notify(option);
            }
            if (
              !this.isCopySaleOrder &&
              this.salesOrderData.salesOrderReportFile
            ) {
              $(".overlayItemUpdate").css("display", "block");
            }
            if (!this.isAdmin && !this.isSupervisor && this.salesOrderData.departmentId !==2 &&
              this.salesOrderData.holdProcess &&
              this.salesOrderData.processId > 0
            ) {
              $("#additional-requirement").addClass("overlay");
              $("#prism").addClass("overlay");
              $("#calculation").addClass("overlay");
              this.rxProcessRole = true;
            } else {
              $("#additional-requirement").removeClass("overlay");
              $("#prism").removeClass("overlay");
              $("#calculation").removeClass("overlay");
              this.rxProcessRole = false;
            }
            if (this.salesOrderData.salesOrderTypeId == 5) {
              if (
                this.salesOrderData &&
                this.salesOrderData.salesOrderDetail &&
                this.salesOrderData.salesOrderDetail.salesOrderLens.length > 0
              ) {
                if (
                  this.salesOrderData.salesOrderDetail.salesOrderLens.length ==
                  2
                ) {
                  this.selectedTemplate = "both";
                  // this.setBothSideData();
                }
                if (
                  this.salesOrderData.salesOrderDetail.salesOrderLens.length ==
                  1
                ) {
                  if (
                    this.salesOrderData &&
                    this.salesOrderData.salesOrderDetail &&
                    this.salesOrderData.salesOrderDetail.salesOrderLens &&
                    this.salesOrderData.salesOrderDetail.salesOrderLens[0]
                      .lensSideId == 1
                  ) {
                    this.selectedTemplate = "left";
                    // this.setLeftSideData();
                    this.disabledRightSide();
                  }
                  if (
                    this.salesOrderData &&
                    this.salesOrderData.salesOrderDetail &&
                    this.salesOrderData.salesOrderDetail.salesOrderLens &&
                    this.salesOrderData.salesOrderDetail.salesOrderLens[0]
                      .lensSideId == 2
                  ) {
                    this.selectedTemplate = "right";
                    this.disabledLeftSide();
                    // this.setRightSideData();
                  }
                }
              }
              this.setBothSideData();
             
             }
            if (this.isCopySaleOrder) {
              if (this.salesOrderData) {
                const itemInterval = setInterval(() => {
                  if(!this.salesOrderData.isOurLens){
                    if (this.itemCatalogList.length > 0) {
                    this.selectedItemCatalogObject = this.itemCatalogList.find(
                      (item) =>
                        item.itemCatalogGroupId ==
                        this.salesOrderData.salesOrderDetail.salesOrderLens[0]
                          .itemCatalogGroupId
                    );
                    if (
                      this.selectedTemplate == "both" ||
                      this.selectedTemplate == "left"
                    ) {
                      this.getRxPrice(
                        this.selectedItemCatalogObject.itemCatalogGroupId,
                        this.bothSidesForm.get("sphLeft").value,
                        this.bothSidesForm.get("cylLeft").value,
                        this.bothSidesForm.get("addfLeft").value,
                        "left",
                        this.selectedItemCatalogObject.priceGroupMasterId,
                        this.bothSidesForm.get("diameterLeft").value,
                        this.bothSidesForm.get("coat").value,
                        this.bothSidesForm.get("mirror").value,
                        this.bothSidesForm.get("tintType").value
                      );
                    }
                    if (
                      this.selectedTemplate == "both" ||
                      this.selectedTemplate == "right"
                    ) {
                      this.getRxPrice(
                        this.selectedItemCatalogObject.itemCatalogGroupId,
                        this.bothSidesForm.get("sphRight").value,
                        this.bothSidesForm.get("cylRight").value,
                        this.bothSidesForm.get("addfRight").value,
                        "right",
                        this.selectedItemCatalogObject.priceGroupMasterId,
                        this.bothSidesForm.get("diameterRight").value,
                        this.bothSidesForm.get("coat").value,
                        this.bothSidesForm.get("mirror").value,
                        this.bothSidesForm.get("tintType").value
                      );
                    }
                    this.getEdgingPrice(
                            this.selectedItemCatalogObject.brandMasterId,
                            this.bothSidesForm.get("customerBranchId").value,
                            this.selectedItemCatalogObject.indexId,
                            this.selectedItemCatalogObject.materialId,
                            this.bothSidesForm.get("frameType").value,
                            this.bothSidesForm.get("isOurLens").value
                          );
                    clearInterval(itemInterval);
                  }
                  } else {
                    if (this.itemCatalogList.length > 0) {
                        this.selectedItemCatalogObject = this.itemCatalogList.find(
                          (item) => item.itemCatalogGroupId == this.salesOrderData.salesOrderDetail.salesOrderLens[0].itemCatalogGroupId
                        );
                        this.getEdgingPrice(
                            this.selectedItemCatalogObject.brandMasterId,
                            this.bothSidesForm.get("customerBranchId").value,
                            this.selectedItemCatalogObject.indexId,
                            this.selectedItemCatalogObject.materialId,
                            this.bothSidesForm.get("frameType").value,
                            this.bothSidesForm.get("isOurLens").value
                          );
                          clearInterval(itemInterval);
                        }
                  }
                  
                }, 1000);
              }
          }
        } else {
          this.bothSidesForm.get("salesId").setValue(null);
          this.isCopySaleOrder = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
          // this.type = "add";
        }
        this.loadingIndicator = false;
      }
      })
      .catch((err) => {
      
        this.loadingIndicator = false;
         this.isCopySaleOrder = false;
        this.bothSidesForm.get("salesId").setValue(null);
        console.log("err ", err);
        // this.type = "add";
      });
  }

  /**
   * @name scrollToBottom
   * @description scroll down and up
   * @return void
   */
  scrollToBottom(salesOrderTypeId) {
    const smoothScrollConfig = {
      block: "start",
      inline: "nearest",
      behavior: "smooth",
    };
    let el;
    setTimeout(() => {
      switch (salesOrderTypeId) {
        case 3:
          if (this.sptScrollElement) {
            el = this.sptScrollElement.nativeElement;
          }
          break;
        case 10:
          if (this.customerInformation) {
            el = this.customerInformation.nativeElement;
          }
          break;
      }
      el.scrollIntoView();
    }, 100);
  }

    /**
   * @name getAllOtherServiesByFilter
   * @method GET
   * @param {number} brandMasterId
   * @param {number} materialId
   * @param {number} focalId
   * @return Promise
   */
  getAllOtherServiesByFilter(
    brandMasterId: number,
    materialId: number,
    focalId: number
  ) {
    this.loadingIndicator = true;
    this._salesService
      .getAllOtherServiesByFilter(brandMasterId, materialId, focalId)
      .then((response) => {
        if (response.data.completed) {
          this.otherServicesList = response.data.payload;
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

   /**
   * @name getAllShapes
   * @returns Promise
   * @description fetch all shapes
   */
  getAllShapes() {
    this._salesService
      .getAllShapes()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element: any) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.shapesList = list;
          } else {
            if (response.data.payload.active) {
              this.shapesList = response.data.payload;
            }
          }
        }
      })
      .catch((err) => {
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllCutUncuts
   * @returns Promise
   * @description fetch record
   */
  getAllCutUncuts() {
    this.loadingCuts = true;
    this._salesService
      .getAllCutUncuts()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.cutUnCutsList = list;
          } else {
            if (response.data.payload.active) {
              this.cutUnCutsList = response.data.payload;
            }
          }
        }
        this.loadingCuts = false;
      })
      .catch((err) => {
        this.loadingCuts = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllCustomerTypes
   * @reutrn Customer type list
   */

  getAllCustomerTypes() {
    this.loadingCustomerType = true;
    this.customerTypelist = [];
    this._salesService
      .getAllCustomerTypes()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.customerTypelist = list;
            this.tempCustomerTypeList = list;
            let filteredCustomerTypes = this.tempCustomerTypeList.filter(
              (x) => {
                return x.customerTypeId != 6;
              }
            );
            this.customerTypelist = filteredCustomerTypes;
          } else {
            if (response.data.payload.active) {
              this.customerTypelist = response.data.payload;
              this.tempCustomerTypeList = response.data.payload;
              let filteredCustomerTypes = this.tempCustomerTypeList.filter(
                (x) => {
                  return x.customerTypeId != 6;
                }
              );
              this.customerTypelist = filteredCustomerTypes;
            }
          }
        }
        this.loadingCustomerType = false;
        if (!this.salesOrderId) {
          this.bothSidesForm
            .get("customerTypeId")
            .setValue(this.customerTypelist[0].customerTypeId);
          // this.filterCustomer(this.customerTypelist[0].customerTypeId);
        }
      })
      .catch((err) => {
        this.loadingCustomerType = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllCompanyBranchByCustomerId
   * @param {number} userId
   * @param {number} companyBranchId
   * @returns Promise
   * @description fetch Customers
   */
   getAllCompanyBranchByCustomerId(customerId: number, userId: number) {
    if (customerId && userId) {
      this.loadingCustomer = true;
    this._salesService
      .getAllCompanyBranchByCustomerId(customerId, userId)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.customerList = list;
            this.tempCustomerList = list;
            // this.filterCustomer(1);
          } else {
            if (response.data.payload.active) {
              this.customerList = response.data.payload;
              this.tempCustomerList = response.data.payload;
              // this.filterCustomer(1);
            }
          }
        }
        this.loadingCustomer = false;
      })
      .catch((err) => {
        this.loadingCustomer = false;
        console.error("Error:  ", err);
      });
    }
    
  }

  /**
   *@name  filterProvinces
   *@param {number} countryId
   *@desc filters province list according to countryId
   */
  // filterCustomer(customerTypeId?: any, customerTypeEvent?: any) {
  //   this.customerList = [];
  //   if (this.tempCustomerList) {
  //     let filteredCustomers = this.tempCustomerList.filter((x) => {
  //       return x.customerTypeId === customerTypeId;
  //     });
  //     this.customerList = filteredCustomers;
  //   }
  // }

  /**
   *@name  filterProvinces
   *@param {number} customerBranchId
   *@desc filters customer Contact by branchid
   */
  getAllCustomerContactByCustomerBranchId(customerBranchId) {
    this.loadingCustomerContact = true;
    this.customerContactList = [];
    this._salesService
      .getAllCustomerContactByCustomerBranchId(customerBranchId)
      .then((response) => {
        if (response.data.completed) {
          // this.customerContactList = response.data.payload;
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.customerContactList = list;
          } else {
            this.customerContactList = response.data.payload;
          }
          let filterList = this.customerContactList.filter((item) => {
            return item.customerBranchId == customerBranchId;
          });
          this.customerContactList = filterList;
        }
        this.loadingCustomerContact = false;
      })
      .catch((err) => {
        this.loadingCustomerContact = false;
        console.error("Error:  ", err);
      });
  }
  /**
   * @name getCustomerContactName
   * @param {number} customerBranchId
   * @return void
   * @description customer object
   */
  getCustomerContactName(customerBranchId: number) {
    if (customerBranchId) {
      this.customerBranchId = customerBranchId;
      let event: any = {};
      const itemInterval = setInterval(() => {
        if (this.customerList.length > 0) {
          event = this.customerList.find(
            (c) => c.customerBranchId == customerBranchId
          );
          if (event && event.customerBranchId) {
            this.selectedCustomerContactEvent = event;
             this.customerId = event.customerId;
            //  this.getCustomerBrandMasterByCategoryId(1, this.customerId);
            this.getCustomerBrandMaster(this.customerId, true, false, false);

             this.filterAllItemCatalogs();
            //  if (!this.salesOrderId) {
                this.validateCustomerPaymentTerm(this.customerId, this.bothSidesForm.get("customerBranchId").value);
            //  }
             
              this.bothSidesForm.get("customerId").setValue(event.customerId);
              this.getAllCustomerContactByCustomerBranchId(event.customerBranchId);
              
              this.fileredCustomerList = this.customerList.find(
                (item) => item.customerBranchId == event.customerBranchId
              );
            // if (
            //   localStorage.getItem("user") && !JSON.parse(localStorage.getItem("user")).isAdministrator && 
            //   this.type == "add" &&
            //   this.salesOrderId &&
            //   event.customerId !== this.customerId
            // ) {
            //   // NEW REQUIRED
            //   this.saveSwal.options = {
            //     type: "error",
            //     timer: 3000,
            //     titleText:
            //       "Not Allowed to changed customer, only customer barch can be changed",
            //     showConfirmButton: false,
            //     confirmButtonText: "Reset",
            //     showCancelButton: false,
            //     allowOutsideClick: false,
            //     allowEscapeKey: false,
            //   };
            //   this.saveSwal.show().then((res: any) => {
            //     this.bothSidesForm.get("customerBranchId").setValue("");
            //     this.bothSidesForm
            //       .get("customerBranchId")
            //       .setValue(this.salesOrderData.customerBranchId);
            //   });
            // } else {
            //   this.customerId = event.customerId;
            //   this.bothSidesForm.get("customerId").setValue(event.customerId);
            //   this.getAllCustomerContactByCustomerBranchId(event.customerBranchId);
              
            //   this.fileredCustomerList = this.customerList.find(
            //     (item) => item.customerBranchId == event.customerBranchId
            //   );
            // }
            if (this.selectedCustomerContactEvent.providePO) {
              this.bothSidesForm
                .get("ponumber")
                .setValidators([Validators.required]);
            } else {
              this.bothSidesForm.get("ponumber").clearValidators();
            }
            this.bothSidesForm.get("ponumber").updateValueAndValidity();
          }
          // IF CUSTOMER ID CHANGE THEN PRICE AND RELATED API TO CUSTOMER ID THEN CALL HERE
          if (Object.entries(this.selectedItemCatalogObject).length > 0) {
            this.getEdgingPrice(
              this.selectedItemCatalogObject.brandMasterId,
              this.bothSidesForm.get("customerBranchId").value,
              this.selectedItemCatalogObject.indexId,
              this.selectedItemCatalogObject.materialId,
              this.bothSidesForm.get('frameType').value,
              this.bothSidesForm.get('isOurLens').value
            );
            this.getOtherService(
              this.customerId,
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId,
              this.selectedItemCatalogObject.focalId
            );
            if (this.selectedTemplate == 'both' || this.selectedTemplate == 'left') {
                this.getRxPrice(this.selectedItemCatalogObject.itemCatalogGroupId, 
                  this.bothSidesForm.get('sphLeft').value, 
                  this.bothSidesForm.get('cylLeft').value, 
                  this.bothSidesForm.get('addfLeft').value, 'left', this.selectedItemCatalogObject.priceGroupMasterId,
                  this.bothSidesForm.get('diameterLeft').value, this.bothSidesForm.get('coat').value, this.bothSidesForm.get('mirror').value, this.bothSidesForm.get('tintType').value);
            }
            if (this.selectedTemplate == 'both' || this.selectedTemplate == 'right') {
                this.getRxPrice(this.selectedItemCatalogObject.itemCatalogGroupId, 
                  this.bothSidesForm.get('sphRight').value, 
                  this.bothSidesForm.get('cylRight').value, 
                  this.bothSidesForm.get('addfRight').value, 'right', this.selectedItemCatalogObject.priceGroupMasterId,
                  this.bothSidesForm.get('diameterRight').value, this.bothSidesForm.get('coat').value, this.bothSidesForm.get('mirror').value, this.bothSidesForm.get('tintType').value);
            }
          } 
          this.getPricing(null,'prismInRight','');
          this.getPricing(null,'prismUpRight','');
          this.getPricing(null,'prismInLeft','');
          this.getPricing(null,'prismUpLeft','');
          this.getPricing(null,'prismOutRight','');
          this.getPricing(null,'prismDownRight','');
          this.getPricing(null,'prismOutLeft','');
          this.getPricing(null,'prismDownLeft','');
          clearInterval(itemInterval);
        }
      }, 200);
      if (this.type == 'add') {
        this.bothSidesForm.get('customerContactId').setValue(null);
      }
    } 
  }

  /**
   * @name getPriceIsAvalible
   * @return boolean
   */
  getPriceIsAvalible() {
      if (this.$lensePriceRight > 0 || this.$lensePriceLeft > 0 || this.$leftOval > 0  
        || this.$rightOval > 0 || this.$leftPrismPrice > 0 || this.$rightPrismPrice > 0 
        || this.$rightFittingPrice > 0 || this.$leftCtPrice > 0 || this.$rightCtPrice > 0 
        || this.$leftEtPrice > 0 || this.$rightEtPrice > 0 || this.$leftBaseCurvePrice > 0 
        || this.$rightBaseCurvePrice > 0 || this.$leftDecPrice > 0 || this.$rightDecPrice > 0 
        || this.$fittingPrice > 0 || this.$tailorMadePrice > 0 || this.$selectedOtherServicePrice > 0 
        || this.$engraveName > 0 || this.$specialLogo > 0 || this.$hcPrice > 0 || this.$coatingPriceRight > 0 
        || this.$coatingPriceLeft > 0 || this.$mirrorPriceRight > 0 || this.$mirrorPriceLeft > 0 
        || this.$tintPriceLeft > 0 || this.$tintPriceRight > 0) {
          return true;
        } else {
          return false;
        }
  }

  /**
   * @name changeCustomerEvent
   * @return
   */
  changeCustomerEvent(customerBranchId: number) {
    if (customerBranchId) {
     
      let cBranchId = customerBranchId;
      if (this.getPriceIsAvalible()) {
        this.saveSwal.swalOptions = {
          icon: "error",
          titleText:
            "Change in Customer will reset the price and cannot be undone.",
          showConfirmButton: true,
          confirmButtonText: "Ok",
          showCancelButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
          timer: null
        };
        this.saveSwal.fire().then((res: any) => {
          console.log('Res', res);
          if (res && res.value) {
            // RESET ALL API CALL AGAIN 
            this.bothSidesForm.get('customerBranchId').setValue(cBranchId);
            this.getCustomerContactName(this.bothSidesForm.get('customerBranchId').value);
           
          } else {
            // set old customer id
            this.bothSidesForm.get('customerBranchId').setValue(this.customerBranchId);
            this.getCustomerContactName(this.bothSidesForm.get('customerBranchId').value);
          }
        });
      } else {
        this.getCustomerContactName(this.bothSidesForm.get('customerBranchId').value);
      }
    } 
  }

  /**
   * @name validateCustomerPaymentTerm
   * @param {number} customerId
   * @returns Promise
   * @description customer validation limit
   */
   validateCustomerPaymentTerm(customerId: number, customerBranchId: any) {
    if (customerId && customerBranchId) {
      this._salesService
        .validateCustomerPaymentTerm(customerId, customerBranchId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload) {
              this.saveSwal.swalOptions = {
                icon: "warning",
                titleText: response.data.payload,
                showConfirmButton: false,
                confirmButtonText: "Reset",
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                timer: null
              };
              this.saveSwal.fire().then((res: any) => {
                if (res && res.dismiss && res.dismiss == 'cancel') {
                  if (response.data.payload && response.data.payload.toLowerCase().includes('blocked')) {
                    this.bothSidesForm.get('customerBranchId').setValue(null);
                    this.customerInformation.nativeElement.scrollIntoView();
                   }
                }
              });
            }
          } else {
            const option = {
              width: 300,
              displayTime: 8000,
              message: response.data.message,
              type: "error",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.log("err ", err);
        });
    }
  }

  

  /**
   * @name isValidatePONumber
   * @param {string} poNumber
   * @param {number} customerId
   * @returns boolean
   * @description true false
   */
  isValidatePONumber(poNumber: string, customerId: number) {
    if (poNumber && customerId) {
      this.loadingPoNumber = true;
      this._salesService
        .isValidatePONumber(poNumber, customerId)
        .then((response) => {
          if (response.data.completed && response.data.payload == 1) {
            if (
              this.selectedCustomerContactEvent &&
              this.selectedCustomerContactEvent.providePO
            ) {
              this.bothSidesForm.get("ponumber").setValue("");
            }
            const option = {
              width: 300,
              displayTime: 5000,
              message: "Po Number already exit!...",
              type: "warning",
            };
            notify(option);
          } else {
          }
          this.loadingPoNumber = false;
        })
        .catch((err) => {
          this.loadingPoNumber = false;
          console.log("err ", err);
        });
    }
  }



  /**
   * @name getCutUncutLensId
   * @return void
   */
  getCutUncutLensId(cutUncutLensId: number, label) {
    
    if (this.selectedTemplate == "both") {
      if (cutUncutLensId && cutUncutLensId == 1) {
        this.bothSidesForm.get("diameterRight").setValue("");
        this.bothSidesForm.get("diameterLeft").setValue("");
        this.bothSidesForm.get("diameterRight").clearValidators();
        this.bothSidesForm.get("diameterLeft").clearValidators();
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterRight").disable();
        this.bothSidesForm.get("diameterLeft").disable();
      } else {
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([Validators.required, rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([Validators.required, rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterRight").enable();
        this.bothSidesForm.get("diameterLeft").enable();
      }
    }
    if (this.selectedTemplate == "left") {
      if (cutUncutLensId && cutUncutLensId == 1) {
        this.bothSidesForm.get("diameterLeft").setValue("");
        this.bothSidesForm.get("diameterLeft").clearValidators();
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterLeft").disable();
      } else {
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterLeft").enable();
      }
    }
    if (this.selectedTemplate == "right") {
      if (cutUncutLensId && cutUncutLensId == 1) {
        this.bothSidesForm.get("diameterRight").setValue("");
        this.bothSidesForm.get("diameterRight").clearValidators();
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterRight").disable();
      } else {
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get("diameterRight").enable();
      }
    }
    this.bothSidesForm.get("diameterRight").updateValueAndValidity();
    this.bothSidesForm.get("diameterLeft").updateValueAndValidity();
  }

  /**
   * @name checkHasPrice
   * @return boolean
   * @description check is any item has been price then return true else false; true for green class else white 
   */
   get checkHasPrice() {
    if(this.$lensePriceRight > 0 || this.$lensePriceLeft > 0 || this.$coatingPrice > 0 || this.$tintPrice > 0 || this.$leftPrismPrice > 0 || 
      this.$rightPrismPrice > 0 || this.$fittingPrice > 0 || this.$rightFittingPrice > 0 || this.$leftCtPrice > 0 || this.$rightCtPrice > 0 || 
      this.$leftEtPrice > 0 || this.$rightEtPrice > 0 || this.$mirrorPrice > 0 || this.$leftBaseCurvePrice > 0 || this.$rightBaseCurvePrice > 0 || 
      this.$leftDecPrice > 0 || this.$rightDecPrice > 0 || this.$tailorMadePrice > 0 || this.$selectedOtherServicePrice > 0 || this.$engraveName > 0 || 
      this.$specialLogo > 0 || this.$hcPrice > 0 || this.$leftOval > 0 || this.$rightOval > 0) {
          return true;
      } else {
        return false;
      }
  }

  /**
   * @name isOurLenseRole
   * @param {MatCheckboxChange} event
   * @param {string} label
   * @return void
   * @description check if isOurLense true then lense price is 0 other wise default lense price add
   */
  isOurLenseRole(event: any) {
    if (event.checked) {
      this.$lensePriceLeft = 0;
      this.$lensePriceRight = 0;
      this.bothSidesForm.get("cutUncutLensId").setValidators([Validators.required]);
    } else {
      if (
        this.bothSidesForm.get("qtyRight").value > 0 &&
        (this.selectedTemplate == "both" || this.selectedTemplate == "right")
      ) {
        this.$lensePriceRight = this.$tempLensePriceRight;
        // this.$lensePriceRight =
        // this.$tempLensePriceRight *
        // this.bothSidesForm.get("qtyRight").value;
        this.bothSidesForm
        .get("diameterRight")
        .setValue(
          this.selectedItemCatalogObject
            ? this.selectedItemCatalogObject.diameter
            : null
        );
      }

      if (
        this.bothSidesForm.get("qtyLeft").value > 0 &&
        (this.selectedTemplate == "both" || this.selectedTemplate == "left")
      ) {
        this.$lensePriceLeft = this.$tempLensePriceLeft;
        // this.$lensePriceLeft =
        // this.$tempLensePriceLeft *
        // this.bothSidesForm.get("qtyLeft").value;
        this.bothSidesForm
          .get("diameterLeft")
          .setValue(
            this.selectedItemCatalogObject
              ? this.selectedItemCatalogObject.diameter
              : null
          );
      }
      this.bothSidesForm.get("cutUncutLensId").setValue("");
      this.bothSidesForm.get("cutUncutLensId").clearValidators();
    }
    this.bothSidesForm.get("cutUncutLensId").updateValueAndValidity();
  }
  
  /**
   * @name validateZeroValue
   * @return void
   *  */

  validateZeroValue(controlNme: string) {
    if (this.bothSidesForm.get(controlNme).value == 0) {
      this.bothSidesForm.get(controlNme).setValue("");
      return;
    }
  }

  /**
   * @name getRightQtyRole
   * @return boolean
   * @description this role implment for 03/11/2020 : 7:03AM  if user add qty then auto add 2nd qty becouse qty are same
   */
  getRightQtyRole() {
    if (
      this.bothSidesForm.get("qtyLeft").value > 0 &&
      (this.selectedTemplate == "both" || this.selectedTemplate == "right")
    ) {
      this.bothSidesForm
        .get("qtyRight")
        .setValue(this.bothSidesForm.get("qtyLeft").value);
      // this.addLensePrice("right");
    }
  }
  /**
   * @name getLeftQtyRole
   * @return boolean
   * @description this role implment for 03/11/2020 : 7:03AM  if user add qty then auto add 2nd qty becouse qty are same
   */
  getLeftQtyRole() {
    if (
      this.bothSidesForm.get("qtyRight").value > 0 &&
      (this.selectedTemplate == "both" || this.selectedTemplate == "left")
    ) {
      this.bothSidesForm
        .get("qtyLeft")
        .setValue(this.bothSidesForm.get("qtyRight").value);
      // this.addLensePrice("left");
    }
  }

  updateLensePriceForCombo(selectedTemplate: string) {
    if (this.isComboPrice) {
      if (
        this.bothSidesForm.get("qtyRight").value > 0 &&
        (selectedTemplate == "both" || selectedTemplate == "right")
      ) {
        this.addLensePrice("right");
      }

      if (
        this.bothSidesForm.get("qtyLeft").value > 0 &&
        (selectedTemplate == "both" || selectedTemplate == "left")
      ) {
         this.addLensePrice("left");
      }
    }
  }

  /**
   * @name onCustomItemCreating
   * @return void
   * @description creating new item
   */
  onCustomItemCreating(e) {
    // Generates a new 'id'
    const nextId =
      Math.max.apply(
        Math,
        this.frameBrandList.map((c) => c.frameBrandId)
      ) + 1;
    // Creates a new entry
    e.customItem = { frameBrandId: nextId, frameBrandName: e.text };
    this.frameBrandList.push(e.customItem);

    // Adds the entry to the data source
    // this.selectBoxData.store().insert(e.customItem);
    // // Reloads the data source
    // this.selectBoxData.reload();
  }
  toFixedMasking(controlName: any) {
    if (
      this.bothSidesForm.get(controlName).value &&
      this.bothSidesForm.get(controlName).value !== "+" &&
      this.bothSidesForm.get(controlName).value !== "-"
    ) {
      let value = this.bothSidesForm.get(controlName).value;
      //value.toFixed(1);
      if (value.toString().includes("-")) {
        // value.toString().replace('-',);
        this.bothSidesForm.get(controlName).setValue(value);
      } else {
        //let up = '+' + value;
        this.bothSidesForm.get(controlName).setValue(value);
      }
    } else {
      this.bothSidesForm.get(controlName).setValue("");
    }
  }

  /**
   * @name priceValueChange
   * @params {number} discount
   * @params {number} additional
   * @params {number} tailor
   * @return price module
   */
  priceValueChange(event: any) {
    this.$additionalPrice = event.additional ? event.additional : 0;
    this.$discountPrice = event.discount ? event.discount : 0;
    this.$fittingPrice = event.fittingUpdatedPrice ? event.fittingUpdatedPrice : 0,
    this.$Total = event.total ? event.total : 0;
    this.$subTotalLeft = event.subTotalLeft ? event.subTotalLeft : 0,
    this.$subTotalRight = event.subTotalRight ? event.subTotalRight : 0;
  }

  /**
   * @name getAllFittingTypes
   * @returns Promise
   * @description fetch all FittingType
   */
  getAllFittingTypes() {
    this._salesService
      .getAllFittingTypes()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element: any) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.fittingList = list;
              // this.bothSidesForm
              //   .get("fittingTypeId")
              //   .setValue(this.fittingList[0].fittingTypeId);
          } else {
            if (response.data.payload.active) {
              this.fittingList = response.data.payload;
            }
          }
        }
      })
      .catch((err) => {
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getToggleFrame
   * @returns bool
   * @description toggle for edit mode
   */
  getToggleFrame() {
    if (
      // this.bothSidesForm.get("fitting").value ||
      // this.bothSidesForm.get("tailorMade").value ||
      this.bothSidesForm.get("fittingTypeId").value ||
      this.bothSidesForm.get("frameType").value ||
      this.bothSidesForm.get("frameCondition").value ||
      this.bothSidesForm.get("frameBrand").value ||
      this.bothSidesForm.get("frameMaterial").value ||
      this.bothSidesForm.get("frameColor").value ||
      this.bothSidesForm.get("frameSize").value ||
      this.bothSidesForm.get("accurateIPD").value ||
      this.bothSidesForm.get("circumference").value ||
      this.bothSidesForm.get("frameModel").value ||
      this.bothSidesForm.get("dbl").value ||
      //  this.bothSidesForm.get('ipdr').value ||
      //  this.bothSidesForm.get('ipdl').value ||
      // this.bothSidesForm.get("frameRHFT").value ||
      // this.bothSidesForm.get("frameLHFT").value ||
      // this.bothSidesForm.get("segmentHeight").value ||
      this.bothSidesForm.get("lensReference").value ||
      this.bothSidesForm.get("frameAvailable").value ||
      this.bothSidesForm.get("shape").value ||
      this.bothSidesForm.get("tailorWidth").value ||
      this.bothSidesForm.get("tailorHeight").value
    ) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @name onFileChange
   * @return image
   */

  onFileChange(event: any) {
    this.invalidFile = false;
    if (event.target.files.length > 0) {
      this.allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
      // if (this.allowedExtensions.exec(event.target.files[0].name)) {
      //   this.bothSidesForm.get("tracingImage").setValue(null);
      //   this.bothSidesForm.get("tracingImageName").setValue(null);
      //   this.invalidFile = true;
      //   return false;
      // } else {
        let reader = new FileReader();
        if (event.target.files && event.target.files.length) {
          const [file] = event.target.files;
          reader.readAsDataURL(file);
          reader.onload = () => {
            // AVOIDING UN-NECESAARY ERROR
            this.imageView = file;
            this.bothSidesForm
              .get("tracingImage")
              .setValue((reader.result as string).split(",")[1]);
            this.bothSidesForm.get("tracingImageName").setValue(file.name);
          };
        // }
      }
    }
  }

  /**
   * @name allReset
   * @retirn void
   * @description reset all value
   */
  allReset() {
    this.bothSidesForm.get("coat").setValue("");
    this.bothSidesForm.get("coat").enable();
    this.bothSidesForm.get("tintType").setValue("");
    this.bothSidesForm.get("tintType").enable();
    this.bothSidesForm.get("mirror").setValue("");
    this.bothSidesForm.get("mirror").enable();
    this.bothSidesForm.get("fittingTypeId").setValue(null);
    this.bothSidesForm.get("fittingTypeId").enable();
    // this.bothSidesForm.get("rightFittingTypeId").setValue("");
    // this.bothSidesForm.get("rightFittingTypeId").enable();
    this.$lensePrice = 0;
    this.$coatingPrice = 0;
    this.$tintPrice = 0;
    this.$mirrorPrice = 0;
    this.$rightOval = 0;
    this.$leftOval = 0;
    this.$leftEtPrice = 0;
    this.$rightEtPrice = 0;
    this.$leftCtPrice = 0;
    this.$rightCtPrice = 0;
    this.$leftDecPrice = 0;
    this.$rightDecPrice = 0;
    this.$leftPrismPrice = 0;
    this.$rightPrismPrice = 0;
    this.$leftBaseCurvePrice = 0;
    this.$rightBaseCurvePrice = 0;
    this.$hcPrice = 0;
    this.$fittingPrice = 0;
    this.$specialLogo = 0;
    this.$engraveName = 0;
    this.$lensePriceLeft = 0;
    this.$lensePriceRight = 0;
    this.$rightFittingPrice = 0;
    this.$additionalPrice = 0;
    this.$discountPrice = 0;
    this.$selectedOtherServicePrice = 0;
     this.$coatingPriceRight = 0;
    this.$mirrorPriceRight = 0;
    this.$tintPriceRight = 0;
    this.$coatingPriceLeft = 0;
    this.$mirrorPriceLeft = 0;
    this.$tintPriceLeft = 0;
    
    // temp
    this.$tempCoatingPrice = 0;
    this.$tempTintPrice = 0;
    this.$tempLeftPrismPrice = 0;
    this.$tempRightPrismPrice = 0;
    this.$tempFittingPrice = 0;
    this.$tempLeftCtPrice = 0;
    this.$tempRightCtPrice = 0;
    this.$tempRightEtPrice = 0;
    this.$tempLeftEtPrice = 0;
    this.$tempMirrorPrice = 0;
    this.$tempLeftBaseCurvePrice = 0;
    this.$tempRightBaseCurvePrice = 0;
    this.$tempRightDecPrice = 0;
    this.$tempLeftDecPrice = 0;
    this.$tempTailorMadePrice = 0;
    this.$tempEngraveName = 0;
    this.$tempSpecialLogo = 0;
    this.$tempHcPrice = 0;
    this.$tempLeftOval = 0;
    this.$tempRightOval = 0;
    this.$tempRightFittingPrice = 0;
    this.$tempSelectedOtherServicePrice = 0;
    this.$tempCoatingPriceRight = 0;
    this.$tempMirrorPriceRight = 0;
    this.$tempTintPriceRight = 0;
    this.$tempCoatingPriceLeft = 0;
    this.$tempMirrorPriceLeft = 0;
    this.$tempTintPriceLeft = 0;
  }
  

  /**
   * @name selectionChangedHandler
   */
  selectionChangedHandler(event: any) {
    if (event.currentSelectedRowKeys.length > 0) {
      this.comboPriceSelectedData = event;
    }
    if (event.currentDeselectedRowKeys.length > 0) {
      this.comboPriceSelectedData = event;
    }
  }

  /**
   *@name getMirrorPrice
   * @param {number} mirrorId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getMirrorPrice(mirrorId: number, customerId: number) {
    this.$mirrorPrice = 0;
    this.$tempMirrorPrice = 0;
    if (!this.comboMirrorPrice) {
      if (mirrorId) {
        this._salesService
          .getMirrorPrice(mirrorId, customerId)
          .then((response) => {
            if (response.data.completed && response.data.payload) {
              if (
                this.bothSidesForm.get("qtyLeft").value &&
                this.selectedTemplate == "left"
              ) {
                this.$mirrorPrice = response.data.payload.price
                  ? response.data.payload.price : 0;
              } else if (
                this.bothSidesForm.get("qtyRight").value &&
                this.selectedTemplate == "right"
              ) {
                this.$mirrorPrice = response.data.payload.price
                  ? response.data.payload.price : 0;
              } else {
                 this.$mirrorPrice = response.data.payload.price
                ? response.data.payload.price : 0;
              }
              this.$tempMirrorPrice = response.data.payload.price;
              // this.$mirrorPrice =
              //   response.data.payload.price && this.selectedTemplate == "both"
              //     ? response.data.payload.price * 2
              //     : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Mirror Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            } else {
              console.log("response.data", response.data.payload);
            }
          })
          .catch((err) => {
            console.error("Error:  ", err);
          });
      } else {
        this.$mirrorPrice = 0;
        this.$tempMirrorPrice = 0;
      }
    }
  }



  /**
   * @name getFormValidationErrors
   * @param {FormGroup} form
   * @return required validation
   */

  getFormValidationErrors(form: FormGroup) {
    const result = [];
    Object.keys(form.controls).forEach((key) => {
      //.replace(/([a-z0-9])([A-Z])/g, '$1 $2')
      const controlErrors: ValidationErrors = form.get(key).errors;
      if (controlErrors) {
        Object.keys(controlErrors).forEach((keyError) => {
          result.push({
            control: key.replace(/([a-z0-9])([A-Z])/g, "$1 $2"),
            error: keyError,
            value: controlErrors[keyError],
          });
        });
      }
    });
    return result;
  }

  /**
   * @name toggle
   * @description toggle section for user press  button
   */
  toggle(label: string): void {
    const smoothScrollConfig = {
      block: "start",
      inline: "nearest",
      behavior: "smooth",
    };
    let el: any;
    setTimeout(() => {
      switch (label) {
        case "rxInformation":
          el = this.rxInformation.nativeElement;
          break;
        case "frame":
          if (this.toggleFrame) {
            el = this.frame.nativeElement;
          }
          break;
      }
      el.scrollIntoView();
    }, 100);
  }

  /*
   * NAME : setBranchValue
   * PURPOSE : Autogenerates function contract comments
   *  PARAMS : companyBranchId: number -
   * RETURNS :  -
   *   NOTES : set selected companyBrannch
   */
  setBranchValue(companyBranchId: number) {
    this.bothSidesForm.get("coatingLocation").setValue(companyBranchId);
    this.bothSidesForm.get("hcLocation").setValue(companyBranchId);
    this.bothSidesForm.get("tintLocation").setValue(companyBranchId);
    if (JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyBranchId == 13) {
      this.bothSidesForm.get("fittingLocationId").setValue(JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyBranchId);
    } else {
      this.bothSidesForm.get("fittingLocationId").setValue(companyBranchId);
    }
    
  }

  // FILTERS
  /**
   * @name getAllMaterials
   * @returns Promise
   * @description fetch all item
   */
  getAllMaterials() {
    this.loadingMaterials = true;
    this._salesService
      .getAllMaterials()
      .then((response) => {
        if (response.data.completed) {
          this.allMaterials = response.data.payload;
          this.loadingMaterials = false;
        }
      })
      .catch((err) => {
        this.loadingMaterials = false;
        console.error("Error:  ", err);
      });
  }
   /**
   * @name getAllEngraves
   * @returns Promise
   * @description fetch all item
   */
  getAllEngraves() {
    this.loadingIndicator = true;
    this._salesService
      .getAllEngraves()
      .then((response) => {
        if (response.data.completed) {
          this.engravesList = response.data.payload;
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllMaterialsByCategory
   * @returns Promise
   * @description fetch all item
   */
  getAllMaterialsByCategory(itemCategoryId: number) {
    this.loadingMaterials = true;
    this._salesService
      .getAllMaterialsByCategory(itemCategoryId)
      .then((response) => {
        if (response.data.completed) {
          this.allMaterialsForFitting = response.data.payload;
          this.loadingMaterials = false;
        }
      })
      .catch((err) => {
        this.loadingMaterials = false;
        console.error("Error:  ", err);
      });
  }

  getViewItemCatalog() {
    this.filterAllItemCatalogs(this.type);
  }

  /**
   * @name getAllIndexByMaterialId
   * @returns Promise
   * @description fetch all item
   */
  getAllIndexByMaterialId(materialId: number) {
    if (materialId) {
      this.leftIndexList = [];
      this.loadingLeftIndex = true;
      this._salesService
        .getAllIndexByMaterialId(materialId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              // const list = [];
              // response.data.payload.forEach((element) => {
              //   if (element.active) {
              //     list.push(element);
              //   }
              // });
              this.leftIndexList = response.data.payload;
            } else {
              if (response.data.payload.active) {
                this.leftIndexList = response.data.payload;
              }
            }
            this.loadingLeftIndex = false;
            if (!this.salesOrderId) {
              this.filterAllItemCatalogs(this.type);
            }
          }
        })
        .catch((error) => {
          this.loadingLeftIndex = false;
          const option = {
            width: 300,
            displayTime: 5000,
            message: error.message,
            type: "error",
          };
          console.log(error);
          notify(option);
        });
    } else {
      this.leftIndexList = [];
    }
  }
 

  /**
   * @name validateAxisRight
   * @return void
   * @description CYL Axis is mandatory when CYL is selected for BF and MF
   */
  get validateAxisRight() {
    if (this.selectedItemCatalogObject) {
      const cylRightValue = parseFloat(
        this.bothSidesForm.get("cylRight").value
      );
      // && (this.selectedItemCatalogObject.focalId == 2 || this.selectedItemCatalogObject.focalId == 3)
      if (cylRightValue && cylRightValue !== 0) {
        this.bothSidesForm
          .get("axisRight")
          .setValidators([
            rangeValidator(1, 180, "p"),
            stepValidator(1),
            Validators.required,
          ]);

        this.bothSidesForm.get("axisRight").updateValueAndValidity();
        return true;
      } else {
        this.bothSidesForm
          .get("axisRight")
          .setValidators([rangeValidator(1, 180, "p"), stepValidator(1)]);
        this.bothSidesForm.get("axisRight").updateValueAndValidity();
        return false;
      }
    }
  }
  /**
   * @name validateAxisLeft
   * @return void
   * @description CYL Axis is mandatory when CYL is selected for BF and MF
   */
  get validateAxisLeft() {
    if (this.selectedItemCatalogObject) {
      const cylLeftValue = parseFloat(this.bothSidesForm.get("cylLeft").value);
      // && (this.selectedItemCatalogObject.focalId == 2 || this.selectedItemCatalogObject.focalId == 3)
      if (cylLeftValue && cylLeftValue !== 0) {
        this.bothSidesForm
          .get("axisLeft")
          .setValidators([
            rangeValidator(1, 180, "p"),
            stepValidator(1),
            Validators.required,
          ]);
        this.bothSidesForm.get("axisLeft").updateValueAndValidity();
        return true;
      } else {
        this.bothSidesForm
          .get("axisLeft")
          .setValidators([rangeValidator(1, 180, "p"), stepValidator(1)]);
        this.bothSidesForm.get("axisLeft").updateValueAndValidity();
        return false;
      }
    }
  }
 /**
   * @name filtersByItemCatalog
   * @return item catalog object
   */
  filtersByItemCatalog(itemId: any) {
    if (itemId) {
      this.loadingIndicator = true;
      const itemInterval = setInterval(() => {
        if (this.itemCatalogList.length > 0) {
          this.selectedItemCatalogObject = this.itemCatalogList.find(item => item.itemCatalogGroupId == itemId);
          this.otherServicesList = [];
          this.focalId = this.selectedItemCatalogObject.focalId;
          if (this.selectedItemCatalogObject) {
            if (this.type == 'add') {
              this.getEdgingPrice(
                this.selectedItemCatalogObject.brandMasterId,
                this.bothSidesForm.get("customerBranchId").value,
                this.selectedItemCatalogObject.indexId,
                this.selectedItemCatalogObject.materialId,
                this.bothSidesForm.get('frameType').value,
                this.bothSidesForm.get('isOurLens').value
              );
            }
            if (!this.isComboPrice && this.selectedItemCatalogObject.coatingBrandId > 0) { 
              this.isDefaultCoating = true;
              if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
                this.bothSidesForm.get('coat').setValue(this.selectedItemCatalogObject.coatingBrandId);
              }
            } else {
              this.isDefaultCoating = false;
              if (this.type == 'add') {
                this.bothSidesForm.get('coat').setValue('');
              }
            }

            this.getMirrorList(this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId);
            if (this.selectedTemplate == 'both' || this.selectedTemplate == 'left') {
                this.getLeftCYL(this.selectedItemCatalogObject.cylMinExt, this.selectedItemCatalogObject.cylMaxExt);
              // this.getLeftCylRange(this.bothSidesForm.get('sphLeft').value);
            }
            if (this.selectedTemplate == 'both' || this.selectedTemplate == 'right') {
              this.getRightCYL(this.selectedItemCatalogObject.cylMinExt, this.selectedItemCatalogObject.cylMaxExt);
              // this.getRightCylRange(this.bothSidesForm.get('sphRight').value);
            }
            if (this.type == 'add' && this.selectedItemCatalogObject.itemTypeMasterId == 1) {
              if (this.selectedTemplate == 'both' || this.selectedTemplate == 'left') {
                if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
                  this.bothSidesForm.get("qtyLeft").setValue(1);
                }
                this.getRxPrice(this.selectedItemCatalogObject.itemCatalogGroupId, 
                  this.bothSidesForm.get('sphLeft').value, 
                  this.bothSidesForm.get('cylLeft').value, 
                  this.bothSidesForm.get('addfLeft').value, 'left', this.selectedItemCatalogObject.priceGroupMasterId,
                  this.bothSidesForm.get('diameterLeft').value, this.bothSidesForm.get('coat').value, this.bothSidesForm.get('mirror').value, this.bothSidesForm.get('tintType').value);
              }
              if (this.selectedTemplate == 'both' || this.selectedTemplate == 'right') {
                if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
                  this.bothSidesForm.get("qtyRight").setValue(1);
                }
                
                this.getRxPrice(this.selectedItemCatalogObject.itemCatalogGroupId, 
                  this.bothSidesForm.get('sphRight').value, 
                  this.bothSidesForm.get('cylRight').value, 
                  this.bothSidesForm.get('addfRight').value, 'right', this.selectedItemCatalogObject.priceGroupMasterId,
                  this.bothSidesForm.get('diameterRight').value, this.bothSidesForm.get('coat').value, this.bothSidesForm.get('mirror').value, this.bothSidesForm.get('tintType').value);
              }
            }
           
                
            if (this.selectedItemCatalogObject && this.selectedItemCatalogObject.diameter > 0) {
              if (this.type == 'add') {
                if (this.selectedTemplate == "right" || this.selectedTemplate == "both") {
                  this.bothSidesForm.get("diameterRight").setValue(this.selectedItemCatalogObject.diameter);
                  this.bothSidesForm.get("diameterRight").disable();
                }
                if (this.selectedTemplate == "left" || this.selectedTemplate == "both") {
                  this.bothSidesForm.get("diameterLeft").setValue(this.selectedItemCatalogObject.diameter);
                  this.bothSidesForm.get("diameterLeft").disable();
                }
              }
             
            } else {
              if (this.type == 'add') {
                if (this.selectedTemplate == "right" || this.selectedTemplate == "both") {
                  this.bothSidesForm.get("diameterRight").setValue('');
                  this.bothSidesForm.get("diameterRight").enable();
                }
                if (this.selectedTemplate == "left" || this.selectedTemplate == "both") {
                  this.bothSidesForm.get("diameterLeft").setValue('');
                  this.bothSidesForm.get("diameterLeft").enable();
                }
              }
            }
            // ADDF ACTIVE CONDITION
            if (this.focalId == 2 || this.focalId == 3) {
              if (this.selectedTemplate == "right" || this.selectedTemplate == "both") {
                this.bothSidesForm.get("addfRight").enable();
                this.bothSidesForm.get("addfRight").setValidators([Validators.required]);
                if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
                  this.bothSidesForm.get("qtyRight").setValue(1);
                }
              }
              if (this.selectedTemplate == "left" || this.selectedTemplate == "both") {
                this.bothSidesForm.get("addfLeft").enable();
                this.bothSidesForm.get("addfLeft").setValidators([Validators.required]);
                if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
                   this.bothSidesForm.get("qtyLeft").setValue(1);
                }
              }
              
            } else {
              this.bothSidesForm.get("addfRight").clearValidators();
              this.bothSidesForm.get("addfLeft").clearValidators();
              this.bothSidesForm.get("addfRight").disable();
              this.bothSidesForm.get("addfLeft").disable();
              this.bothSidesForm.get("addfRight").setValue(null);
              this.bothSidesForm.get("addfLeft").setValue(null);
            }
            
            this.bothSidesForm.get("addfRight").updateValueAndValidity();
            this.bothSidesForm.get("addfLeft").updateValueAndValidity();
            // this.getFrameForSalesOrder(
            //   this.selectedItemCatalogObject.itemCatalogGroupId
            // );
            if (this.salesOrderId || this.bothSidesForm.get("salesId").value) {
              // this.getCatalogComboList(
              //   this.bothSidesForm.get("itemCatalogGroupId").value,
              //   JSON.parse(localStorage.getItem("selectedCustomerBranch"))
              //     .companyId,
              //   this.customerId,
              //   this.selectedItemCatalogObject.priceGroupMasterId
              // );
            }
            if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value && this.type == "add") {
              // CLEAR COMBO PRICE
              // this.clearCombo();
              // this.getCatalogComboList(
              //   this.bothSidesForm.get("itemCatalogGroupId").value,
              //   JSON.parse(localStorage.getItem("selectedCustomerBranch"))
              //     .companyId,
              //   this.customerId,
              //   this.selectedItemCatalogObject.priceGroupMasterId
              // );
            }
            this.getOtherService(
              this.customerId,
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId,
              this.selectedItemCatalogObject.focalId
            );
            this.getAllOtherServiesByFilter(
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId,
              this.selectedItemCatalogObject.focalId
            );
      
            // TINT DROPDOWN
            this.getTintTypeyFilterBrandIdIndexId(
              this.selectedItemCatalogObject.filterBrandId,
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId,
              this.selectedItemCatalogObject.indexId
            );
                // END
            this.getAllSOAttributes(
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.subBrandMasterId
            );
            this.getTintColor(
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId
            );
            this.getCoatingBrandByBrandMasterIdAndMaterialId(
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId,
              false
            );
            this.getHcBrandByBrandMasterIdAndMaterialId(
              this.selectedItemCatalogObject.brandMasterId,
              this.selectedItemCatalogObject.materialId
            );

            this.getSPH(this.selectedItemCatalogObject.extTpMin, this.selectedItemCatalogObject.extTpMax);
            this.getADDF(this.selectedItemCatalogObject.addMinExt, this.selectedItemCatalogObject.addMaxExt);

            
             this.type = "add";
            clearInterval(itemInterval);
            this.loadingIndicator = false;
          }
        }
      }, 1000);
    } else {
      if (!this.salesOrderId || !this.bothSidesForm.get("salesId").value) {
        this.isComboPrice = false;
      }
      this.loadingIndicator = false;
    }
  }


  /**
   * @name getCustomerChange
   * @erturn void
   */
  getCustomerChange() {
    this.getCatalogComboList(
      this.bothSidesForm.get("itemCatalogGroupId").value,
      JSON.parse(localStorage.getItem("selectedCustomerBranch"))
        .companyId,
      this.customerId,
      this.selectedItemCatalogObject.priceGroupMasterId
    );
  }
  /**
   * @name defaultCoatingRoule
   * @return boolean
   * @description if item group coating > 0 then coating is required other wise null
   */
get defaultCoatingRoule() {
  if (!this.isCoatingNotRequired && this.selectedItemCatalogObject && this.selectedItemCatalogObject.coatingBrandId && this.selectedItemCatalogObject.coatingBrandId > 0) {
    this.bothSidesForm.get('coat').setValidators([Validators.required]);
    this.bothSidesForm.get('coat').updateValueAndValidity();
    return true;
  } else {
    this.bothSidesForm.get('coat').clearValidators();
    this.bothSidesForm.get('coat').updateValueAndValidity();
    return false;
  }
}
/**
 * @name coatingPriceRole
 * @return boolean
 * @description if have value and value not equal to default coating and coating price is 0 then coating price is required
 */
// get coatingPriceRole() {
//     if (this.selectedItemCatalogObject && this.bothSidesForm.get('coat').value && !this.isComboPrice && (this.bothSidesForm.get('coat').value !== this.selectedItemCatalogObject.coatingBrandId) && this.$coatingPrice == 0) {
//       this.bothSidesForm.get('coat').setErrors({price: true});
//       return true;
//     } else {
//       this.bothSidesForm.get('coat').setErrors(null);
//       if (this.selectedItemCatalogObject && this.selectedItemCatalogObject.coatingBrandId && this.selectedItemCatalogObject.coatingBrandId > 0) {
//         this.bothSidesForm.get('coat').setValidators([Validators.required]);
//         this.bothSidesForm.get('coat').updateValueAndValidity();
//       }
//       return false;
//     }
// }

/**
 * @name lensRightPriceRole
 * @return boolean
 * @description set lens Pirce right validaiton
 */
get lensRightPriceRole() {
  if (this.selectedTemplate == 'both' || this.selectedTemplate == 'right') {
    if (this.bothSidesForm.get('isOurLens').value) {
      this.$lensePriceRight = 0;
      this.bothSidesForm.get('rightLensePrice').clearValidators();
      this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
      return false;
    }
    const itemCatalogGroupId = this.bothSidesForm.get('itemCatalogGroupId').value;
    const sph = this.bothSidesForm.get('sphRight').value;
    const cyl = this.bothSidesForm.get('cylRight').value;
    const addf = this.bothSidesForm.get('addfRight').value;
   
    if (
      (itemCatalogGroupId && !this.isComboPrice && !this.bothSidesForm.get('isOurLens').value && ((sph || sph == 0) && (cyl && cyl !== null || cyl == 0)) ||
      (addf && addf !== null || addf == 0))
    ) {
      if (this.$lensePriceRight == 0) {
        this.bothSidesForm.get('rightLensePrice').setValidators([Validators.required]);
        // this.bothSidesForm.addControl('rightLensePrice', new FormControl('', [Validators.required]));
        this.$lensePriceRight = 0;
        this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
        return true;
      } else {
        this.bothSidesForm.get('rightLensePrice').clearValidators();
        // this.bothSidesForm.removeControl('rightLensePrice');
        this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
        return false;
      }
    } else if (this.isComboPrice) {
      this.bothSidesForm.get('rightLensePrice').clearValidators();
      this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
      return false;
    } else {
      this.bothSidesForm.get('rightLensePrice').setValidators([Validators.required]);
      // this.bothSidesForm.addControl('rightLensePrice', new FormControl('', [Validators.required]));
      this.$lensePriceRight = 0;
      this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
      return true;
    }   
  } else {
        this.$lensePriceRight = 0;
        this.bothSidesForm.get('rightLensePrice').clearValidators();
        this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
        return false;
  } 
}
/**
 * @name lensLeftPriceRole
 * @return boolean
 * @description set lens Pirce right validaiton
 */
 get lensLeftPriceRole() {
   if (this.selectedTemplate == 'both' || this.selectedTemplate == 'left') {
     if (this.bothSidesForm.get('isOurLens').value) {
      this.$lensePriceLeft = 0;
      this.bothSidesForm.get('leftLensePrice').clearValidators();
      this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
      return false;
    }
    const itemCatalogGroupId = this.bothSidesForm.get('itemCatalogGroupId').value;
    const sph = this.bothSidesForm.get('sphLeft').value;
    const cyl = this.bothSidesForm.get('cylLeft').value;
    const addf = this.bothSidesForm.get('addfLeft').value;
  
    if (
      (itemCatalogGroupId && !this.isComboPrice && !this.bothSidesForm.get('isOurLens').value && ((sph || sph == 0) && (cyl && cyl !== null || cyl == 0)) ||
      (addf && addf !== null || addf == 0))
    ) {
      if (this.$lensePriceLeft == 0) {
        // this.bothSidesForm.addControl('leftLensePrice', new FormControl('', [Validators.required]));
        this.bothSidesForm.get('leftLensePrice').setValidators([Validators.required]);
        this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
        this.$lensePriceLeft = 0;
        return true;
      } else {
        // this.bothSidesForm.removeControl('leftLensePrice');
        this.bothSidesForm.get('leftLensePrice').clearValidators();
        this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
        return false;
      }
    } else if (this.isComboPrice) {
      this.bothSidesForm.get('leftLensePrice').clearValidators();
      this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
      return false;
    } else {
      this.bothSidesForm.get('leftLensePrice').setValidators([Validators.required]);
      this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
      // this.bothSidesForm.addControl('leftLensePrice', new FormControl('', [Validators.required]));
        this.$lensePriceLeft = 0;
        return true;
    }
   } else {
      this.$lensePriceLeft = 0;
      this.bothSidesForm.get('leftLensePrice').clearValidators();
      this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
      return false;
  }
}

/**
 * @name hsPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
get hsPriceRole() {
  if (this.bothSidesForm.get('hc').value && this.$hcPrice == 0) {
       this.bothSidesForm.get('hc').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('hc').setErrors(null);
    return false;
  }
}

/**
 * @name baseCurveRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get baseCurveRightPriceRole() {
  if (this.bothSidesForm.get('baseCurveRight').value && this.$rightBaseCurvePrice == 0) {
       this.bothSidesForm.get('baseCurveRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('baseCurveRight').setErrors(null);
    this.bothSidesForm.get('baseCurveRight').setValidators([rangeValidator(0.5, 10, "p"), stepValidator(0.5)]);
    this.bothSidesForm.get('baseCurveRight').updateValueAndValidity();
    return false;
  }
}

/**
 * @name baseCurveLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get baseCurveLeftPriceRole() {
  if (this.bothSidesForm.get('baseCurveLeft').value && this.$leftBaseCurvePrice == 0) {
       this.bothSidesForm.get('baseCurveLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('baseCurveLeft').setErrors(null);
    this.bothSidesForm.get('baseCurveLeft').setValidators([rangeValidator(0.5, 10, "p"), stepValidator(0.5)]);
    this.bothSidesForm.get('baseCurveLeft').updateValueAndValidity();
    return false;
  }
}
/**
 * @name etRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get etRightPriceRole() {
  if (this.bothSidesForm.get('etRight').value && this.$rightEtPrice == 0) {
       this.bothSidesForm.get('etRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('etRight').setErrors(null);
    this.bothSidesForm.get('etRight').setValidators([rangeValidator(0.3, 5, "p")]);
    this.bothSidesForm.get('etRight').updateValueAndValidity();
    return false;
  }
}
/**
 * @name etLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get etLeftPriceRole() {
  if (this.bothSidesForm.get('etLeft').value && this.$leftEtPrice == 0) {
       this.bothSidesForm.get('etLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('etLeft').setErrors(null);
    this.bothSidesForm.get('etLeft').setValidators([rangeValidator(0.3, 5, "p")]);
    this.bothSidesForm.get('etLeft').updateValueAndValidity();
    return false;
  }
}
/**
 * @name ctLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get ctLeftPriceRole() {
  if (this.bothSidesForm.get('ctLeft').value && this.$leftCtPrice == 0) {
       this.bothSidesForm.get('ctLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('ctLeft').setErrors(null);
    this.bothSidesForm.get('ctLeft').setValidators([rangeValidator(1.0, 10, "p")]);
    this.bothSidesForm.get('ctLeft').updateValueAndValidity();
    return false;
  }
}
/**
 * @name ctRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get ctRightPriceRole() {
  if (this.bothSidesForm.get('ctRight').value && this.$rightCtPrice == 0) {
       this.bothSidesForm.get('ctRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('ctRight').setErrors(null);
    this.bothSidesForm.get('ctRight').setValidators([rangeValidator(1.0, 10, "p")]);
    this.bothSidesForm.get('ctRight').updateValueAndValidity();
    return false;
  }
}

/**
 * @name decentrationInLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get decentrationInLeftPriceRole() {
  if (this.bothSidesForm.get('decinLeft').value && this.$leftDecPrice == 0) {
       this.bothSidesForm.get('decinLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('decinLeft').setErrors(null);
    this.bothSidesForm.get('decinLeft').setValidators([rangeValidator(1, 10, "p"),
    stepValidator(1)]);
    this.bothSidesForm.get('decinLeft').updateValueAndValidity();
    return false;
  }
}
/**
 * @name decentrationInRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get decentrationInRightPriceRole() {
  if (this.bothSidesForm.get('decinRight').value && this.$rightDecPrice == 0) {
       this.bothSidesForm.get('decinRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('decinRight').setErrors(null);
    this.bothSidesForm.get('decinRight').setValidators([rangeValidator(1, 10, "p"),
    stepValidator(1),]);
    this.bothSidesForm.get('decinRight').updateValueAndValidity();
    return false;
  }
}

/**
 * @name decentrationOutLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get decentrationOutLeftPriceRole() {
  if (this.bothSidesForm.get('decoutLeft').value && this.$leftDecPrice == 0) {
       this.bothSidesForm.get('decoutLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('decoutLeft').setErrors(null);
    this.bothSidesForm.get('decoutLeft').setValidators([rangeValidator(1, 10, "p"),
    stepValidator(1)]);
    this.bothSidesForm.get('decoutLeft').updateValueAndValidity();
    return false;
  }
}

/**
 * @name decentrationOutRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get decentrationOutRightPriceRole() {
  if (this.bothSidesForm.get('decoutRight').value && this.$rightDecPrice == 0) {
       this.bothSidesForm.get('decoutRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('decoutRight').setErrors(null);
    this.bothSidesForm.get('decoutRight').setValidators([rangeValidator(1, 10, "p"),
    stepValidator(1)]);
    this.bothSidesForm.get('decoutRight').updateValueAndValidity();
    return false;
  }
}


/**
 * @name prismInRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismInRightPriceRole() {
  if (this.bothSidesForm.get('prismInRight').value && this.$rightPrismPrice == 0) {
       this.bothSidesForm.get('prismInRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismInRight').setErrors(null);
    this.bothSidesForm.get('prismInRight').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismInRight').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismOutRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismOutRightPriceRole() {
  if (this.bothSidesForm.get('prismOutRight').value && this.$rightPrismPrice == 0) {
       this.bothSidesForm.get('prismOutRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismOutRight').setErrors(null);
    this.bothSidesForm.get('prismOutRight').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismOutRight').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismUpRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismUpRightPriceRole() {
  if (this.bothSidesForm.get('prismUpRight').value && this.$rightPrismPrice == 0) {
       this.bothSidesForm.get('prismUpRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismUpRight').setErrors(null);
    this.bothSidesForm.get('prismUpRight').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismUpRight').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismDownRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismDownRightPriceRole() {
  if (this.bothSidesForm.get('prismDownRight').value && this.$rightPrismPrice == 0) {
       this.bothSidesForm.get('prismDownRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismDownRight').setErrors(null);
    this.bothSidesForm.get('prismDownRight').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismDownRight').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismValueRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismValueRightPriceRole() {
  if (this.bothSidesForm.get('prismValueRight').value && this.$rightPrismPrice == 0) {
       this.bothSidesForm.get('prismValueRight').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismValueRight').setErrors(null);
    this.bothSidesForm.get('prismValueRight').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismValueRight').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismAxisRightPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
//  get prismAxisRightPriceRole() {
//   if (this.bothSidesForm.get('prismAxisRight').value && this.$rightPrismPrice == 0) {
//        this.bothSidesForm.get('prismAxisRight').setErrors({price: true});
//     return true;
//   } else {
//     this.bothSidesForm.get('prismAxisRight').setErrors(null);
//     this.bothSidesForm.get('prismAxisRight').setValidators([rangeValidator(0, 360, "p"), stepValidator(1)]);
//     this.bothSidesForm.get('prismAxisRight').updateValueAndValidity();
//     return false;
//   }
// }

/**
 * @name prismInLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismInLeftPriceRole() {
  if (this.bothSidesForm.get('prismInLeft').value && this.$leftPrismPrice == 0) {
       this.bothSidesForm.get('prismInLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismInLeft').setErrors(null);
    this.bothSidesForm.get('prismInLeft').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismInLeft').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismOutLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismOutLeftPriceRole() {
  if (this.bothSidesForm.get('prismOutLeft').value && this.$leftPrismPrice == 0) {
       this.bothSidesForm.get('prismOutLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismOutLeft').setErrors(null);
    this.bothSidesForm.get('prismOutLeft').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismOutLeft').updateValueAndValidity();
    return false;
  }
}
/**
 * @name prismUpLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismUpLeftPriceRole() {
  if (this.bothSidesForm.get('prismUpLeft').value && this.$leftPrismPrice == 0) {
       this.bothSidesForm.get('prismUpLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismUpLeft').setErrors(null);
    this.bothSidesForm.get('prismUpLeft').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismUpLeft').updateValueAndValidity();
    return false;
  }
}

/**
 * @name prismDownLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismDownLeftPriceRole() {
  if (this.bothSidesForm.get('prismDownLeft').value && this.$leftPrismPrice == 0) {
       this.bothSidesForm.get('prismDownLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismDownLeft').setErrors(null);
    this.bothSidesForm.get('prismDownLeft').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismDownLeft').updateValueAndValidity();
    return false;
  }
}


/**
 * @name prismValueLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get prismValueLeftPriceRole() {
  if (this.bothSidesForm.get('prismValueLeft').value && this.$leftPrismPrice == 0) {
       this.bothSidesForm.get('prismValueLeft').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('prismValueLeft').setErrors(null);
    this.bothSidesForm.get('prismValueLeft').setValidators([rangeValidator(0.5, 16, "p"), stepValidator(0.25)]);
    this.bothSidesForm.get('prismValueLeft').updateValueAndValidity();
    return false;
  }
}

/**
 * @name prismAxisLeftPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
//  get prismAxisLeftPriceRole() {
//   if (this.bothSidesForm.get('prismAxisLeft').value && this.$leftPrismPrice == 0) {
//        this.bothSidesForm.get('prismAxisLeft').setErrors({price: true});
//     return true;
//   } else {
//     this.bothSidesForm.get('prismAxisLeft').setErrors(null);
//     this.bothSidesForm.get('prismAxisLeft').setValidators([rangeValidator(0, 360, "p"), stepValidator(1)]);
//     this.bothSidesForm.get('prismAxisLeft').updateValueAndValidity();
//     return false;
//   }
// }


/**
 * @name fittingTypePriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get fittingTypePriceRole() {
  if (!this.comboFittingPrice && this.isFitting && this.bothSidesForm.get('frameType').value && this.$fittingPrice == 0) {
       this.bothSidesForm.get('frameType').setErrors({price: true});
       this.bothSidesForm.get('frameType').setValidators([Validators.required]);
       this.bothSidesForm.get('frameType').updateValueAndValidity();
    return true;
  } else {
    this.bothSidesForm.get('frameType').setErrors(null);
    if (this.isFitting || this.isTailorMade) {
      this.bothSidesForm.get('frameType').setValidators([Validators.required]);
      this.bothSidesForm.get('frameType').updateValueAndValidity();
    } 
    return false;
  }
}

/**
 * @name tailorMadePriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
 get tailorMadePriceRole() {
  if (this.isTailorMade && this.$tailorMadePrice == 0) {
       this.bothSidesForm.get('tailorMade').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('tailorMade').setErrors(null);
    return false;
  }
}
/**
 * @name mirrorPriceRole
 * @return boolean
 * @description if use select hc server then price is required
 */
// get mirrorPriceRole () {
//   if (this.bothSidesForm.get('mirror').value && !this.isComboPrice && this.$mirrorPrice == 0) {
//     this.bothSidesForm.get('mirror').setErrors({price: true});
//       return true;
//   } else {
//     this.bothSidesForm.get('mirror').setErrors(null);
//     return false;
//     }
// }
/**
 * @name coatingPriceRole
 * @return boolean
 * @description if have value and value not equal to default coating and coating price is 0 then coating price is required
 */
//  get tintPriceRole() {
//   if (this.bothSidesForm.get('tintType').value && !this.isComboPrice && this.$tintPrice == 0) {
//     this.bothSidesForm.get('tintType').setErrors({price: true});
//     return true;
//   } else {
//     this.bothSidesForm.get('tintType').setErrors(null);
//     // if (!this.isComboPrice && this.bothSidesForm.get('mirror').value) {
//     //      this.bothSidesForm.get('tintType').setValidators([Validators.required]);
//     // } else {
//     //   this.bothSidesForm.get('tintType').clearValidators();
//     // }
//     // this.bothSidesForm.get('tintType').updateValueAndValidity();
//     return false;
//   }
// }

 /**
   * @name  getTintProcessRole
   * @return void
   * @description Adding/ Removing HC	Blank issuance/QC/Tinting/HC/MC&Mirror
   */
  get getTintProcessRole() {
    if (!this.isAdmin && !this.isSupervisor &&   
      this.salesOrderId &&
      this.salesOrderData &&
      this.salesOrderData.departmentId !==2 &&
      this.salesOrderData.holdProcess &&
      this.salesOrderData.processId > 0
    ) {
      return true;
    } else {
      return false;
    }
  }
  
  tintValidation(mirrorId: number) {
    if (mirrorId) {
      this.bothSidesForm.get('tintType').setValidators([Validators.required]);
    } else {
      this.bothSidesForm.get('tintType').clearValidators();
    }
    this.bothSidesForm.get('tintType').updateValueAndValidity();
  }
/**
 * @name otherServicePriceRole
 * @return boolean
 * @description if have value and value not equal to default coating and coating price is 0 then coating price is required
 */
 get otherServicePriceRole() {
  if (this.bothSidesForm.get('otherServices').value && this.$selectedOtherServicePrice == 0) {
    this.bothSidesForm.get('otherServices').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('otherServices').setErrors(null);
    return false;
  }
}

/**
 * @name engravingPriceRole
 * @return boolean
 * @description if have value and value not equal to default coating and coating price is 0 then coating price is required
 */
 get engravingPriceRole() {
  if (this.bothSidesForm.get('nameCode').value && this.$engraveName == 0) {
    this.bothSidesForm.get('nameCode').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('nameCode').setErrors(null);
    return false;
  }
}

/**
 * @name logoPriceRole
 * @return boolean
 * @description if have value and value not equal to default coating and coating price is 0 then coating price is required
 */
 get logoPriceRole() {
  if (this.bothSidesForm.get('engraveId').value && this.$specialLogo == 0) {
    this.bothSidesForm.get('engraveId').setErrors({price: true});
    return true;
  } else {
    this.bothSidesForm.get('engraveId').setErrors(null);
    return false;
  }
}

/**
 * @name mirrorDisabledRole
 * @return boolean
 * @discription if FilterId=1 then disable Mirror selection
 */
get mirrorDisabledRole() {
  if (!this.isComboPrice && this.selectedItemCatalogObject && this.selectedItemCatalogObject.filterId == 1) {
      this.bothSidesForm.get('mirror').setValue(null);
      this.bothSidesForm.get('mirror').disable();
      this.$mirrorPrice = 0;
      this.$tempMirrorPrice = 0;
      return true;
  } else {
    this.bothSidesForm.get('mirror').enable();
    return false;
  }
}




    /**
   *@name getCatalogComboList
   * @param {number} itemCatalogGroupId
   * @param {number} companyId
   * @param {number} customerId
   * @memberof JobFormComponent
   */
   getCatalogComboList(
    itemCatalogGroupId: number,
    companyId: number,
    customerId: number,
    priceGroupMasterId: number
  ) {
    if (itemCatalogGroupId && companyId && customerId && priceGroupMasterId) {
      this.comboPriceList = [];
      this._salesService
        .getCatalogComboList(itemCatalogGroupId, companyId, customerId, priceGroupMasterId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              this.comboPriceList = response.data.payload;
            } else {
              this.isComboPrice = false;
              this.comboCoatingPrice = false;
              this.comboTintPrice = false;
              this.comboMirrorPrice = false;
              this.comboFittingPrice = false;
            }
          } else {
            console.error("Line: 1565 ", response.data.payload);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    }
  }


  showComboPricePopup() {
    this.comboPricePopup = true;
  }

  /**
 * @name clearCombo
 * @returns void
 * @description Clear Combo
 */
  clearCombo(label?: string) {
    this.bothSidesForm.get("coat").setValue(null);
    this.bothSidesForm.get("coat").enable();
    this.bothSidesForm.get("tintType").setValue(null);
    this.bothSidesForm.get("tintType").enable();
    this.bothSidesForm.get("mirror").setValue(null);
    this.bothSidesForm.get("mirror").enable();
    this.bothSidesForm.get("fittingTypeId").setValue(null);
    this.bothSidesForm.get("fittingTypeId").enable();
    if (label == 'clearItemGroup') {
      this.bothSidesForm.get("itemCatalogGroupId").setValue(null);
      this.rxProcessRole = false;
    }
    this.$lensePrice = 0;
    this.$lensePriceRight = 0;
    this.$lensePriceLeft = 0;
    this.$coatingPrice = 0;
    this.$tintPrice = 0;
    this.$mirrorPrice = 0;

    // temp
    this.$tempCoatingPrice = 0;
    this.$tempTintPrice = 0;
    this.$tempMirrorPrice = 0;
    this.isComboPrice = false;
    this.comboCoatingPrice = false;
    this.comboTintPrice = false;
    this.comboMirrorPrice = false;
    this.comboFittingPrice = false;



  }

    
  closePopup() {
    if (this.tempGrid) {
      this.tempGrid.instance.clearSelection();
    }

    if (!this.isComboPrice) {
      this.comboCoatingPrice = false;
      this.comboTintPrice = false;
      this.comboMirrorPrice = false;
      this.comboFittingPrice = false;
    }
    this.comboPricePopup = false;
  }

     /**
   * @name addToGrid
   * @return selected combo pricing data
   */
  addToGrid() {
    this.$lensePrice = 0;
    if (this.comboPriceSelectedData.currentSelectedRowKeys.length > 0) {

      if (this.selectedTemplate == 'both') {
        this.bothSidesForm.get("leftexcludebranddiscount").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].excludeBrandDiscount);
        this.bothSidesForm.get("leftpricingTypeId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].pricingTypeId);
        this.bothSidesForm.get("leftmpldetailId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].mpldetailId);
        this.bothSidesForm.get("rightexcludebranddiscount").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].excludeBrandDiscount);
        this.bothSidesForm.get("rightpricingTypeId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].pricingTypeId);
        this.bothSidesForm.get("rightmpldetailId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].mpldetailId);
      }
      if (this.selectedTemplate == 'left') {
        this.bothSidesForm.get("leftexcludebranddiscount").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].excludeBrandDiscount);
        this.bothSidesForm.get("leftpricingTypeId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].pricingTypeId);
        this.bothSidesForm.get("leftmpldetailId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].mpldetailId);
      }
      if (this.selectedTemplate == 'right') {
        this.bothSidesForm.get("rightexcludebranddiscount").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].excludeBrandDiscount);
        this.bothSidesForm.get("rightpricingTypeId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].pricingTypeId);
        this.bothSidesForm.get("rightmpldetailId").setValue(this.comboPriceSelectedData.currentSelectedRowKeys[0].mpldetailId);
      }
        
      if (
        this.comboPriceSelectedData.currentSelectedRowKeys[0].coatingBrandId
      ) {
        this.isComboPrice = true;
        this.comboCoatingPrice = true;
        this.bothSidesForm
          .get("coat")
          .setValue(
            this.comboPriceSelectedData.currentSelectedRowKeys[0].coatingBrandId
          );
        this.bothSidesForm.get("coat").disable();
      } else {
        this.bothSidesForm.get("coat").setValue(null);
        this.bothSidesForm.get("coat").enable();
        this.comboCoatingPrice = false;
      }
      if (this.comboPriceSelectedData.currentSelectedRowKeys[0].tintId) {
        this.isComboPrice = true;
        this.comboTintPrice = true;
        this.bothSidesForm
          .get("tintType")
          .setValue(
            this.comboPriceSelectedData.currentSelectedRowKeys[0].tintId
          );
        this.bothSidesForm.get("tintType").disable();
      } else {
        this.comboTintPrice = false;
        this.bothSidesForm.get("tintType").setValue(null);
        this.bothSidesForm.get("tintType").enable();
      }
      if (this.comboPriceSelectedData.currentSelectedRowKeys[0].mirrorId) {
        this.isComboPrice = true;
        this.comboMirrorPrice = true;
        this.bothSidesForm
          .get("mirror")
          .setValue(
            this.comboPriceSelectedData.currentSelectedRowKeys[0].mirrorId
          );
        this.bothSidesForm.get("mirror").disable();
      } else {
        this.comboMirrorPrice = false;
        this.bothSidesForm.get("mirror").setValue(null);
        this.bothSidesForm.get("mirror").enable();
      }
      if (this.comboPriceSelectedData.currentSelectedRowKeys[0].fittingTypeId) {
        this.isComboPrice = true;
        this.comboFittingPrice = true;
        this.bothSidesForm
          .get("fittingTypeId")
          .setValue(
            this.comboPriceSelectedData.currentSelectedRowKeys[0].fittingTypeId
          );
        this.bothSidesForm.get("fittingTypeId").disable();
        this.toggleFrame = false;
        this.toggle("frame");
      } else {
        this.comboFittingPrice = false;
        this.bothSidesForm.get("fittingTypeId").setValue(null);
        this.bothSidesForm.get("fittingTypeId").enable();
      }
      if (this.selectedTemplate == 'left') {
        this.$tempLensePriceLeft = this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice  ? this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice : 0;
        this.addLensePrice("left");
        this.lenseError['left'] = null;
        this.bothSidesForm.get('leftLensePrice').clearValidators();
        this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
        // this.bothSidesForm.removeControl('leftLensePrice');
      }
      if (this.selectedTemplate == 'right') {
        this.$tempLensePriceRight = this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice  ? this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice : 0;
        this.addLensePrice("right");
        this.lenseError['right'] = null;
        this.bothSidesForm.get('rightLensePrice').clearValidators();
        this.bothSidesForm.get('rightLensePrice').updateValueAndValidity();
        // this.bothSidesForm.removeControl('rightLensePrice');  
      }
      if (this.selectedTemplate == 'both') {
        this.$tempLensePriceLeft = this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice  ? this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice : 0;
        this.$tempLensePriceRight = this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice  ? this.comboPriceSelectedData.currentSelectedRowKeys[0].comboPrice : 0;

        this.addLensePrice("left");
        this.addLensePrice("right");
        this.lenseError['left'] = null;
        this.bothSidesForm.get('leftLensePrice').clearValidators();
        this.bothSidesForm.get('leftLensePrice').updateValueAndValidity();
        // this.bothSidesForm.removeControl('leftLensePrice');
        this.lenseError['right'] = null;
        // this.bothSidesForm.removeControl('rightLensePrice'); 
        this.bothSidesForm.get('rightLensePrice').clearValidators();
        this.bothSidesForm.get('rightLensePrice').updateValueAndValidity(); 

      }
      // this.addLensePrice("both");
      this.comboPricePopup = false;
    }
  }
  /**
   * @name getEngravingPrice
   * @param {number} nameCode
   * @memberof JobFormComponent
   */
  getEngravingPrice(nameCode: number) {
    if (nameCode) {
      this.$engraveName = 0;
      this.$tempEngraveName = 0;
      if (this.otherServicesData && this.otherServicesData.length > 0) {
        let engraveName = this.otherServicesData.find(
          (item) => item.otherServiceMasterId == 4
        );
        if (this.bothSidesForm.get("qtyLeft").value && this.selectedTemplate == 'left') {
          this.$engraveName =
          engraveName && engraveName.price
            ? engraveName.price
            : 0;

          // engraveName && engraveName.price
          //   ? engraveName.price * this.bothSidesForm.get("qtyLeft").value
          //   : 0;
        } else if (this.bothSidesForm.get("qtyRight").value && this.selectedTemplate == 'right') {
          this.$engraveName =
          engraveName && engraveName.price
            ? engraveName.price
            : 0;
          // this.$engraveName =
          // engraveName && engraveName.price
          //   ? engraveName.price * this.bothSidesForm.get("qtyRight").value
          //   : 0;
        } else {
          this.$engraveName =
          engraveName && engraveName.price
            ? engraveName.price
            : 0;
          // this.$engraveName = this.selectedTemplate == 'both' ?  (engraveName && engraveName.price ? engraveName.price : 0) * this.bothSidesForm.get("qtyRight").value : (engraveName && engraveName.price ? engraveName.price : 0);
        }
        this.$tempEngraveName = engraveName && engraveName.price ? engraveName.price : 0;
        // this.$engraveName =
        //   engraveName && engraveName.price
        //     ? this.selectedTemplate == "both"
        //       ? engraveName.price * 2
        //       : engraveName.price
        //     : 0;
            if (engraveName && engraveName.price) {
              const option = {
                width: 300,
                displayTime: 3000,
                position: 'bottom right',
                message: 'EngraveName Price: ' + engraveName.price + ' ' + 'OPL Service Price' ,
                type: 'info',
              };
              notify(option); 
            }
      }
    } else {
      this.$engraveName = 0;
      this.$tempEngraveName = 0;
    }
  }

    /**
   * @name getRxPrice
   * @description price of item
   */
  getRxPrice(
    itemCatalogGroupId: number,
    sph: any,
    cyl: any,
    addf: any,
    label: string,
    priceGroupMasterId: number,
    diameter,
    coatingBrandId,
    mirrorId,
    tintId
  ) {
    let customerBranchId = this.bothSidesForm.get('customerBranchId').value ? this.bothSidesForm.get('customerBranchId').value : 0;
    //this.isTranspose &&
    if (customerBranchId && 
      !this.isComboPrice && 
      itemCatalogGroupId &&
      priceGroupMasterId &&
      !this.bothSidesForm.get('isOurLens').value &&
      ((sph || sph == 0) &&
      ((cyl || cyl == 0) || (addf || addf == 0)))
    ) {
      let isCyl = false;
      let isAdd = false;
      let leftError = true;
      let rightError = true;
      let qty = "";
     
      if (label == 'left') {
        qty = this.bothSidesForm.get('qtyLeft').value;
      }
      if (label == 'right') {
        qty = this.bothSidesForm.get('qtyRight').value;
      }
      if (this.selectedItemCatalogObject.focalId == 1
      ) {
        isCyl = true;
      }
      if (
        (this.selectedItemCatalogObject.focalId == 2 ||
          this.selectedItemCatalogObject.focalId == 3)
      ) {
        isAdd = true;
      }
      if (
        (itemCatalogGroupId && ((sph || sph == 0) && (cyl && cyl !== null || cyl == 0)) ||
        (addf && addf !== null || addf == 0))
      ) {
        if (label == 'left') {
          this.$tempLensePriceLeft = 0;
          // leftError = true;
        }
        if (label == 'right') {
          this.$tempLensePriceRight = 0;
          // rightError = true;
        }
        
   
        this._salesService
          .getRxPrice(
            JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
            customerBranchId,
            itemCatalogGroupId,
            this.selectedItemCatalogObject.focalId,
            this.selectedItemCatalogObject.brandMasterId,
            sph,
            cyl ? cyl : 0,
            addf ? addf : 0,
            this.selectedItemCatalogObject.isBarcodeSingleSide ? this.selectedItemCatalogObject.isBarcodeSingleSide : false,
            JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyBranchId,
            priceGroupMasterId,
            diameter ? diameter : 0,
            JSON.parse(localStorage.getItem("selectedCustomerBranch")).cityId,
            coatingBrandId,
            mirrorId,
            tintId
          )
          .then((response: any) => {
         
            if (response.data.completed && response.data.payload) {
              this.bothSidesForm.get('rxPrice').setErrors(null);
              if (response.data.payload.price == 0 && response.data.payload.coatingPrice == 0
                && response.data.payload.mirrorPrice == 0 && response.data.payload.tintPrice == 0) {
                  const option = {
                    width: 300,
                    displayTime: 5000,
                    message: "Price Not Found!",
                    type: "error",
                  };
                  notify(option);
                  return;
               }
               let errorPrice = [];
              if (response.data.payload.price == 0) {
                if (label == 'left') {
                  errorPrice.push('Left lense price');
                  // this.bothSidesForm.addControl('leftLensePrice', new FormControl('', [Validators.required]));
                  // this.bothSidesForm.get("leftLensePrice").setErrors({'leftLensePrice': true});
                   this.$tempLensePriceLeft = 0;
                   this.$lensePriceLeft = 0;
                  // leftError = true;
                  this.$msgLensePrice = "Price not available for selected item!";
                  this.addLensePrice('left');
                }
                if (label == 'right') {
                  errorPrice.push('Right lense price');
                  // this.bothSidesForm.get("rightLensePrice").setErrors({'rightLensePrice': true});
                   this.$tempLensePriceRight = 0;
                   this.$lensePriceRight = 0;
                  // rightError = true;
                  this.$msgLensePrice = "Price not available for selected item!";
                  this.addLensePrice('right');
                  // this.bothSidesForm.addControl('rightLensePrice', new FormControl('', [Validators.required]));
                }
                
                const option = {
                  width: 300,
                  displayTime: 5000,
                  message: "Price not available for selected item!",
                  type: "warning",
                };
                notify(option);
                this.lenseError = {
                    left: true,
                    right: true
                  };
                //  this.bothSidesForm.get("itemCatalog").setErrors(this.lenseError);
              }
              if (response.data.payload.coatingPrice == 0) {
                if (label == 'left') {
                  errorPrice.push('Left coating price');
                   this.$tempCoatingPriceLeft = 0;
                   this.$coatingPriceLeft = 0;
                  // this.$msgLensePrice = "Coating price not available for selected item!";
                  this.addLensePrice('left');
                }
                if (label == 'right') {
                  errorPrice.push('Right coating price');
                   this.$tempCoatingPriceRight = 0;
                   this.$coatingPriceRight = 0;
                  // this.$msgLensePrice = "Coating price not available for selected item!";
                  this.addLensePrice('right');
                }
                
                // const option = {
                //   width: 300,
                //   displayTime: 5000,
                //   message: "Coating price not available for selected item!",
                //   type: "warning",
                // };
                // notify(option);
               
              }
             
              if (response.data.payload.mirrorPrice == 0) {
                if (label == 'left') {
                  errorPrice.push('Left mirror price');
                   this.$tempMirrorPriceLeft = 0;
                   this.$mirrorPriceLeft = 0;
                  // this.$msgLensePrice = "Mirror price not available for selected item!";
                  this.addLensePrice('left');
                }
                if (label == 'right') {
                  errorPrice.push('Right mirror price');
                   this.$tempMirrorPriceRight = 0;
                   this.$mirrorPriceRight = 0;
                  //  this.$msgLensePrice = "Mirror price not available for selected item!";
                  this.addLensePrice('right');
                }
                
                // const option = {
                //   width: 300,
                //   displayTime: 5000,
                //   message: "Mirror price not available for selected item!",
                //   type: "warning",
                // };
                // notify(option);
               
              }
              if (response.data.payload.tintPrice == 0) {
                if (label == 'left') {
                  errorPrice.push('Left Tint price');
                   this.$tempTintPriceLeft = 0;
                   this.$tintPriceLeft = 0;
                  // this.$msgLensePrice = "Mirror price not available for selected item!";
                  this.addLensePrice('left');
                }
                if (label == 'right') {
                  errorPrice.push('Right Tint price');
                   this.$tempTintPriceRight = 0;
                   this.$tintPriceRight = 0;
                  //  this.$msgLensePrice = "Mirror price not available for selected item!";
                  this.addLensePrice('right');
                }
                
                // const option = {
                //   width: 300,
                //   displayTime: 5000,
                //   message: "TintPrice price not available for selected item!",
                //   type: "warning",
                // };
                // notify(option);
               
              }
              // if (response.data.payload.price == 0 || response.data.payload.coatingPrice == 0
              //   || response.data.payload.mirrorPrice == 0 || response.data.payload.tintPrice == 0) {
              //     const option = {
              //       width: 300,
              //       displayTime: 5000,
              //       message: errorPrice.toString() + ' not found...',
              //       type: "warning",
              //     };
              //     notify(option);
              //   }
               
              if (label == 'left') {
                if (response.data.payload.price > 0) {
                  this.$tempLensePriceLeft = response.data.payload.price;
                }
                if (response.data.payload.coatingPrice > 0) { 
                  this.$tempCoatingPriceLeft = response.data.payload.coatingPrice;
                }
                if (response.data.payload.mirrorPrice > 0) { 
                  this.$tempMirrorPriceLeft = response.data.payload.mirrorPrice;
                }
                if (response.data.payload.tintPrice > 0) { 
                  this.$tempTintPriceLeft = response.data.payload.tintPrice;
                }
                this.$msgLensePrice = response.data.payload.priceTypeName;
                this.addLensePrice('left');
                this.bothSidesForm.get("leftexcludebranddiscount").setValue(response.data.payload.excludeBrandDiscount);
                this.bothSidesForm.get("leftpricingTypeId").setValue(response.data.payload.pricingTypeId);
                this.bothSidesForm.get("leftmpldetailId").setValue(response.data.payload.mplDetailId);
                // leftError = null;
                // this.lenseError['left'] = null;
                // this.bothSidesForm.removeControl('leftLensePrice');
              }
              if (label == 'right') {
                if (response.data.payload.price > 0) { 
                  this.$tempLensePriceRight =  response.data.payload.price;
                }
                if (response.data.payload.coatingPrice > 0) { 
                  this.$tempCoatingPriceRight =  response.data.payload.coatingPrice;
                }
                if (response.data.payload.mirrorPrice > 0) { 
                  this.$tempMirrorPriceRight =  response.data.payload.mirrorPrice;
                }
                if (response.data.payload.tintPrice > 0) { 
                  this.$tempTintPriceRight =  response.data.payload.tintPrice;
                }
                this.$msgLensePrice = response.data.payload.priceTypeName;
                this.addLensePrice('right');
                this.bothSidesForm.get("rightexcludebranddiscount").setValue(response.data.payload.excludeBrandDiscount);
                this.bothSidesForm.get("rightpricingTypeId").setValue(response.data.payload.pricingTypeId);
                this.bothSidesForm.get("rightmpldetailId").setValue(response.data.payload.mplDetailId);
                // rightError = null;
                // this.lenseError['right'] = null;
                // this.bothSidesForm.removeControl('rightLensePrice');
              }
              if (this.selectedItemCatalogObject && this.selectedItemCatalogObject.coatingBrandId > 0 && !coatingBrandId && response.data.payload.price > 0 && response.data.payload.pricingTypeId > 2) {
                this.isCoatingNotRequired = true;
              } else {
                this.isCoatingNotRequired = false;
              }
            //  this.bothSidesForm.get("itemCatalog").setErrors(this.lenseError);
            } else {
              this.bothSidesForm.get('rxPrice').setValue(response.data.message);
              this.bothSidesForm.get('rxPrice').setErrors({price: true});
              const option = {
                width: 300,
                displayTime: 5000,
                message: response.data.message,
                type: "error",
              };
              notify(option);
              console.error(response);
              if (label == 'left') {
                 this.$tempLensePriceLeft = 0;
                 this.$lensePriceLeft = 0;

                 this.$tempCoatingPriceLeft = 0;
                 this.$tempMirrorPriceLeft = 0;
                 this.$tempTintPriceLeft = 0;

                 this.$coatingPriceLeft = 0;
                 this.$mirrorPriceLeft = 0;
                 this.$tintPriceLeft = 0;

                 this.bothSidesForm.get("leftexcludebranddiscount").setValue(false);
                 this.bothSidesForm.get("leftmpldetailId").setValue(0);
                 this.bothSidesForm.get("leftpricingTypeId").setValue(0);
              }
              if (label == 'right') {
                 this.$tempLensePriceRight = 0;
                 this.$lensePriceRight = 0;

                 this.$tempCoatingPriceRight =  0;
                 this.$tempMirrorPriceRight =  0;
                 this.$tempTintPriceRight =  0;

                 this.$coatingPriceRight =  0;
                 this.$mirrorPriceRight =  0;
                 this.$tintPriceRight =  0;

                 this.bothSidesForm.get("rightexcludebranddiscount").setValue(false);
                 this.bothSidesForm.get("rightmpldetailId").setValue(0);
                 this.bothSidesForm.get("rightpricingTypeId").setValue(0);
              }
            }
          })
          .catch((error) => {
           
            if (label == 'left') {
              this.$tempLensePriceLeft = 0;
              this.$lensePriceLeft = 0;
              this.bothSidesForm.get("leftexcludebranddiscount").setValue(false);
              this.bothSidesForm.get("leftmpldetailId").setValue(0);
              this.bothSidesForm.get("leftpricingTypeId").setValue(0);
           }
           if (label == 'right') {
              this.$tempLensePriceRight = 0;
              this.$lensePriceRight = 0;
              this.bothSidesForm.get("rightexcludebranddiscount").setValue(false);
              this.bothSidesForm.get("rightmpldetailId").setValue(0);
              this.bothSidesForm.get("rightpricingTypeId").setValue(0);
           }
            this.loadingIndicator = false;
            const option = {
              width: 300,
              displayTime: 5000,
              message: error.message,
              type: "error",
            };
            console.log(error);
            notify(option);
          });
      }
    }
  }

   /**
   * @name getMirrorList
   * @method GET
   * @param {number} brandMasterId
   * @param {number} materialId
   * @param {number} colorMasterId
   * @return Promise
   */
  getMirrorList(brandMasterId: number, materialId: number) {
    if (brandMasterId && materialId) {
      this.loadingIndicator = true;
    this._salesService
      .getMirrorList(brandMasterId, materialId)
      .then((response) => {
        if (response.data.completed) {
          this.allMirrors = response.data.payload;
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
    }
    
  }
  /**
   * @name getEdgingPrice
   *
   * @param {number} brandMasterId
   * @param {number} customerId
   * @param {number} indexId
   * @param {number} materialId
   * @param {number} frameId
   * @returns
   * @memberof SalesService
   */
  getEdgingPrice(
    brandMasterId: number,
    customerBranchId: number,
    indexId: number,
    materialId: number,
    frameId: number,
    isOurLens?:boolean,
  ) {
    if (!this.comboFittingPrice && frameId && this.isFitting) {
      this.$fittingPrice = 0;
      this.$tempFittingPrice = 0;
      
      if (brandMasterId && customerBranchId && indexId && materialId && frameId) {
        this._salesService
          .getEdgingPrice(brandMasterId, customerBranchId, indexId, materialId, frameId,1, isOurLens)
          .then((response) => {
            if (response.data.completed && response.data.payload) {
              if (this.bothSidesForm.get("qtyLeft").value && this.selectedTemplate == 'left') {
                this.$fittingPrice =
                response.data.payload.price
                  ? response.data.payload.price : 0;
                // this.$fittingPrice =
                // response.data.payload.price
                //   ? response.data.payload.price * this.bothSidesForm.get("qtyLeft").value
                //   : response.data.payload.price;
              } else if (this.bothSidesForm.get("qtyRight").value && this.selectedTemplate == 'right') {
                this.$fittingPrice =
                response.data.payload.price
                  ? response.data.payload.price : 0;
                // this.$fittingPrice =
                // response.data.payload.price
                //   ? response.data.payload.price * this.bothSidesForm.get("qtyRight").value
                //   : response.data.payload.price;
              } else {
                this.$fittingPrice =
                response.data.payload.price
                  ? response.data.payload.price : 0;
                // this.$fittingPrice = this.selectedTemplate == 'both' ?  response.data.payload.price * this.bothSidesForm.get("qtyRight").value: response.data.payload.price;
              }
              this.$tempFittingPrice = response.data.payload.price;
               if(!response.data.payload.price) {
                this.validateFreeFitting();
                return;
              }
                  const option = {
                    width: 300,
                    displayTime: 3000,
                    position: 'bottom right',
                    message: 'Fitting Price: ' + response.data.payload.price + ' ' + response.data.payload.priceTypeName,
                    type: 'info',
                  };
                  notify(option);
                  // this.bothSidesForm.get("frameType").setErrors(null);
            } else {
              // this.bothSidesForm
              //   .get("frameType")
              //   .setErrors({ price: true });
            }
          })
          .catch((err) => {
            console.error("Error:  ", err);
          });
      } else {
        this.$fittingPrice = 0;
        this.$tempFittingPrice = 0;
      }
    }
  }


  validateFreeFitting() {
    //let customerFreeFittingStatus=this.customerList.find((item) => item.customerId == this.bothSidesForm.get('customerId').value).freeFitting;
    let customerFreeFittingStatus=this.customerList.find((item) => item.customerBranchId == this.bothSidesForm.get('customerBranchId').value).freeFitting;
     /*
    customerFreeFittingStatus info:
    0:if not price of fitting then error on fitting selection
    1:if order type 5 then it could go ahead without fitting price
    2:order type 3,4 free fitting
    3:all order free*/
    let displayMessage = '';
    let messageType= 'info';
    switch (customerFreeFittingStatus) {
      case 0:
        //error of no price fount
        //set framtype value to null
        this.bothSidesForm.get("frameType").setValue(null);
        displayMessage = 'No price found for that fitting type';
        messageType = 'error';
        break;
      case 1:
        //can go ahead without fitting price, no error
        displayMessage = 'No fitting price found But customer is eligible for free fitting';
        break;
      case 2:
        this.bothSidesForm.get("frameType").setValue(null);
        displayMessage = 'No price found for that fitting type';
        messageType = 'error';
        break;
      case 3:  
      // can go ahead without fitting price, no error
       displayMessage = 'No fitting price found but customer is eligible for free fitting';
       break;

    }
    const option = {
                    width: 300,
                    displayTime: 3000,
                    position: 'bottom right',
                    message: displayMessage,
                    type: messageType,
                  };
                  notify(option);
  }

    /**
   * @name GetCoatingBrandByBrandMasterIdAndMaterialId
   * @param {event}  object
   * @param {number} brandMasterId
   * @param {number} materialId
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  
  getCoatingBrandByBrandMasterIdAndMaterialId(
    brandMasterId: number,
    materialId: number,
    isHC?: boolean
    
  ) {
    if (brandMasterId && materialId) {
      this.allCoating = [];
      //  this.itemCatalogForm.get('coatingBrandId').setValue('');
      this.loadingIndicator = true;
      const customerId = this.bothSidesForm.get("customerId").value;
      this._salesService
        .getCoatingBrandByBrandMasterIdAndMaterialId(brandMasterId, materialId, isHC,  customerId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.allCoating = list;
            } else {
              if (response.data.payload.active) {
                this.allCoating = response.data.payload;
              }
            }
          } else {
            console.error(response.data.message);
          }
          this.loadingIndicator = false;
        })
        .catch((error) => {
          this.loadingIndicator = false;
          console.error(error.message);
        });
      // this.type = 'add';
    }
  }
   /**
   * @name getHcBrandByBrandMasterIdAndMaterialId
   * @param {event}  object
   * @param {number} brandMasterId
   * @param {number} materialId
   * @return coatingBrands
   * @description fetch data by id
   *
   */
  
  getHcBrandByBrandMasterIdAndMaterialId(
    brandMasterId: number,
    materialId: number
  ) {
    if (brandMasterId && materialId) {
      this.allCoating = [];
      //  this.itemCatalogForm.get('coatingBrandId').setValue('');
      this.loadingIndicator = true;
      const customerId = this.bothSidesForm.get("customerId").value;
      this._salesService
        .getCoatingBrandByBrandMasterIdAndMaterialId(brandMasterId, materialId, true, customerId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.allHCoating = list;
            } else {
              if (response.data.payload.active) {
                this.allHCoating = response.data.payload;
              }
            }
          } else {
            console.error(response.data.message);
          }
          this.loadingIndicator = false;
        })
        .catch((error) => {
          this.loadingIndicator = false;
          console.error(error.message);
        });
      // this.type = 'add';
    }
  }

   /**
   * @name getTintColor
    * @param {number} brandMasterId
   * @param {number} materialId
   * @return colorsList
   * @description fetch data by id
   *
   */
    getTintColor( brandMasterId: number,
      materialId: number, type?: string) {
    this.allColors = [];
    // if (type == 'add') {
    //   this.itemCatalogForm.get('colorMasterId').setValue('');
    // }
    if (brandMasterId && materialId) {
      this.loadingIndicator = true;
      this._salesService
        .getTintColor(brandMasterId, materialId)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              this.allColors = response.data.payload;
            //   const list = [];
            //   response.data.payload.forEach((element) => {
            //     if (element.active) {
            //       list.push(element);
            //     }
            //   });
            //   this.allColors = list;
            // } else {
            //   if (response.data.payload.active) {
            //     this.allColors = response.data.payload;
            //   }
            }
          } else {
            console.error(response.data.message);
          }

          this.loadingIndicator = false;
        })
        .catch((error) => {
          this.loadingIndicator = false;
          console.error(error.message);
        });
    }
  }



  /**
   * @name getAllSOAttributes
   * @params {number} brandMasterId
   * @params {number} subBrandMasterId
   * @returns Promise
   * @description fetch record
   */
  getAllSOAttributes(brandMasterId: number, subBrandMasterId: number) {
    this.loadingIndicator = true;
    this._salesService
      .getAllSOAttributes(brandMasterId, subBrandMasterId)
      .then((response) => {
        if (response.data.completed) {
          this.allSoAttribute.rhft =
            response.data.payload && response.data.payload.rhft
              ? response.data.payload.rhft
              : null;
          this.allSoAttribute.lhft =
            response.data.payload && response.data.payload.lhft
              ? response.data.payload.lhft
              : null;
          this.allSoAttribute.ffv =
            response.data.payload && response.data.payload.ffv
              ? response.data.payload.ffv
              : null;
          this.allSoAttribute.mid =
            response.data.payload && response.data.payload.mid
              ? response.data.payload.mid
              : null;
          this.allSoAttribute.age =
            response.data.payload && response.data.payload.age
              ? response.data.payload.age
              : null;
              this.allSoAttribute.specialBase = response.data.payload && response.data.payload.specialBase
              ? response.data.payload.specialBase : null;
          this.allSoAttribute.bvd =
            response.data.payload && response.data.payload.bvd
              ? response.data.payload.bvd
              : null;
          this.allSoAttribute.pa =
            response.data.payload && response.data.payload.pa
              ? response.data.payload.pa
              : null;
          this.allSoAttribute.wrap =
            response.data.payload && response.data.payload.wrap
              ? response.data.payload.wrap
              : null;
          this.allSoAttribute.nwd =
              response.data.payload && response.data.payload.nwd
                ? response.data.payload.nwd
                : null;    
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }
  
   /**
   *@name getTintTypeyFilterBrandIdIndexId
   * @param {number} filterId
   * @param {number} brandMasterId
   * @param {number} materialId
   * @returns
   * @memberof SalesService
   */
   getTintTypeyFilterBrandIdIndexId(
    filterBrandId: number,
    brandMasterId: number,
    materialId: number,
    indexId: number
  ) {
    this._salesService
      .getTintTypeyFilterBrandIdIndexId(
        filterBrandId,
        brandMasterId,
        materialId,
        indexId
      )
      .then((response) => {
        if (response.data.completed) {
          // need to handle active records in case of issue
              this.allTints = response.data.payload;
        }
        this.loadingIndicator = false;
        if (this.isEdit) {
          if (this.bothSidesForm.get("tintType").value && this.allTints && this.allTints.length > 0) {
            this.selectedTintObject = this.allTints.find(t => t.tintId == this.bothSidesForm.get("tintType").value);
            if (this.selectedTintObject.tintMasterId == 1 || this.selectedTintObject.tintMasterId == 2) {
              this.bothSidesForm.get('color1').enable();
              this.bothSidesForm.get("color1").setValidators([Validators.required]);
              this.bothSidesForm.get("color2").clearValidators();
              this.bothSidesForm.get('color2').disable();
            }
            if (this.selectedTintObject.tintMasterId == 3) {
               this.bothSidesForm.get("color1").setValidators([Validators.required]);
              this.bothSidesForm.get("color2").setValidators([Validators.required]);
              this.bothSidesForm.get('color1').enable();
              this.bothSidesForm.get('color2').enable();
            }
            if (this.selectedTintObject.tintMasterId == 4) {
              this.bothSidesForm.get('color1').setValue('');
              this.bothSidesForm.get('color2').setValue('');
              this.bothSidesForm.get('color1').disable();
              this.bothSidesForm.get('color2').disable();
              this.bothSidesForm.get("color1").clearValidators();
              this.bothSidesForm.get("color2").clearValidators();
              this.bothSidesForm.get("percentage").setValidators([rangeValidator(0, 100, "p")]);
            } else {
              this.bothSidesForm.get("percentage").clearValidators();
              this.bothSidesForm.get("percentage").setValidators([rangeValidator(0, 100, "p"), Validators.required]);
            }
         }
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

    /**
   *@name getOtherService
   * @param {number} value
   * @param {number} customerId
   * @param {string} control name
   * @returns
   * @memberof SalesService
   */
  getOtherService(
    customerId: number,
    brandMasterId: number,
    materialId: number,
    focalId: number
  ) {
    this._salesService
      .getOtherService(customerId, brandMasterId, materialId, focalId)
      .then((response) => {
        if (response.data.completed && response.data.payload) {
          this.otherServicesData = response.data.payload;
        } else {
          console.log("response.data", response.data.payload);
        }
      })
      .catch((err) => {
        console.error("Error:  ", err);
      });
  }





  /**
   * @name tempValidate
   * @return void
   * @param {string} control label
   */
  tempValidate(label: string) {
    switch (label) {
      case "sphRight":
        if (!this.bothSidesForm.get("sphRight").value) {
          this.sphRightTooltip = true;
          setTimeout(() => {
            this.sphRightTooltip = false;
          }, 4000);
        }
        break;
      case "cylRight":
        if (!this.bothSidesForm.get("cylRight").value) {
          this.cylRightTooltip = true;
          setTimeout(() => {
            this.cylRightTooltip = false;
          }, 4000);
        }
        break;
      case "sphLeft":
        if (!this.bothSidesForm.get("sphLeft").value) {
          this.sphLeftTooltip = true;
          setTimeout(() => {
            this.sphLeftTooltip = false;
          }, 4000);
        }
        break;
      case "cylLeft":
        if (!this.bothSidesForm.get("cylLeft").value) {
          this.cylLeftTooltip = true;
          setTimeout(() => {
            this.cylLeftTooltip = false;
          }, 4000);
        }
        break;
      case "ipdr":
        if (!this.bothSidesForm.get("ipdr").value) {
          this.ipdrTooltip = true;
          setTimeout(() => {
            this.ipdrTooltip = false;
          }, 4000);
        }
        break;
      case "ipdl":
        if (!this.bothSidesForm.get("ipdl").value) {
          this.ipdlTooltip = true;
          setTimeout(() => {
            this.ipdlTooltip = false;
          }, 4000);
        }
        break;
    }
  }
  /**
   * @name getAllFocals
   * @returns Promise
   * @description fetch all item
   */
  getAllFocals() {
    this.loadingFocal = true;
    this._salesService
      .getAllFocals()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.focalIdsList = list;
          } else {
            if (response.data.payload.active) {
              this.focalIdsList = response.data.payload;
            }
          }
          this.loadingFocal = false;
        }
      })
      .catch((error) => {
        this.loadingFocal = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
  }

  /**
   * @name addLensePrice
   * @param controlname
   * @return void
   */
  addLensePrice(label: string) {
    switch (label) {
      case "left":
        if (
          this.bothSidesForm.get("qtyLeft").value &&
          this.bothSidesForm.get("itemCatalogGroupId").value
        ) {
          if (!this.bothSidesForm.get("isOurLens").value) {
            this.$lensePriceLeft = this.$tempLensePriceLeft;
              if (this.$msgLensePrice) {
                const option = {
                  width: 300,
                  displayTime: 3000,
                  position: "bottom right",
                  message: this.$msgLensePrice,
                  type: "info",
                };
                notify(option);
              }
            
          }
          // this.$coatingPrice = this.$tempCoatingPrice;
          // this.$mirrorPrice = this.$tempMirrorPrice;
          // this.$tintPrice = this.$tempTintPrice;
          this.$coatingPriceLeft = this.$tempCoatingPriceLeft;
          this.$mirrorPriceLeft = this.$tempMirrorPriceLeft;
          this.$tintPriceLeft = this.$tempTintPriceLeft;

          this.$leftPrismPrice = this.$tempLeftPrismPrice;
          this.$fittingPrice = this.$tempFittingPrice;
          this.$leftCtPrice = this.$tempLeftCtPrice;
          this.$leftEtPrice = this.$tempLeftEtPrice;
          
          this.$leftBaseCurvePrice = this.$tempLeftBaseCurvePrice;
          this.$leftDecPrice = this.$tempLeftDecPrice;
          this.$engraveName = this.$tempEngraveName;
          this.$specialLogo = this.$tempSpecialLogo;
          this.$hcPrice = this.$tempHcPrice;
          this.$leftOval = this.$tempLeftOval;
          this.$selectedOtherServicePrice = this.$tempSelectedOtherServicePrice;
        } else {
          this.$lensePriceLeft = 0;
          // this.$coatingPrice = 0;
          // this.$tintPrice = 0;
          // this.$mirrorPrice = 0;
          this.$coatingPriceLeft = 0;
          this.$mirrorPriceLeft = 0;
          this.$tintPriceLeft = 0;

          this.$leftPrismPrice = 0;
          this.$fittingPrice = 0;
          this.$leftCtPrice = 0;
          this.$leftEtPrice = 0;
          
          this.$leftBaseCurvePrice = 0;
          this.$leftDecPrice = 0;
          this.$engraveName = 0;
          this.$specialLogo = 0;
          this.$hcPrice = 0;
          this.$leftOval = 0;
          this.$selectedOtherServicePrice = 0;
        }
        break;
      case "right":
        if (
          this.bothSidesForm.get("qtyRight").value) {
          if (!this.bothSidesForm.get("isOurLens").value) {
            this.$lensePriceRight = this.$tempLensePriceRight;
            // this.$lensePriceRight =
            //   this.$tempLensePriceRight *
            //   this.bothSidesForm.get("qtyRight").value;
              if (this.$msgLensePrice) {
                const option = {
                  width: 300,
                  displayTime: 3000,
                  position: "bottom right",
                  message: this.$msgLensePrice,
                  type: "info",
                };
                notify(option);
              }
          }

          // this.$coatingPrice = this.$tempCoatingPrice;
          // this.$mirrorPrice = this.$tempMirrorPrice;
          // this.$tintPrice = this.$tempTintPrice;
          this.$coatingPriceRight = this.$tempCoatingPriceRight;
          this.$mirrorPriceRight = this.$tempMirrorPriceRight;
          this.$tintPriceRight = this.$tempTintPriceRight;

          this.$rightPrismPrice = this.$tempRightPrismPrice;
          this.$rightFittingPrice = this.$tempRightFittingPrice;
          this.$rightCtPrice = this.$tempRightCtPrice;
          this.$rightEtPrice = this.$tempRightEtPrice;
          this.$rightBaseCurvePrice = this.$tempRightBaseCurvePrice;
          this.$rightDecPrice = this.$tempRightDecPrice;
          this.$engraveName = this.$tempEngraveName;
          this.$specialLogo = this.$tempSpecialLogo;
          this.$hcPrice = this.$tempHcPrice;
          // this.$leftOval = this.$tempLeftOval * this.bothSidesForm.get("qtyRight").value;
          this.$rightOval = this.$tempRightOval;
          this.$selectedOtherServicePrice = this.$tempSelectedOtherServicePrice;
        } else {
          this.$lensePriceRight = 0;
          // this.$coatingPrice = 0;
          // this.$mirrorPrice = 0;
          // this.$tintPrice = 0;
          this.$rightPrismPrice = 0;
          this.$rightFittingPrice = 0;
          this.$rightCtPrice = 0;
          this.$rightEtPrice = 0;
          
          this.$rightBaseCurvePrice = 0;
          this.$rightDecPrice = 0;
          this.$engraveName = 0;
          this.$specialLogo = 0;
          this.$hcPrice = 0;
          // this.$leftOval = 0;
          this.$rightOval = 0;
          this.$selectedOtherServicePrice = 0;
          this.$coatingPriceRight = 0;
          this.$mirrorPriceRight = 0;
          this.$tintPriceRight = 0;
        }
        break;
      case "both":
        if (this.bothSidesForm.get("itemCatalogGroupId").value) {
          // SERVICES CHECKED
          // this.$coatingPrice = this.$tempCoatingPrice;
          // this.$tintPrice = this.$tempTintPrice;
          this.$fittingPrice = this.$tempFittingPrice;
          this.$rightFittingPrice = this.$tempRightFittingPrice;
          // this.$mirrorPrice = this.$tempMirrorPrice;
          this.$tailorMadePrice = this.$tempTailorMadePrice;
          this.$engraveName = this.$tempEngraveName;
          this.$specialLogo = this.$tempSpecialLogo;
          this.$hcPrice = this.$tempHcPrice;
          this.$selectedOtherServicePrice = this.$tempSelectedOtherServicePrice;
          // END SERVICES
          if (this.bothSidesForm.get("qtyLeft").value) {
            // if (!this.isOurLens) {
            //   this.$lensePriceLeft =
            //   this.$lensePrice * this.bothSidesForm.get("qtyLeft").value;
            // }

            this.$leftPrismPrice = this.$tempLeftPrismPrice;
            this.$leftCtPrice = this.$tempLeftCtPrice;
            this.$leftEtPrice = this.$tempLeftEtPrice;
            this.$leftBaseCurvePrice = this.$tempLeftBaseCurvePrice;
            this.$leftDecPrice = this.$tempLeftDecPrice;
            this.$leftOval = this.$tempLeftOval;

            this.$coatingPriceLeft = this.$tempCoatingPriceLeft;
            this.$mirrorPriceLeft = this.$tempMirrorPriceLeft;
            this.$tintPriceLeft = this.$tempTintPriceLeft;

          }
          if (this.bothSidesForm.get("qtyRight").value) {
            // if (!this.isOurLens) {
            //   this.$lensePriceRight =
            //   this.$lensePrice * this.bothSidesForm.get("qtyRight").value;
            // }
            this.$coatingPriceRight = this.$tempCoatingPriceRight;
            this.$mirrorPriceRight = this.$tempMirrorPriceRight;
            this.$tintPriceRight = this.$tempTintPriceRight;

            this.$rightPrismPrice = this.$tempRightPrismPrice;
            this.$rightCtPrice = this.$tempRightCtPrice;
            this.$rightEtPrice = this.$tempRightEtPrice;
            this.$rightBaseCurvePrice = this.$tempRightBaseCurvePrice;
            this.$rightDecPrice = this.$tempRightDecPrice;
            this.$rightOval = this.$tempRightOval;
          }
        } else {
          this.$lensePriceLeft = 0;
          this.$lensePriceRight = 0;
          // this.$coatingPrice = 0;
          // this.$tintPrice = 0;
          this.$rightPrismPrice = 0;
          this.$leftPrismPrice = 0;
          this.$fittingPrice = 0;
          this.$rightFittingPrice = 0;
          this.$leftCtPrice = 0;
          this.$rightCtPrice = 0;
          this.$leftEtPrice = 0;
          this.$rightEtPrice = 0;
          // this.$mirrorPrice = 0;
          this.$leftBaseCurvePrice = 0;
          this.$rightBaseCurvePrice = 0;
          this.$leftDecPrice = 0;
          this.$rightDecPrice = 0;
          this.$tailorMadePrice = 0;
          this.$engraveName = 0;
          this.$specialLogo = 0;
          this.$hcPrice = 0;
          this.$leftOval = 0;
          this.$rightOval = 0;
          this.$tempSelectedOtherServicePrice = 0;

          this.$coatingPriceRight = 0;
          this.$mirrorPriceRight = 0;
          this.$tintPriceRight = 0;

          this.$coatingPriceLeft = 0;
          this.$mirrorPriceLeft = 0;
          this.$tintPriceLeft = 0;
        }
        break;
    }
  }
  /**
   * @name qtyRight
   * @return qtyRight
   */
  get qtyRight() {
    let qty = 0;
    if (this.bothSidesForm.get("qtyRight").value) {
      return (qty = this.bothSidesForm.get("qtyRight").value);
    }
    return qty;
  }
  /**
   * @name qtyLeft
   * @return qtyLeft
   */
  get qtyLeft() {
    let qty = 0;
    if (this.bothSidesForm.get("qtyLeft").value) {
      return (qty = this.bothSidesForm.get("qtyLeft").value);
    }
    return qty;
  }

  /**
   * @name filterAllItemCatalogs
   * @param {event}  itemTypeMasterId
   * @param {number} brandMasterId
   * @return subBrandsList
   * @description fetch data by id
   */
  filterAllItemCatalogs(type?: string) {
    if (
      this.bothSidesForm.get("itemCatalogFilters").get("brandMasterId")
        .value) {
      const payload = {
        materialId: this.bothSidesForm
          .get("itemCatalogFilters")
          .get("materialId").value
          ? this.bothSidesForm.get("itemCatalogFilters").get("materialId")
              .value
          : 0,
        focalId: this.bothSidesForm.get("itemCatalogFilters").get("focalId")
          .value
          ? this.bothSidesForm.get("itemCatalogFilters").get("focalId")
              .value
          : 0,
        brandMasterId: this.bothSidesForm
          .get("itemCatalogFilters")
          .get("brandMasterId").value
          ? this.bothSidesForm
              .get("itemCatalogFilters")
              .get("brandMasterId").value
          : 0,
        filterId: this.bothSidesForm
          .get("itemCatalogFilters")
          .get("filterId").value
          ? this.bothSidesForm.get("itemCatalogFilters").get("filterId")
              .value
          : 0,
        indexId: this.bothSidesForm.get("itemCatalogFilters").get("indexId")
          .value
          ? this.bothSidesForm.get("itemCatalogFilters").get("indexId")
              .value
          : 0,
          isOurLens: false,
          customerId: this.customerId,
        itemTypeMasterId: 1,
      };
      this.itemCatalogList = [];
      if (this.type == "add") {
         this.bothSidesForm.get("itemCatalogGroupId").setValue(null);
      }
      this.loadingItemCatalog = true;

      this._salesService
        .filterAllItemCatalogsByCustomer(payload)
        .then((response) => {

          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.itemCatalogList = list;
            } else {
              if (response.data.payload.active) {
                this.itemCatalogList = response.data.payload;
              }
            }
          } else {
            console.error(
              "filterAllItemCatalogs Line 3154: ",
              response.data.message
            );
          }
          this.loadingItemCatalog = false;
        })
        .catch((error) => {
          
          this.loadingItemCatalog = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: error.message,
            type: "error",
          };
          notify(option);
        });
        
    }
  }


  /**
   * @name getBrand
   * @returns Promise
   * @description fetch all item
   */
  getBrand() {
    this._salesService
      .getBrand()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element: any) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.brandsList = list;
          } else {
            if (response.data.payload.active) {
              this.brandsList = response.data.payload;
            }
          }
        }
        this.loadingIndicator = false;
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }
/**
   * @name getCustomerBrandMasterByCategoryId
   * @params {number} itemCategoryId
   * @param {number} customerId
   * @returns Promise
   * @description fetch Brand List
   */
   getCustomerBrandMasterByCategoryId(itemCategoryId: number, customerId: number) {
     if (itemCategoryId && customerId) {
      this._salesService
      .getCustomerBrandMasterByCategoryId(itemCategoryId, customerId)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element: any) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.brandMasterList = list;
          } else {
            if (response.data.payload.active) {
              this.brandMasterList = response.data.payload;
            }
          }
        }
        this.loadingIndicator = false;
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
     }
   
  }
  /**
   * @name getAllFilters
   * @returns Promise
   * @description fetch all item
   */
  getAllFilters() {
    this.loadingFilters = true;
    this._salesService
      .getAllFilters()
      .then((response) => {
        if (response.data.completed) {
          this.allFilters = response.data.payload;
          this.loadingFilters = false;
        }
      })
      .catch((err) => {
        this.loadingFilters = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @NAME getAllUrgencyTypes
   * @return list
   */
  getAllUrgencyTypes() {
    this.loadingIndicator = true;
    this._salesService
      .getAllUrgencyTypes()
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element: any) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.urgencyTypeList = list;
          } else {
            if (response.data.payload.active) {
              this.urgencyTypeList = response.data.payload;
            }
          }
        }
        this.loadingIndicator = false;
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllFrameCondition
   * @returns Promise
   * @description fetch all item
   */
  getAllFrameCondition() {
    this.loadingIndicator = true;
    this._salesService
      .getAllFrameCondition()
      .then((response) => {
        if (response.data.completed) {
          this.allFrameCondition = response.data.payload;
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

    /**
     * @name getAllFrames
     * @returns Promise
     * @description fetch frame types
    */
  getAllFrames() {
    this.frameTypeLoading = true;
    this._salesService
      .getAllFrames()
      .then((response) => {
        if (response.data.completed) {
          this.allFrameType = response.data.payload;
          this.frameTypeLoading = false;
        }
      })
      .catch((err) => {
        this.frameTypeLoading = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllModel
   * @returns Promise
   * @description fetch all item
   */
  getAllModel() {
    this.loadingIndicator = true;
    this._salesService
      .getAllModel()
      .then((response) => {
        if (response.data.completed) {
          this.allModels = response.data.payload;
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllColorMasters
   * @returns Promise
   * @description fetch all ColorMaster item
   */

  getAllColorMasters() {
    this.loadingIndicator = true;
    this._salesService
      .getAllColorMasters()
      .then((response) => {
        if (response.data.completed) {
          this.colorMasterList = response.data.payload;
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }
  /**
   * @name getAllCompanyBranches
   * @returns Promise
   * @description fetch all item
   */
  getAllCompanyBranches() {
    this.loadingIndicator = true;
    this._salesService
      .getAllCompanyBranches(true)
      .then((response) => {
        if (response.data.completed) {
          this.allCompanyBranches = response.data.payload;
          if (!this.salesOrderId && !this.bothSidesForm.get("salesId").value) {
            this.bothSidesForm.get("companyBranchId").setValue(this.allCompanyBranches[0].companyBranchId);
          }
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name getAllFrameBrands
   * @returns Promise
   * @description fetch all item frameBrandList
   */
  getAllFrameBrands() {
    this.loadingIndicator = true;
    this._salesService
      .getAllFrameBrands()
      .then((response) => {
        if (response.data.completed) {
          this.frameBrandList = response.data.payload;
          if (this.salesOrderId) {
            const item = this.frameBrandList.find(
              (frame) =>
                frame.frameBrandName ==
                this.bothSidesForm.get("frameBrand").value
            );
            if (!item) {
              const nextId =
                Math.max.apply(
                  Math,
                  this.frameBrandList.map((c) => c.frameBrandId)
                ) + 1;
              this.frameBrandList.push({
                frameBrandName: this.bothSidesForm.get("frameBrand").value,
                frameBrandId: nextId,
              });
            }
          }
          this.loadingIndicator = false;
        }
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }



  /**
   * @name setFittingValue
   * @return void
   * @description set fitting height left and right
   */
  setFittingValue(controlName: string) {
    if (this.getToggleFrame()) {
      // this.toggleFrame = true;
      // this.isFitting = true;
    }
  }

  /**
   * @name getSPH
   * @param {number} range1
   * @param {number} range2
   * @returns sph range
   * @memberof salesService
   */
  getSPH(range1: number, range2: number) {
    this.loadingSphRange = true;
    this._salesService
      .getSPH(range1, range2)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.sphRangeList = list;
          } else {
            if (response.data.payload.active) {
              this.sphRangeList = response.data.payload;
            }
          }
          this.loadingSphRange = false;
        }
      })
      .catch((err) => {
        this.loadingSphRange = false;
        console.log("err ", err);
      });
  }
  /**
   * @name getRightCYL
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
  getRightCYL(range1: number, range2: number) {
    this.loadingCylRange = true;
    this.rightCylRangeList = [];
    this._salesService
      .getCYL(range1, range2)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.rightCylRangeList = list;
          } else {
            if (response.data.payload.active) {
              this.rightCylRangeList = response.data.payload;
            }
          }
          this.loadingCylRange = false;
        }
      })
      .catch((err) => {
        this.loadingCylRange = false;
        console.log("err ", err);
      });
  }

   /**
   * @name getLeftCYL
   * @param {number} range1
   * @param {number} range2
   * @returns cyl range
   * @memberof salesService
   */
    getLeftCYL(range1: number, range2: number) {
      this.loadingCylRange = true;
      this.leftCylRangeList = [];
      this._salesService
        .getCYL(range1, range2)
        .then((response) => {
          if (response.data.completed) {
            if (response.data.payload.length > 0) {
              const list = [];
              response.data.payload.forEach((element) => {
                if (element.active) {
                  list.push(element);
                }
              });
              this.leftCylRangeList = list;
            } else {
              if (response.data.payload.active) {
                this.leftCylRangeList = response.data.payload;
              }
            }
            this.loadingCylRange = false;
          }
        })
        .catch((err) => {
          this.loadingCylRange = false;
          console.log("err ", err);
        });
    }

  /**
   * @name getCylRange
   * @return cyl ranges
   */
  // getRightCylRange(sphValue: any) {
  //   if (sphValue && this.selectedItemCatalogObject) {
  //   let balance = this.selectedItemCatalogObject.extTpMax - Math.abs(sphValue);
  //   console.log('Right Cyl', balance * -1, balance);
  //   this.getRightCYL(balance * -1, balance);
  //   // if (Math.abs(this.selectedItemCatalogObject.cylMinExt) <= balance) {
  //   //   this.getRightCYL(this.selectedItemCatalogObject.cylMinExt, 0);
  //   // } else {
  //   //   let cyl= Math.abs(balance - Math.abs(this.selectedItemCatalogObject.cylMinExt)) * -1;
  //   //   this.getRightCYL(cyl, 0);
  //   // }
  //     // let CYL = Math.abs(sphValue) - Math.abs(this.selectedItemCatalogObject.cylMinExt);
  //     // if (this.type == 'add') {
  //     //   this.bothSidesForm.get('cylRight').setValue(null);
  //     // }
  //     // this.getRightCYL(CYL, 0);
  //   }


  // }
    /**
   * @name getLeftCylRange
   * @return cyl ranges
   */
    //  getLeftCylRange(sphValue: any) {
    //   if (sphValue && this.selectedItemCatalogObject) {
    //     let balance = this.selectedItemCatalogObject.extTpMax - Math.abs(sphValue);
    //     console.log('Left Cyl', balance * -1, balance);
    //     this.getLeftCYL(balance * -1, balance);
    //     // let CYL = Math.abs(sphValue) - Math.abs(this.selectedItemCatalogObject.cylMinExt);
    //     // if (this.type == 'add') {
    //     //   this.bothSidesForm.get('cylLeft').setValue(null);
    //     // }
    //     // this.getLeftCYL(CYL, 0);
    //   }
    // }
  /**
   * @name getADDF
   * @param {number} range1
   * @param {number} range2
   * @returns addf range
   * @memberof salesService
   */
  getADDF(range1: number, range2: number) {
    if (range1 || range1 == 0 && range2 || range2 == 0) {
      this.loadingAddfRange = true;
    this._salesService
      .getADDF(range1, range2)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.addfRangeList = list;
          } else {
            if (response.data.payload.active) {
              this.addfRangeList = response.data.payload;
            }
          }
          this.loadingAddfRange = false;
        }
      })
      .catch((error) => {
        this.loadingAddfRange = false;
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        console.log(error);
        notify(option);
      });
    }
  }
/**
  * @name validateOvalHeight
  * @param {formControlName} startControl width
  * @param {formControlName} endControl height
  * @return validation
  */
  validateOvalHeight(startControl: any, endControl: any) {
    if (
      this.bothSidesForm.get(endControl).value &&
      this.bothSidesForm.get(startControl).value
    ) {
      if (
        this.bothSidesForm.get(endControl).value >
        this.bothSidesForm.get(startControl).value
      ) {
        this.bothSidesForm.get(endControl).setErrors({ inValidHeight: true });
      } else {
        this.bothSidesForm.get(endControl).setErrors(null);
        this.bothSidesForm.get(endControl).setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
        this.bothSidesForm.get(endControl).updateValueAndValidity();
      }
    }
  }

  /**
  * @name validateTailorHeight
  * @param {formControlName} startControl width
  * @param {formControlName} endControl height
  * @return validation
  */
   validateTailorHeight(startControl: any, endControl: any) {
    if (
      this.bothSidesForm.get(endControl).value &&
      this.bothSidesForm.get(startControl).value
    ) {
      if (
        this.bothSidesForm.get(endControl).value >
        this.bothSidesForm.get(startControl).value
      ) {
        this.bothSidesForm.get(endControl).setErrors({ inValidHeight: true });
      } else {
        this.bothSidesForm.get(endControl).setErrors(null);
        this.bothSidesForm.get(endControl).updateValueAndValidity();
      }
    }
  }

  
  /**
   * @name disableOvalRightCheckBox
   * @param diameterRightValue
   * @returns control enable disable
   */
  disableOvalRightCheckBox(diameterRightValue: any) {
    if (diameterRightValue) {
      this.bothSidesForm.get("isOvalRight").disable();
    } else {
      this.bothSidesForm.get("isOvalRight").enable();
    }
    this.bothSidesForm.get("isOvalRight").updateValueAndValidity();
  }

  /**
   * @name disableOvalLeftCheckBox
   * @param diameterLeftValue
   * @returns control enable disable
   */
  disableOvalLeftCheckBox(diameterLeftValue: any) {
    if (diameterLeftValue) {
      this.bothSidesForm.get("isOvalLeft").disable();
    } else {
      this.bothSidesForm.get("isOvalLeft").enable();
    }
    this.bothSidesForm.get("isOvalLeft").updateValueAndValidity();
  }

  // SERVICES 
 
    /**
   *@name getCoatingPrice
   * @param {number} coatingBrandId
   * @param {number} brandMasterId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getCoatingPrice(
    coatingBrandId: number,
    brandMasterId: number,
    customerId: number
  ) {
    this.$coatingPrice = 0;
    this.$tempCoatingPrice = 0;
    // !this.isDefaultCoating && 
    if (!this.comboCoatingPrice) {
      if (coatingBrandId && brandMasterId && coatingBrandId !== this.selectedItemCatalogObject.coatingBrandId) {
        this._salesService
          .getCoatingPrice(coatingBrandId, brandMasterId, customerId)
          .then((response) => {
            if (response.data.completed && response.data.payload) {
              if (
                this.bothSidesForm.get("qtyLeft").value &&
                this.selectedTemplate == "left"
              ) {
                this.$coatingPrice = response.data.payload.price;
                  // ? response.data.payload.price *
                  //   this.bothSidesForm.get("qtyLeft").value
                  // : response.data.payload.price;
              } else if (
                this.bothSidesForm.get("qtyRight").value &&
                this.selectedTemplate == "right"
              ) {
                this.$coatingPrice = response.data.payload.price;
                  // ? response.data.payload.price *
                  //   this.bothSidesForm.get("qtyRight").value
                  // : response.data.payload.price;
              } else {
                this.$coatingPrice = response.data.payload.price;

                  // this.selectedTemplate == "both"
                  //   ? response.data.payload.price *
                  //     this.bothSidesForm.get("qtyRight").value *
                  //     2
                  //   : response.data.payload.price;
              }
              this.$tempCoatingPrice = response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Coating Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            } else {
              console.error("Line: 1821 ", response.data.payload);
            }
          })
          .catch((err) => {
            console.error("Error:  ", err);
          });
      } else {
        this.$coatingPrice = 0;
        this.$tempCoatingPrice = 0;
      }
    }
  }
   /**
   * @name backOnlyActive
   * @return void
   */
  backOnlyActive() {
    if (
      this.bothSidesForm.get("coat").value &&
      this.bothSidesForm.get("mirror").value
    ) {
      this.bothSidesForm.get("backOnly").setValue(true);
    } else {
      this.bothSidesForm.get("backOnly").setValue(false);
    }
  }

   /**
   *@name getCoatingPrice
   * @param {number} coatingBrandId
   * @param {number} brandMasterId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getHcPrice(
    hcoatingId: number,
    brandMasterId: number,
    customerId: number
  ) {
    this.$hcPrice = 0;
    this.$tempHcPrice = 0;
      if (hcoatingId) {
     
        this._salesService
          .getCoatingPrice(hcoatingId, brandMasterId, customerId)
          .then((response) => {
       
            if (response.data.completed && response.data.payload) {
              if (this.bothSidesForm.get("qtyLeft").value && this.selectedTemplate == 'left') {
                this.$hcPrice =
                response.data.payload.price;

                  // ? response.data.payload.price * this.bothSidesForm.get("qtyLeft").value
                  // : response.data.payload.price;
              } else if (this.bothSidesForm.get("qtyRight").value && this.selectedTemplate == 'right') {
                this.$hcPrice =
                response.data.payload.price;

                  // ? response.data.payload.price * this.bothSidesForm.get("qtyRight").value
                  // : response.data.payload.price;
              } else {
                this.$hcPrice = response.data.payload.price;
                // this.selectedTemplate == 'both' ?  response.data.payload.price * this.bothSidesForm.get("qtyRight").value * 2 : response.data.payload.price;
              }
              this.$tempHcPrice = response.data.payload.price;
                  const option = {
                    width: 300,
                    displayTime: 3000,
                    position: 'bottom right',
                    message: 'HC Price: ' + response.data.payload.price + ' ' + response.data.payload.priceTypeName,
                    type: 'info',
                  };
                  notify(option);

            } else {
              console.log("response.data", response.data.payload);
            }
          })
          .catch((err) => {
         
            console.error("Error:  ", err);
          });
      } else {
        this.$hcPrice = 0;
        this.$tempHcPrice = 0;
      }
  }
    /**
   * @name atLeastOneServiceRequired
   * @return boolean
   */
  get atLeastOneServiceRequired() {
    let isValid = [];
    const coat = this.bothSidesForm.get('coat').value;
    const hc = this.bothSidesForm.get('hc').value;
    const mirror = this.bothSidesForm.get('mirror').value;
    const tintType = this.bothSidesForm.get('tintType').value;
    const otherServices = this.bothSidesForm.get('otherServices').value;
    const nameCode = this.bothSidesForm.get('nameCode').value;
    const engraveId = this.bothSidesForm.get('engraveId').value;
    const color1 = this.bothSidesForm.get('color1').value;
    const color2 = this.bothSidesForm.get('color2').value;
    if (this.selectedTemplate == 'both') {
      if (coat) {
        isValid.push(coat);
      }
      if (hc) {
        isValid.push(hc);
      }
      if (mirror) {
        isValid.push(mirror);
      }
      if (tintType) {
        isValid.push(tintType);
      }
      if (otherServices) {
        isValid.push(otherServices);
      }
      if (nameCode) {
        isValid.push(nameCode);
      }
      if (engraveId) {
        isValid.push(engraveId);
      }
      if (color1) {
        isValid.push(color1);
      }
      if (color2) {
        isValid.push(color2);
      }
    }
    return isValid;
  }

    /**
   * @name singleSideRole
   * @return void
   * @description for singal side roles
   */
  get singleSideRole() {
    if (this.selectedTemplate && (this.selectedTemplate === 'left' || this.selectedTemplate === 'right')) {
      this.bothSidesForm.get('mirror').setValue('');
      this.bothSidesForm.get('tintType').setValue('');
      this.bothSidesForm.get('color1').clearValidators();
      this.bothSidesForm.get('color2').clearValidators();
      this.bothSidesForm.get('color1').enable();
      this.bothSidesForm.get('color2').enable();
      this.bothSidesForm.get('percentage').setValidators([rangeValidator(0, 100, 'p')]);
      this.bothSidesForm.get('color1').updateValueAndValidity();
      this.bothSidesForm.get('color2').updateValueAndValidity();
      this.bothSidesForm.get('percentage').updateValueAndValidity();
      return true;
    } else {
      return false;
    }
  }

   /**
   *@name getTintPrice
   * @param {number} tintId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
  getTintPrice(tintId: number, customerId: number) {
    this.$tintPrice = 0;
    this.$tempTintPrice = 0;
    if (!this.comboTintPrice) {
      if (tintId) {
        this.selectedTintObject = this.allTints.find(t => t.tintId == tintId);
        if (this.selectedTintObject) {
          // FULL OR Gradual
          // !this.isDefaultCoating && 
          if (this.selectedTintObject.tintMasterId == 1 || this.selectedTintObject.tintMasterId == 2) {
            this.bothSidesForm.get('color1').enable();
            this.bothSidesForm.get("color1").setValidators([Validators.required]);
            this.bothSidesForm.get("color2").clearValidators();
            this.bothSidesForm.get('color2').disable();
          }
          //!this.isDefaultCoating && 
          if (this.selectedTintObject.tintMasterId == 3) {
             this.bothSidesForm.get("color1").setValidators([Validators.required]);
            this.bothSidesForm.get("color2").setValidators([Validators.required]);
            this.bothSidesForm.get('color1').enable();
            this.bothSidesForm.get('color2').enable();
          }
          // !this.isDefaultCoating && 
          if (this.selectedTintObject.tintMasterId == 4) {
            this.bothSidesForm.get('color1').setValue('');
            this.bothSidesForm.get('color2').setValue('');
            this.bothSidesForm.get('color1').disable();
            this.bothSidesForm.get('color2').disable();
            this.bothSidesForm.get("color1").clearValidators();
            this.bothSidesForm.get("color2").clearValidators();
            this.bothSidesForm.get("percentage").setValidators([rangeValidator(0, 100, "p")]);
          } else {
            this.bothSidesForm.get("percentage").clearValidators();
            this.bothSidesForm.get("percentage").setValidators([rangeValidator(0, 100, "p"), Validators.required]);
            // this.bothSidesForm.get("color1").setValidators([Validators.required]);
            // this.bothSidesForm.get("color2").setValidators([Validators.required]);
            // this.bothSidesForm.get('color1').enable();
            // this.bothSidesForm.get('color2').enable();
          }
          this.bothSidesForm.get("color1").updateValueAndValidity();
          this.bothSidesForm.get("color2").updateValueAndValidity();
          this.bothSidesForm.get("percentage").updateValueAndValidity();
        }
       
        // this._salesService
        //   .getTintPrice(tintId, customerId)
        //   .then((response) => {
        //     if (response.data.completed && response.data.payload) {
        //       if (this.bothSidesForm.get("qtyLeft").value && this.selectedTemplate == 'left') {
        //         this.$tintPrice =
        //         response.data.payload.price
        //           ? response.data.payload.price : 0;
        //         // this.$tintPrice =
        //         // response.data.payload.price
        //         //   ? response.data.payload.price * this.bothSidesForm.get("qtyLeft").value
        //         //   : response.data.payload.price;
        //       } else if (this.bothSidesForm.get("qtyRight").value && this.selectedTemplate == 'right') {
        //         this.$tintPrice =
        //         response.data.payload.price
        //           ? response.data.payload.price : 0;
        //         // this.$tintPrice =
        //         // response.data.payload.price
        //         //   ? response.data.payload.price * this.bothSidesForm.get("qtyRight").value
        //         //   : response.data.payload.price;
        //       } else {
        //         this.$tintPrice =
        //         response.data.payload.price
        //           ? response.data.payload.price : 0;
        //         // this.$tintPrice = this.selectedTemplate == 'both' ?  response.data.payload.price * this.bothSidesForm.get("qtyRight").value * 2 : response.data.payload.price;
        //       }
        //       this.$tempTintPrice = response.data.payload.price;
        //       // this.$tintPrice =
        //       //   response.data.payload.price && this.selectedTemplate == "both"
        //       //     ? response.data.payload.price * 2
        //       //     : response.data.payload.price;
        //           const option = {
        //             width: 300,
        //             displayTime: 3000,
        //             position: 'bottom right',
        //             message: 'Tint Price: ' + response.data.payload.price + ' ' + response.data.payload.priceTypeName,
        //             type: 'info',
        //           };
        //           notify(option);
        //     } else {
        //       console.log("response.data", response.data.payload);
        //     }
        //   })
        //   .catch((err) => {
        //     console.error("Error:  ", err);
        //   });
      } else {
        this.$tintPrice = 0;
        this.$tempTintPrice = 0;
        this.selectedTintObject = {};
      }
    }
  }
   /**
   * @name otherServicePrice
   * @param {number} otherServiceMasterId
   * @returns price
   */
  otherServicePrice(otherServiceId: number) {
    this.$selectedOtherServicePrice = 0;
    this.$tempSelectedOtherServicePrice = 0;
    if (otherServiceId) {
      if (this.otherServicesData && this.otherServicesData.length > 0) {
        const selectedItem = this.otherServicesData.find(
          (item: any) => item.otherServiceId == otherServiceId
        );
        // this.$selectedOtherServicePrice =
        //   selectedItem && selectedItem.price
        //     ? this.selectedTemplate == "both"
        //       ? selectedItem.price * 2
        //       : selectedItem.price
        //     : 0;
        if (this.bothSidesForm.get("qtyLeft").value && this.selectedTemplate == 'left') {
          this.$selectedOtherServicePrice = selectedItem && selectedItem.price ? selectedItem.price : 0;
          // selectedItem && selectedItem.price
          //   ? selectedItem.price * this.bothSidesForm.get("qtyLeft").value
          //   : 0;
        } else if (this.bothSidesForm.get("qtyRight").value && this.selectedTemplate == 'right') {
          this.$selectedOtherServicePrice = selectedItem && selectedItem.price ? selectedItem.price : 0;
          // this.$selectedOtherServicePrice =
          // selectedItem && selectedItem.price
          //   ? selectedItem.price * this.bothSidesForm.get("qtyRight").value
          //   : 0;
        } else {
          this.$selectedOtherServicePrice = selectedItem && selectedItem.price ? selectedItem.price : 0;
          // this.$selectedOtherServicePrice = this.selectedTemplate == 'both' ?  (selectedItem && selectedItem.price ? selectedItem.price : 0) * this.bothSidesForm.get("qtyRight").value * 2 : (selectedItem && selectedItem.price ? selectedItem.price : 0);
        }
        this.$tempSelectedOtherServicePrice = selectedItem && selectedItem.price ? selectedItem.price : 0;

            if (selectedItem && selectedItem.price) {
              const option = {
                width: 300,
                displayTime: 3000,
                position: 'bottom right',
                message: 'Other Services Price: ' + selectedItem.price + ' ' + 'OPL Service Price' ,
                type: 'info',
              };
              notify(option);
            }
      }
    } else {
      this.$selectedOtherServicePrice = 0;
      this.$tempSelectedOtherServicePrice = 0;
    }
  }

  /**
   * @name getSpecialLogoPricing
   * @param {number} engraveId
   * @memberof JobFormComponent
   */
  getSpecialLogoPricing(engraveId: number) {
    if (engraveId) {
      this.$specialLogo = 0;
      this.$tempSpecialLogo = 0;
      if (this.otherServicesData && this.otherServicesData.length > 0) {
        let specialLogoItem = this.otherServicesData.find(
          (item) => item.otherServiceMasterId == 3
        );
        if (this.bothSidesForm.get("qtyLeft").value && this.selectedTemplate == 'left') {
          this.$specialLogo =
          specialLogoItem && specialLogoItem.price
            ? specialLogoItem.price : 0;
          // this.$specialLogo =
          // specialLogoItem && specialLogoItem.price
          //   ? specialLogoItem.price * this.bothSidesForm.get("qtyLeft").value
          //   : 0;
        } else if (this.bothSidesForm.get("qtyRight").value && this.selectedTemplate == 'right') {
          this.$specialLogo =
          specialLogoItem && specialLogoItem.price
            ? specialLogoItem.price : 0;
          // this.$specialLogo =
          // specialLogoItem && specialLogoItem.price
          //   ? specialLogoItem.price * this.bothSidesForm.get("qtyRight").value
          //   : 0;
        } else {
          this.$specialLogo =
          specialLogoItem && specialLogoItem.price
            ? specialLogoItem.price : 0;
          // this.$specialLogo = this.selectedTemplate == 'both' ?  (specialLogoItem && specialLogoItem.price ? specialLogoItem.price : 0) * this.bothSidesForm.get("qtyRight").value : (specialLogoItem && specialLogoItem.price ? specialLogoItem.price : 0);
        }
        this.$tempSpecialLogo = specialLogoItem && specialLogoItem.price ? specialLogoItem.price : 0;
        // this.$specialLogo =
        //   specialLogoItem && specialLogoItem.price
        //     ? this.selectedTemplate == "both"
        //       ? specialLogoItem.price * 2
        //       : specialLogoItem.price
        //     : 0;
            if (specialLogoItem && specialLogoItem.price) {
              const option = {
                width: 300,
                displayTime: 3000,
                position: 'bottom right',
                message: 'Special Logo  Price: ' + specialLogoItem.price + ' ' + 'OPL Service Price' ,
                type: 'info',
              };
              notify(option);
            }
           
      }
    } else {
      this.$specialLogo = 0;
      this.$tempSpecialLogo = 0;
    }
  }
  // SERVICES ROLES

   /**
   * @name  getServiceProcessRole
   * @return void
   * @description Adding/ Removing HC	Blank issuance/QC/Tinting/HC/MC&Mirror
   */
  get getServiceProcessRole() {
    if (!this.isAdmin && !this.isSupervisor &&  
      this.salesOrderId && this.salesOrderData &&
      this.salesOrderData.departmentId !==2 &&
      this.salesOrderData.holdProcess &&
      this.salesOrderData.holdProcess.holdProcess &&
      this.salesOrderData.holdProcess.processId > 0
    ) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @name getTintMirrorRole
   * @return void
   * @description Adding/ Removing 1 or 2
   */
  get getTintMirrorRole() {
    if (!this.isAdmin && !this.isSupervisor && this.salesOrderId &&  
      this.salesOrderData &&
      this.salesOrderData.departmentId !==2 &&
      this.salesOrderData.holdProcess &&
      this.salesOrderData.processId > 2
    ) {
      return true;
    } else {
      return false;
    }
  }

   /**
   * @name getHcProcessRole
   * @return void
   * @description Adding/ Removing HC	Blank issuance/QC/Tinting
   */
  get getHcProcessRole() {
    if (!this.isAdmin && !this.isSupervisor &&  
      this.salesOrderId &&
      this.salesOrderData &&
      this.salesOrderData.departmentId !==2 &&
      this.salesOrderData.holdProcess &&
      this.salesOrderData.processId > 3
    ) {
      return true;
    } else {
      return false;
    }
  }
 
  // SERVICES

  get isSubmitRole() {
    if (!this.salesOrderId && this.bothSidesForm.get('asRedo').value && this.complainStatus) {
      return true;
    } else if(!this.salesOrderId && this.isCopySaleOrder && this.bothSidesForm.get('asRedo').value && !this.complainStatus) {
      return false;
    }  else if (this.salesOrderId && this.salesOrderData && this.salesOrderData.holdProcess) {
       return true;
    }  else if(this.isCopySaleOrder && this.salesOrderData && !this.salesOrderData.holdProcess) {
      return true;
    }  else if (!this.salesOrderId && !this.isCopySaleOrder) {
      return true;
    } else {
      return false;
    }
  }

  // LEFT RIGHT ROLES
   /**
   * @name isOvalRightChange
   * @param form control value
   * @return control enable disable
   */
  isOvalRightChange(value) {
    if (value) {
      this.bothSidesForm.get("diameterRight").setValue("");
      this.bothSidesForm.get("diameterRight").disable();
      this.bothSidesForm.get("ovalWidthRight").enable();
      this.bothSidesForm.get("ovalHeightRight").enable();
      this.bothSidesForm
        .get("ovalWidthRight")
        .setValidators([
          rangeValidator(48, 80, "p"),
          stepValidator(1),
          Validators.required,
        ]);
      this.bothSidesForm
        .get("ovalHeightRight")
        .setValidators([
          rangeValidator(48, 80, "p"),
          stepValidator(1),
          Validators.required,
        ]);
      this.$rightOval = 0;
      this.$tempRightOval = 0;
      let rightItem = null;
      if (this.otherServicesData && this.otherServicesData.length > 0) {
        rightItem = this.otherServicesData.find(
          (item) => item.otherServiceMasterId == 1
        );
        // this.$rightOval = rightItem && rightItem.price ? rightItem.price : 0;
        if (
          this.bothSidesForm.get("qtyRight").value &&
          this.selectedTemplate == "right"
        ) {
          this.$rightOval =
            rightItem && rightItem.price
              ? rightItem.price : 0;
          // this.$rightOval =
          //   rightItem && rightItem.price
          //     ? rightItem.price * this.bothSidesForm.get("qtyRight").value
          //     : 0;
        }
        if (
          this.bothSidesForm.get("qtyRight").value &&
          this.selectedTemplate == "both"
        ) {
          this.$rightOval =
            rightItem && rightItem.price
              ? rightItem.price : 0;
          // this.$rightOval =
          //   this.selectedTemplate == "both"
          //     ? (rightItem && rightItem.price ? rightItem.price : 0) *
          //       this.bothSidesForm.get("qtyRight").value *
          //       2
          //     : rightItem && rightItem.price
          //     ? rightItem.price
          //     : 0;
        }
        this.$tempRightOval =
          rightItem && rightItem.price ? rightItem.price : 0;
        if (rightItem && rightItem.price) {
          const option = {
            width: 300,
            displayTime: 3000,
            position: "bottom right",
            message:
              "Oval Price: " + rightItem.price + " " + "OPL Service Price",
            type: "info",
          };
          notify(option);
        }
      }
    } else {
      this.bothSidesForm.get("diameterRight").enable();
      this.bothSidesForm.get("ovalHeightRight").setValue("");
      this.bothSidesForm.get("ovalWidthRight").setValue("");
      this.bothSidesForm.get("ovalHeightRight").disable();
      this.bothSidesForm.get("ovalWidthRight").disable();
      this.bothSidesForm.get("ovalHeightRight").clearValidators();
      this.bothSidesForm.get("ovalWidthRight").clearValidators();
      this.bothSidesForm
        .get("ovalWidthRight")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm
        .get("ovalHeightRight")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.$rightOval = 0;
      this.$tempRightOval = 0;
    }
    this.bothSidesForm.get("ovalWidthRight").updateValueAndValidity();
    this.bothSidesForm.get("ovalHeightRight").updateValueAndValidity();
  }

   /**
   * @name isOvalLeftChange
   * @param form control value
   * @return control enable disable
   */
  isOvalLeftChange(value) {
    if (value) {
      this.bothSidesForm.get("diameterLeft").setValue("");
      this.bothSidesForm.get("diameterLeft").disable();
      this.bothSidesForm.get("ovalWidthLeft").enable();
      this.bothSidesForm.get("ovalHeightLeft").enable();
      this.bothSidesForm
        .get("ovalWidthLeft")
        .setValidators([
          rangeValidator(48, 80, "p"),
          stepValidator(1),
          Validators.required,
        ]);
      this.bothSidesForm
        .get("ovalHeightLeft")
        .setValidators([
          rangeValidator(48, 80, "p"),
          stepValidator(1),
          Validators.required,
        ]);
      this.$leftOval = 0;
      this.$tempLeftOval = 0;
      let leftItem = null;
      if (this.otherServicesData && this.otherServicesData.length > 0) {
        leftItem = this.otherServicesData.find(
          (item) => item.otherServiceMasterId == 1
        );
        if (
          this.bothSidesForm.get("qtyLeft").value &&
          this.selectedTemplate == "left"
        ) {
          this.$leftOval =
            leftItem && leftItem.price
              ? leftItem.price : 0;
          // this.$leftOval =
          //   leftItem && leftItem.price
          //     ? leftItem.price * this.bothSidesForm.get("qtyLeft").value
          //     : 0;
        }
        if (
          this.bothSidesForm.get("qtyLeft").value &&
          this.selectedTemplate == "both"
        ) {
          this.$leftOval =
            leftItem && leftItem.price
              ? leftItem.price : 0;
          // this.$leftOval =
          //   this.selectedTemplate == "both"
          //     ? (leftItem && leftItem.price ? leftItem.price : 0) *
          //       this.bothSidesForm.get("qtyRight").value *
          //       2
          //     : leftItem && leftItem.price
          //     ? leftItem.price
          //     : 0;
        }
        this.$tempLeftOval = leftItem && leftItem.price ? leftItem.price : 0;
        // this.$leftOval = leftItem && leftItem.price ? leftItem.price : 0;
        if (leftItem && leftItem.price) {
          const option = {
            width: 300,
            displayTime: 3000,
            position: "bottom right",
            message:
              "Oval Price: " + leftItem.price + " " + "OPL Service Price",
            type: "info",
          };
          notify(option);
        }
      }
    } else {
      this.bothSidesForm.get("diameterLeft").enable();
      this.bothSidesForm.get("ovalHeightLeft").setValue("");
      this.bothSidesForm.get("ovalWidthLeft").setValue("");
      this.bothSidesForm.get("ovalHeightLeft").disable();
      this.bothSidesForm.get("ovalWidthLeft").disable();
      this.bothSidesForm.get("ovalHeightLeft").clearValidators();
      this.bothSidesForm.get("ovalWidthLeft").clearValidators();
      this.bothSidesForm
        .get("ovalWidthLeft")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm
        .get("ovalHeightLeft")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.$leftOval = 0;
      this.$tempLeftOval = 0;
    }
    this.bothSidesForm.get("ovalWidthLeft").updateValueAndValidity();
    this.bothSidesForm.get("ovalHeightLeft").updateValueAndValidity();
  }
   /**
   *@name getRightBaseCurvePrice
   * @param {number} baseCurveId
   * @param {number} customerId
   * @param {string} controlName
   * @returns
   * @memberof SalesService
   */
  getRightBaseCurvePrice(baseCurveRight: any, customerId: number, controlName: string) {
    // if (!this.isComboPrice) {
 
    if (
      baseCurveRight &&
      customerId
    ) {
      
        this.$rightBaseCurvePrice = 0;
        this.$tempRightBaseCurvePrice = 0;
      this._salesService
        .getBaseCurvePrice(baseCurveRight, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              controlName == "baseCurveRight" &&
              this.bothSidesForm.get("qtyRight").value && this.bothSidesForm.get("baseCurveRight").value &&
              (this.selectedTemplate == "right" ||
                this.selectedTemplate == "both")
            ) {
              this.$rightBaseCurvePrice = response.data.payload.price
                ? response.data.payload.price : 0;
              // this.$rightBaseCurvePrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyRight").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Base Curve Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempRightBaseCurvePrice = response.data.payload.price;
          } else {
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message: 'Price not found...',
              type: "info",
            };
            notify(option);
            console.error("Line: 2354 ", response.data.payload);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$rightBaseCurvePrice = 0;
        this.$tempRightBaseCurvePrice = 0;
    }
    // }
  }
     /**
   *@name getLeftBaseCurvePrice
   * @param {number} baseCurveId
   * @param {number} customerId
   * @param {string} controlName
   * @returns
   * @memberof SalesService
   */
   getLeftBaseCurvePrice(baseCurveLeft: any, customerId: number, controlName: string) {
    // if (!this.isComboPrice) {
 
    if (
      baseCurveLeft && customerId
    ) {
        this.$leftBaseCurvePrice = 0;
        this.$tempLeftBaseCurvePrice = 0;
     
      this._salesService
        .getBaseCurvePrice(baseCurveLeft, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              controlName == "baseCurveLeft" &&
              this.bothSidesForm.get("qtyLeft").value && this.bothSidesForm.get("baseCurveLeft").value && 
              (this.selectedTemplate == "left" ||
                this.selectedTemplate == "both")
            ) {
              this.$leftBaseCurvePrice = response.data.payload.price
                ? response.data.payload.price : 0;
              // this.$leftBaseCurvePrice = response.data.payload.price;

              // this.$leftBaseCurvePrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyLeft").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Base Curve Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
           
             this.$tempLeftBaseCurvePrice = response.data.payload.price;
          } else {
            console.error("Line: 2354 ", response.data.payload);
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message: 'Price not found...',
              type: "info",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
      this.$leftBaseCurvePrice = 0;
      this.$tempLeftBaseCurvePrice = 0;
    }
    // }
  }
  /**
   * @name checkETCt
   * @params value
   * @params control name
   * @return control enable disable
   */
  checkETCt(value, label1: string, label2: string) {
    if (label1 === label1) {
      if (value) {
        this.bothSidesForm.get(label1).enable();
        this.bothSidesForm.get(label2).setValue("");
        this.bothSidesForm.get(label2).disable();
      } else {
        this.bothSidesForm.get(label2).enable();
      }
    }
  }
  parseAndValidate(value) {
    // Convert the value to an integer and check if it is valid
    let parsedValue = parseInt(value);
    return !isNaN(parsedValue) && parsedValue !== 0 ? parsedValue : null;
}

   /**
   * @name getPricing
   * @param {*} value
   * @param {string} label1
   * @param {string} label2
   * @memberof JobFormComponent
   */
   getPricing(value, label1: string, label2: string) {
    // RIGHT PRISM
    let prismInRight = this.bothSidesForm.get("prismInRight").value;
    let prismUpRight = this.bothSidesForm.get("prismUpRight").value;
    let prismOutRight = this.bothSidesForm.get("prismOutRight").value;
    let prismDownRight = this.bothSidesForm.get("prismDownRight").value;
    // LEFT PRISM
    let prismInLeft = this.bothSidesForm.get("prismInLeft").value;
    let prismUpLeft = this.bothSidesForm.get("prismUpLeft").value;
    let prismOutLeft = this.bothSidesForm.get("prismOutLeft").value;
    let prismDownLeft = this.bothSidesForm.get("prismDownLeft").value;

    if(label1 == "prismInRight" || label1 == "prismOutRight" || label1 == "prismUpRight" || label1 == "prismDownRight"){
      let prismInRightValue = this.parseAndValidate(prismInRight); // 5
      let prismUpRightValue = this.parseAndValidate(prismUpRight); // 6
      let prismOutRightValue = this.parseAndValidate(prismOutRight); // 16
      let prismDownRightValue = this.parseAndValidate(prismDownRight); // 1
      // Filter out null values and find the maximum value
      let values = [prismInRightValue, prismUpRightValue, prismOutRightValue, prismDownRightValue];
      let validValues = values.filter(value => value !== null);
      if(validValues.length > 0) {
        let maxValidValue = Math.max(...validValues);
        console.log("Largest valid value:", maxValidValue);
        this.getRightPrismPrice(maxValidValue, this.customerId);
      } 
        else {
        this.getRightPrismPrice(null, this.customerId);
      }
    }
     else if(label1 == "prismInLeft" || label1 == "prismUpLeft" || label1 == "prismOutLeft" || label1 == "prismDownLeft")
      {
        let prismInLeftValue = this.parseAndValidate(prismInLeft); // 5
        let prismUpLeftValue = this.parseAndValidate(prismUpLeft); // 6
        let prismOutLeftValue = this.parseAndValidate(prismOutLeft); // 16
        let prismDownLeftValue = this.parseAndValidate(prismDownLeft); // 1
          // Filter out null values and find the maximum value
      let values = [prismInLeftValue, prismUpLeftValue, prismOutLeftValue, prismDownLeftValue];
      let validValues = values.filter(value => value !== null);
      if(validValues.length > 0) {
        let maxValidValue = Math.max(...validValues);
        console.log("Largest valid value:", maxValidValue);
        this.getLeftPrismPrice(maxValidValue, this.customerId);
      } 
        else {
        this.getLeftPrismPrice(null, this.customerId);
      }
     }
     else {
      this.getLeftPrismPrice(null, this.customerId);
      this.getRightPrismPrice(null, this.customerId);
      }
}
  // getPricing(value, label1: string, label2: string) {
  //   // if (value > 0) {
  //     let prismInLeft = this.bothSidesForm.get("prismInLeft").value;
  //     let prismUpLeft = this.bothSidesForm.get("prismUpLeft").value;
  //     let prismInRight = this.bothSidesForm.get("prismInRight").value;
  //     let prismUpRight = this.bothSidesForm.get("prismUpRight").value;
  //     let prismOutRight = this.bothSidesForm.get("prismOutRight").value;
  //     let prismDownRight = this.bothSidesForm.get("prismDownRight").value;
  //     let prismOutLeft = this.bothSidesForm.get("prismOutLeft").value;
  //     let prismDownLeft = this.bothSidesForm.get("prismDownLeft").value;

  //     if (label1 === "prismInRight" || label1 === "prismUpRight") {
  //       if (prismInRight || prismUpRight && (!prismOutRight || prismOutRight == 0) || (!prismDownRight || prismDownRight == 0)) {
  //         let prismGroupeId = 0;
  //         if ((prismInRight && prismUpRight == "") || prismUpRight == null) {
  //           // tslint:disable-next-line:radix
  //           prismGroupeId = parseInt(prismInRight);
  //         }
  //         if ((prismUpRight && prismInRight == "") || prismInRight == null) {
  //           // tslint:disable-next-line:radix
  //           prismGroupeId = parseInt(prismUpRight);
  //         }
  //         if (prismUpRight && prismInRight) {
  //           prismGroupeId =
  //             // tslint:disable-next-line:radix
  //             parseInt(prismInRight) > parseInt(prismUpRight)
  //               // tslint:disable-next-line:radix
  //               ? parseInt(prismInRight)
  //               // tslint:disable-next-line:radix
  //               : parseInt(prismUpRight);
  //         }
  //         this.getRightPrismPrice(prismGroupeId, this.customerId);
  //         // this.getPrismPrice(prismGroupeId, this.customerId, "right", label1);
  //       } else {
  //         this.getRightPrismPrice(null, this.customerId);
  //         // this.getPrismPrice(null, this.customerId, "right", label1);
  //       }
  //     } else if (label1 === "prismInLeft" || label1 === "prismUpLeft") {
  //       if (prismInLeft || prismUpLeft && (!prismOutLeft || prismOutLeft == 0) || (!prismDownLeft || prismDownLeft == 0)) {
  //         let prismGroupeId = 0;
  //         if ((prismInLeft && prismUpLeft == "") || prismUpLeft == null) {
  //           // tslint:disable-next-line:radix
  //           prismGroupeId = parseInt(prismInLeft);
  //         }
  //         if ((prismUpLeft && prismInLeft == "") || prismInLeft == null) {
  //           // tslint:disable-next-line:radix
  //           prismGroupeId = parseInt(prismUpLeft);
  //         }
  //         if (prismUpLeft && prismInLeft) {
  //           prismGroupeId =
  //             // tslint:disable-next-line:radix
  //             parseInt(prismInLeft) > parseInt(prismUpLeft)
  //               // tslint:disable-next-line:radix
  //               ? parseInt(prismInLeft)
  //               // tslint:disable-next-line:radix
  //               : parseInt(prismUpLeft);
  //         }
  //         // tslint:disable-next-line: radix
  //         // prismGroupeId = parseInt(prismInLeft) > parseInt(prismUpLeft) ? parseInt(prismInLeft) : parseInt(prismUpLeft);
  //         // this.getPrismPrice(prismGroupeId, this.customerId, "left", label1);
  //         this.getLeftPrismPrice(prismGroupeId, this.customerId);
  //       } else {
  //         // this.getPrismPrice(null, this.customerId, "left", label1);
  //         this.getLeftPrismPrice(null, this.customerId);
  //       }
  //     } else if (label1 === "prismOutRight" || label1 === "prismDownRight") {
  //       if (prismOutRight || prismDownRight && (!prismInRight || prismInRight == 0) || (!prismUpRight || prismUpRight == 0)) {
  //         if (prismOutRight > 0 && prismDownRight > 0) {
  //           let prismGroupeId = 0;
  //           // tslint:disable-next-line:radix
  //           prismGroupeId = parseInt(prismOutRight) > parseInt(prismDownRight)
  //             // tslint:disable-next-line:radix
  //             ? parseInt(prismOutRight)
  //             // tslint:disable-next-line:radix
  //             : parseInt(prismDownRight);
  //           this.getRightPrismPrice(prismGroupeId, this.customerId);
  //         } else if (prismOutRight > 0 && !prismDownRight) {
  //           this.getRightPrismPrice(prismOutRight, this.customerId);
  //         } else if (prismDownRight > 0 && !prismOutRight) {
  //           this.getRightPrismPrice(prismDownRight, this.customerId);
  //         }
         
  //       } else {
  //         this.getRightPrismPrice(null, this.customerId);
  //       }
  //     } else if (label1 === "prismOutLeft" || label1 === "prismDownLeft") {
  //       if (prismOutLeft || prismDownLeft && (!prismInLeft || prismInLeft == 0) || (!prismUpLeft || prismUpLeft == 0)) {
  //         if (prismOutLeft > 0 && prismDownLeft > 0) {
  //           let prismGroupeId = 0;
  //           // tslint:disable-next-line:radix
  //           prismGroupeId = parseInt(prismOutLeft) > parseInt(prismDownLeft)
  //           // tslint:disable-next-line:radix
  //           ? parseInt(prismOutLeft)
  //           // tslint:disable-next-line:radix
  //           : parseInt(prismDownLeft);
  //           this.getLeftPrismPrice(prismGroupeId, this.customerId);
  //         } else if (prismOutLeft > 0 && !prismDownLeft) {
  //           this.getLeftPrismPrice(prismOutLeft, this.customerId);
  //          } else if (prismDownLeft > 0 && !prismOutLeft) {
  //           this.getLeftPrismPrice(prismDownLeft, this.customerId);
  //           }
  //       } else {
  //         // this.getPrismPrice(null, this.customerId, "left", label1);
  //         this.getLeftPrismPrice(null, this.customerId);
  //       }
  //     } else {
  //       // this.getPrismPrice(null, this.customerId, "", label1);
  //       this.getLeftPrismPrice(null, this.customerId);
  //       this.getRightPrismPrice(null, this.customerId);
  //     }
  //     // CT AND ET
  //     // if (label1 == "etRight" || label1 == "etLeft") {
  //     //   if (label1 == "etRight") {
  //     //     this.$rightCtPrice = 0;
  //     //     this.$tempRightCtPrice = 0;
  //     //   }
  //     //   if (label1 == "etLeft") {
  //     //     this.$leftCtPrice = 0;
  //     //     this.$tempLeftCtPrice = 0;
  //     //   }
  //     //   this.getETPrice(value, this.customerId, label1);
  //     // }
  //     // if (label1 == "ctRight" || label1 == "ctLeft") {
  //     //   if (label1 == "ctRight") {
  //     //     this.$rightEtPrice = 0;
  //     //     this.$tempRightEtPrice = 0;
  //     //   }
  //     //   if (label1 == "ctLeft") {
  //     //     this.$leftEtPrice = 0;
  //     //     this.$tempLeftEtPrice = 0;
  //     //   }
  //     //   this.getCTPrice(value, this.customerId, label1);
  //     // }
  //     // // Decentration
  //     // if (label1 == "decinLeft" || label1 == "decoutLeft") {
  //     //   this.getDecentrationPrice(value, this.customerId, "left", label1);
  //     // }
  //     // if (label1 == "decinRight" || label1 == "decoutRight") {
  //     //   this.getDecentrationPrice(value, this.customerId, "right", label1);
  //     // }
  //   // } else {
  //     // reset ct / et R/L value
  //     // if (label1 == "etRight") {
  //     //   this.$rightEtPrice = 0;
  //     //   this.$tempRightEtPrice = 0;
  //     // }
  //     // if (label1 == "ctLeft") {
  //     //   this.$leftCtPrice = 0;
  //     //   this.$tempLeftCtPrice = 0;
  //     // }
  //     // if (label1 == "ctRight") {
  //     //   this.$rightCtPrice = 0;
  //     //   this.$tempRightCtPrice = 0;
  //     // }
  //     // if (label1 == "etLeft") {
  //     //   this.$leftEtPrice = 0;
  //     //   this.$tempLeftEtPrice = 0;
  //     // }
  //   // }
  // }




   /**
   *@name getLeftDecentrationPrice
   * @param {number} decentrationId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
   getLeftDecentrationPrice(
    decinLeft: any,
    customerId: number,
  ) {
    if (decinLeft) {
      this.$leftDecPrice = 0;
      this.$tempLeftDecPrice = 0;
      this._salesService
        .getDecentrationPrice(decinLeft, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              this.bothSidesForm.get("qtyLeft").value &&
              (this.selectedTemplate == "left" ||
                this.selectedTemplate == "both")
            ) {
              this.$leftDecPrice = response.data.payload.price
                ? response.data.payload.price : 0;
              // this.$leftDecPrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyLeft").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Decentration Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempLeftDecPrice = response.data.payload.price;
          } else {
            console.error("Line: 2125 ", response.data.payload);
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message: 'Price not found...',
              type: "info",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$leftDecPrice = 0;
        this.$tempLeftDecPrice = 0;
    }
  }
    /**
   *@name getRightDecentrationPrice
   * @param {number} decentrationId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
   getRightDecentrationPrice(
    decinRight: any,
    customerId: number,
  ) {
    if (decinRight) {
        this.$rightDecPrice = 0;
      this.$tempRightDecPrice = 0;
      this._salesService
        .getDecentrationPrice(decinRight, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              this.bothSidesForm.get("qtyRight").value &&
              (this.selectedTemplate == "right" ||
                this.selectedTemplate == "both")
            ) {
              this.$rightDecPrice = response.data.payload.price
              ? response.data.payload.price : 0;
              // this.$rightDecPrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyRight").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Decentration Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempRightDecPrice = response.data.payload.price;
          } else {
            console.error("Line: 2125 ", response.data.payload);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$rightDecPrice = 0;
        this.$tempRightDecPrice = 0;
    }
  }

   /**
   *@name getRightCTPrice
   * @param {number} ctRight
   * @param {number} customerId
   * @param {string} control name
   * @returns
   * @memberof SalesService
   */
   getRightCTPrice(ctRight: any, customerId: number) {
    if (ctRight) {
      this.$rightCtPrice = 0;
      this.$tempRightCtPrice = 0;
      this._salesService
        .getCTPrice(ctRight, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              this.bothSidesForm.get("ctRight").value && 
              this.bothSidesForm.get("qtyRight").value
            ) {
              this.$rightCtPrice = response.data.payload.price
                ? response.data.payload.price : 0;
              // this.$rightCtPrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyRight").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "CT Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempRightCtPrice = response.data.payload.price;
          } else {
            console.error("Line: 2197", response.data.payload);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$rightCtPrice = 0;
        this.$tempRightCtPrice = 0;
    }
  }
   /**
   *@name getLeftCTPrice
   * @param {number} ctId
   * @param {number} customerId
   * @param {string} control name
   * @returns
   * @memberof SalesService
   */
   getLeftCTPrice(ctLeft: any, customerId: number) {
    if (ctLeft) {
      this.$leftCtPrice = 0;
      this.$tempLeftCtPrice = 0;
      this._salesService
        .getCTPrice(ctLeft, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              this.bothSidesForm.get("ctLeft").value && 
              this.bothSidesForm.get("qtyLeft").value
            ) {
              this.$leftCtPrice = response.data.payload.price ? response.data.payload.price : 0;
              // this.$leftCtPrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyLeft").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "CT Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempLeftCtPrice = response.data.payload.price;
          } else {
            console.error("Line: 2197", response.data.payload);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$leftCtPrice = 0;
        this.$tempLeftCtPrice = 0;
    }
  }

   /**
   *@name getLeftETPrice
   * @param {number} etId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
   getLeftETPrice(etLeft: any, customerId: number) {
    if (etLeft) {
      this.$leftEtPrice = 0;
      this.$tempLeftEtPrice = 0;
      this._salesService
        .getETPrice(etLeft, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              this.bothSidesForm.get("etLeft").value &&
              this.bothSidesForm.get("qtyLeft").value
            ) {
              this.$leftEtPrice = response.data.payload.price
                ? response.data.payload.price : 0;
              // this.$leftEtPrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyLeft").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "ET Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempLeftEtPrice = response.data.payload.price;
          } else {
            console.error("Line: 2272 ", response.data.payload);
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message:'Price not found...',
              type: "info",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$leftEtPrice = 0;
        this.$tempLeftEtPrice = 0;
    }
  }
   /**
   *@name getRightETPrice
   * @param {number} etId
   * @param {number} customerId
   * @returns
   * @memberof SalesService
   */
   getRightETPrice(etRight: any, customerId: number) {
    if (etRight) {
          this.$rightEtPrice = 0;
          this.$tempRightEtPrice = 0;
      this._salesService
        .getETPrice(etRight, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
            if (
              this.bothSidesForm.get("etRight").value &&
              this.bothSidesForm.get("qtyRight").value
            ) {
              this.$rightEtPrice = response.data.payload.price
                ? response.data.payload.price : 0;
              // this.$rightEtPrice = response.data.payload.price
              //   ? response.data.payload.price *
              //     this.bothSidesForm.get("qtyRight").value
              //   : response.data.payload.price;
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "ET Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            }
            this.$tempRightEtPrice = response.data.payload.price;
          } else {
            console.error("Line: 2272 ", response.data.payload);
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message:'Price not found...',
              type: "info",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
      this.$rightEtPrice = 0;
      this.$tempRightEtPrice = 0;
    }
  }
  


   /**
   *@name getPrismPrice
   * @param {number} prismGroupId
   * @param {number} customerId
   * @param {string} position
   * @param {string} control name
   * @returns
   * @memberof SalesService
   */
   getRightPrismPrice(
    prismValue: any,
    customerId: number
  ) {
    if (prismValue) {
      this.$rightPrismPrice = 0;
      this.$tempRightPrismPrice = 0;
      this._salesService
        .getPrismPrice(prismValue, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
              if (this.bothSidesForm.get("qtyRight").value) {
                this.$rightPrismPrice = response.data.payload.price;
                // this.$rightPrismPrice =
                //   response.data.payload.price *
                //   this.bothSidesForm.get("qtyRight").value;
              } else {
                this.$rightPrismPrice = 0;
              }
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Prism Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            this.$tempRightPrismPrice = response.data.payload.price;
          } else {
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message:
                "Prism price not available",
              type: "info",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$rightPrismPrice = 0;
        this.$tempRightPrismPrice = 0;
    }
  }
    /**
   *@name getLeftPrismPrice
   * @param {number} prismGroupId
   * @param {number} customerId
   * @param {string} position
   * @param {string} control name
   * @returns
   * @memberof SalesService
   */
   getLeftPrismPrice(
    prismValue: any,
    customerId: number
  ) {

    if (prismValue) {
      this.$leftPrismPrice = 0;
      this.$tempLeftPrismPrice = 0;
      this._salesService
        .getPrismPrice(prismValue, customerId, this.selectedItemCatalogObject.brandMasterId, this.selectedItemCatalogObject.materialId)
        .then((response) => {
          if (response.data.completed && response.data.payload) {
              if (this.bothSidesForm.get("qtyLeft").value) {
                this.$leftPrismPrice = response.data.payload.price;
                // this.$leftPrismPrice =
                //   response.data.payload.price *
                //   this.bothSidesForm.get("qtyLeft").value;
              } else {
                this.$leftPrismPrice = 0;
              }
              const option = {
                width: 300,
                displayTime: 3000,
                position: "bottom right",
                message:
                  "Prism Price: " +
                  response.data.payload.price +
                  " " +
                  response.data.payload.priceTypeName,
                type: "info",
              };
              notify(option);
            this.$tempLeftPrismPrice = response.data.payload.price;
          } else {
            const option = {
              width: 300,
              displayTime: 3000,
              position: "bottom right",
              message:
                "Prism price not available",
              type: "info",
            };
            notify(option);
          }
        })
        .catch((err) => {
          console.error("Error:  ", err);
        });
    } else {
        this.$leftPrismPrice = 0;
        this.$tempLeftPrismPrice = 0;
    }
  }


   /**
   * @name checkValue
   * @param {number} value
   * @param {formControlName}
   */
  checkValue(value, label: string) {
      if (label == "prismValueLeft" || label == "prismAxisLeft") {
        if (value && value !== "") {
          if (label == "prismValueLeft") {
            this.getLeftPrismPrice(value, this.customerId);
            this.bothSidesForm
            .get("prismAxisLeft")
            .setValidators([rangeValidator(0, 360, "p"), stepValidator(1), Validators.required]);
          this.bothSidesForm.get("prismAxisLeft").updateValueAndValidity();
          }
           
          
          // this.getPrismPrice(
          //   value,
          //   this.customerId,
          //   "left",
          //   label
          // );
          this.bothSidesForm.get("prismInLeft").setValue("");
          this.bothSidesForm.get("prismOutLeft").setValue("");
          this.bothSidesForm.get("prismUpLeft").setValue("");
          this.bothSidesForm.get("prismDownLeft").setValue("");
          this.bothSidesForm.get("prismInLeft").disable();
          this.bothSidesForm.get("prismOutLeft").disable();
          this.bothSidesForm.get("prismUpLeft").disable();
          this.bothSidesForm.get("prismDownLeft").disable();
        } else {
          this.bothSidesForm.get("prismInLeft").enable();
          this.bothSidesForm.get("prismOutLeft").enable();
          this.bothSidesForm.get("prismUpLeft").enable();
          this.bothSidesForm.get("prismDownLeft").enable();
          this.bothSidesForm
            .get("prismAxisLeft").clearValidators();
          this.bothSidesForm
            .get("prismAxisLeft")
            .setValidators([rangeValidator(0, 360, "p"), stepValidator(1)]);
          this.bothSidesForm.get("prismAxisLeft").updateValueAndValidity();
          this.$leftPrismPrice = 0;
        }
      }
      if (label == "prismValueRight" || label == "prismAxisRight") {
        if (value && value !== "") {
          if (label == "prismValueRight") {
            this.getRightPrismPrice(value, this.customerId);
            this.bothSidesForm
            .get("prismAxisRight")
            .setValidators([rangeValidator(0, 360, "p"), stepValidator(1), Validators.required]);
            this.bothSidesForm.get("prismAxisRight").updateValueAndValidity();
          }

          // this.getPrismPrice(
          //   value,
          //   this.customerId,
          //   "right",
          //   label
          // );
          this.bothSidesForm.get("prismInRight").setValue(null);
          this.bothSidesForm.get("prismOutRight").setValue(null);
          this.bothSidesForm.get("prismUpRight").setValue(null);
          this.bothSidesForm.get("prismDownRight").setValue(null);
          this.bothSidesForm.get("prismInRight").disable();
          this.bothSidesForm.get("prismOutRight").disable();
          this.bothSidesForm.get("prismUpRight").disable();
          this.bothSidesForm.get("prismDownRight").disable();
        } else {
          this.bothSidesForm.get("prismInRight").enable();
          this.bothSidesForm.get("prismOutRight").enable();
          this.bothSidesForm.get("prismUpRight").enable();
          this.bothSidesForm.get("prismDownRight").enable();
          this.$rightPrismPrice = 0;
          this.bothSidesForm.get("prismAxisRight").clearValidators();
          this.bothSidesForm
            .get("prismAxisRight")
            .setValidators([rangeValidator(0, 360, "p"), stepValidator(1)]);
            this.bothSidesForm.get("prismAxisRight").updateValueAndValidity();
        }
      }
  }
  // END LEFT RIGHT ROLES

  // SO ATTRIBUTE ROLES
   /**
   * @name segmentHeightRoles
   * @return void
   * @description VALIDATION SEGMENT HEIGHT
   */
  get segmentHeightRoles() {
    const isTailorMade = this.bothSidesForm.get("tailorMade").value;
    const isFitting = this.bothSidesForm.get("fitting").value;
    if (this.focalId == 2) {
      if (isFitting && isTailorMade) {
        // REQUIRED
        this.bothSidesForm.get("segmentHeight").clearValidators();
        this.bothSidesForm
          .get("segmentHeight")
          .setValidators([rangeValidator(5, 40, "p"), Validators.required]);
        this.bothSidesForm.get("segmentHeight").updateValueAndValidity();
        return true;
      } else if (isFitting) {
        // REQUIRED VALIDATION OPTIONAL
        this.bothSidesForm.get("segmentHeight").clearValidators();
        this.bothSidesForm
          .get("segmentHeight")
          .setValidators([rangeValidator(5, 40, "p")]);
        this.bothSidesForm.get("segmentHeight").updateValueAndValidity();
        return true;
      } else if (isTailorMade) {
        // REQUIRED
        this.bothSidesForm.get("segmentHeight").clearValidators();
        this.bothSidesForm
          .get("segmentHeight")
          .setValidators([rangeValidator(5, 40, "p"), Validators.required]);
        this.bothSidesForm.get("segmentHeight").updateValueAndValidity();
        return true;
      } else {
        // REQUIRED NULL
        this.bothSidesForm.get("segmentHeight").clearValidators();
        this.bothSidesForm
          .get("segmentHeight")
          .setValidators([rangeValidator(5, 40, "p")]);
        this.bothSidesForm.get("segmentHeight").updateValueAndValidity();
      }
    } else {
      // REQUIRED NULL
      this.bothSidesForm.get("segmentHeight").clearValidators();
      this.bothSidesForm
        .get("segmentHeight")
        .setValidators([rangeValidator(5, 40, "p")]);
      this.bothSidesForm.get("segmentHeight").updateValueAndValidity();
      return false;
    }
  }

  // END SO ATTRIBUTE ROLES

  // FITTING ROLE
  frameAvailableCheck(value: boolean) {
    if (value) {
      this.bothSidesForm.get("tailorWidth").setValidators([Validators.required]);
      this.bothSidesForm.get("tailorHeight").setValidators([Validators.required]);
    } else {
      this.bothSidesForm.get("tailorWidth").clearValidators();
      this.bothSidesForm.get("tailorHeight").clearValidators();
    }
    this.bothSidesForm.get("tailorWidth").updateValueAndValidity();
    this.bothSidesForm.get("tailorHeight").updateValueAndValidity();
  }
   /**
   * @name  getFittingProcessRole
   * @return void
   * @description Adding/ Removing HC	Blank issuance/QC/Tinting/HC/MC&Mirror
   */
  get getFittingProcessRole() {
    if (!this.isAdmin && !this.isSupervisor &&  
      this.salesOrderId &&
      this.salesOrderData &&
      this.salesOrderData.departmentId !==2 &&
      this.salesOrderData.holdProcess &&
      this.salesOrderData.processId > 15
    ) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * @name toggleFitting
   * @return void
   */
  toggleFitting(event) {
    this.isFitting = event.checked;
    const tailorMade = this.bothSidesForm.get("tailorMade").value;
    if (this.isFitting) {
      this.bothSidesForm.get("frameType").setValidators([Validators.required]);
      this.bothSidesForm.get("fittingTypeId").setValidators([Validators.required]);
      if (!this.salesOrderId) {
        this.bothSidesForm
                .get("fittingTypeId")
                .setValue(this.fittingList[0].fittingTypeId);
      }

    } else {
      this.$fittingPrice = 0;
      this.$tempFittingPrice = 0;
      this.bothSidesForm.get("frameType").clearValidators();
      if (!tailorMade) {
        this.bothSidesForm.get("fittingTypeId").clearValidators();
        this.bothSidesForm.get("fittingTypeId").setValue(null);
      }
      
      this.bothSidesForm.get("frameType").setValue(null);
      this.bothSidesForm.get("frameCondition").setValue(null);
      this.bothSidesForm.get("frameBrand").setValue(null);
      this.bothSidesForm.get("frameModel").setValue(null);
      this.bothSidesForm.get("frameMaterial").setValue(null);
      this.bothSidesForm.get("frameColor").setValue(null);
      this.bothSidesForm.get("frameSize").setValue(null);
      this.bothSidesForm.get("fittingLocationId").setValue(null);
      this.bothSidesForm.get("isFrameCase").setValue(false);
      this.bothSidesForm.get("tracingImage").setValue(null);
      if (!this.isFitting && !tailorMade) {
        this.bothSidesForm.get("up").setValue(null);
        this.bothSidesForm.get("temple").setValue(null);
        this.bothSidesForm.get("down").setValue(null);
        this.bothSidesForm.get("nasel").setValue(null);
      }
    }
    this.getEdgingPrice(
      this.selectedItemCatalogObject.brandMasterId,
      this.bothSidesForm.get("customerBranchId").value,
      this.selectedItemCatalogObject.indexId,
      this.selectedItemCatalogObject.materialId,
      this.bothSidesForm.get('frameType').value,
      this.bothSidesForm.get('isOurLens').value
    );
    this.bothSidesForm.get("frameType").updateValueAndValidity();
    this.bothSidesForm.get("fittingTypeId").updateValueAndValidity();
  }
   /**
   * @name toggleTailorMade
   * @return boolean and price
   */
  toggleTailorMade(event) {
    this.isTailorMade = event.checked;
    const fittingToggle = this.bothSidesForm.get("fitting").value;
    this.$tailorMadePrice = 0;
    this.$tempTailorMadePrice = 0;
    let tailerItem = null;
    this.frameAvailableCheck(this.isTailorMade);
    if (this.isTailorMade) {
      
      if (this.selectedTemplate == "both" || this.selectedTemplate == "right") {
        this.bothSidesForm
          .get("rhft")
          .setValidators([rangeValidator(10, 40, "p"), Validators.required]);
        this.bothSidesForm
          .get("ipdr")
          .setValidators([rangeValidator(15, 40, "p"), Validators.required]);
      }
      if (this.selectedTemplate == "both" || this.selectedTemplate == "left") {
        this.bothSidesForm
          .get("lhft")
          .setValidators([rangeValidator(10, 40, "p"), Validators.required]);
        this.bothSidesForm
          .get("ipdl")
          .setValidators([rangeValidator(15, 40, "p"), Validators.required]);
      }
        this.bothSidesForm.get("frameType").setValidators([Validators.required]);
      
      // if (!this.salesOrderId) {
      //   this.bothSidesForm
      //           .get("fittingTypeId")
      //           .setValue(this.fittingList[0].fittingTypeId);
      // }

      this.bothSidesForm
        .get("dbl")
        .setValidators([rangeValidator(8, 30, "p"), Validators.required]);

      this.bothSidesForm.get("diameterRight").setValue(null);
      this.bothSidesForm.get("diameterLeft").setValue(null);
      this.bothSidesForm.get("diameterLeft").clearValidators();
      this.bothSidesForm.get("diameterRight").clearValidators();
      this.bothSidesForm
        .get("diameterLeft")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm
        .get("diameterRight")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm.get("diameterRight").disable();
      this.bothSidesForm.get("diameterLeft").disable();
      this.bothSidesForm.get("isOvalRight").setValue(false);
      this.bothSidesForm.get("isOvalLeft").setValue(false);
      this.bothSidesForm.get("isOvalRight").disable();
      this.bothSidesForm.get("isOvalLeft").disable();
      this.bothSidesForm.get("ovalHeightRight").setValue(null);
      this.bothSidesForm.get("ovalWidthRight").setValue(null);
      this.bothSidesForm.get("ovalHeightLeft").setValue(null);
      this.bothSidesForm.get("ovalWidthLeft").setValue(null);

      this.bothSidesForm.get("ovalWidthLeft").clearValidators();
      this.bothSidesForm.get("ovalHeightLeft").clearValidators();
      this.bothSidesForm.get("ovalWidthRight").clearValidators();
      this.bothSidesForm.get("ovalHeightRight").clearValidators();
      this.bothSidesForm.get("ovalWidthLeft").disable();
      this.bothSidesForm.get("ovalHeightLeft").disable();
      this.bothSidesForm.get("ovalWidthRight").disable();
      this.bothSidesForm.get("ovalHeightRight").disable();
      this.bothSidesForm
        .get("ovalWidthLeft")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm
        .get("ovalHeightLeft")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm
        .get("ovalWidthRight")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.bothSidesForm
        .get("ovalHeightRight")
        .setValidators([rangeValidator(48, 80, "p"), stepValidator(1)]);
      this.$leftOval = 0;
      this.$tempLeftOval = 0;
      this.$rightOval = 0;
      this.$tempRightOval = 0;
    } else {
      if (!fittingToggle) {
        this.bothSidesForm.get("frameType").clearValidators();
        this.bothSidesForm.get("frameType").setValue(null);
        this.$tempFittingPrice = 0;
        this.$fittingPrice = 0;
        
      }
      this.bothSidesForm.get("lhft").clearValidators();
      this.bothSidesForm
        .get("lhft")
        .setValidators([rangeValidator(10, 40, "p")]);
      this.bothSidesForm.get("rhft").clearValidators();
      this.bothSidesForm
        .get("rhft")
        .setValidators([rangeValidator(10, 40, "p")]);

      this.bothSidesForm.get("ipdr").clearValidators();
      this.bothSidesForm.get("ipdl").clearValidators();
      this.bothSidesForm
        .get("ipdr")
        .setValidators([rangeValidator(15, 40, "p")]);
      this.bothSidesForm
        .get("ipdl")
        .setValidators([rangeValidator(15, 40, "p")]);

      this.bothSidesForm.get("dbl").clearValidators();
      this.bothSidesForm.get("dbl").setValidators([rangeValidator(8, 30, "p")]);
      this.bothSidesForm.get("dbl").setValue(null);
      this.bothSidesForm.get("lensReference").setValue(null);
      if (!fittingToggle && !this.isTailorMade) {
        this.bothSidesForm.get("up").setValue(null);
        this.bothSidesForm.get("temple").setValue(null);
        this.bothSidesForm.get("down").setValue(null);
        this.bothSidesForm.get("nasel").setValue(null);
      }
      this.bothSidesForm.get("frameAvailable").setValue(false);
      this.bothSidesForm.get("diameterRight").enable();
      this.bothSidesForm.get("diameterLeft").enable();
      this.bothSidesForm.get("diameterLeft").clearValidators();
      this.bothSidesForm.get("diameterRight").clearValidators();
      if (this.selectedTemplate == "both" || this.selectedTemplate == "right") {
        this.bothSidesForm
          .get("diameterRight")
          .setValidators([
            rangeValidator(48, 80, "p"),
            stepValidator(1),
            Validators.required,
          ]);
      }
      if (this.selectedTemplate == "both" || this.selectedTemplate == "left") {
        this.bothSidesForm
          .get("diameterLeft")
          .setValidators([
            rangeValidator(48, 80, "p"),
            stepValidator(1),
            Validators.required,
          ]);
      }

      this.bothSidesForm.get("isOvalRight").enable();
      this.bothSidesForm.get("isOvalLeft").enable();
      
    }
    if (this.isTailorMade && !fittingToggle) {
      this.$fittingPrice = 0;
      this.$tempFittingPrice = 0;
    }
    // TAILOR MADE PRICING
    if (this.isTailorMade) {
      
      if (this.otherServicesData && this.otherServicesData.length > 0) {
        tailerItem = this.otherServicesData.find(
          (item) => item.otherServiceMasterId == 5
        );
        if (
          this.bothSidesForm.get("qtyLeft").value &&
          this.selectedTemplate == "left"
        ) {
          this.$tailorMadePrice =
            tailerItem && tailerItem.price
              ? tailerItem.price : 0;
          // this.$tailorMadePrice =
          //   tailerItem && tailerItem.price
          //     ? tailerItem.price * this.bothSidesForm.get("qtyLeft").value
          //     : 0;
        } else if (
          this.bothSidesForm.get("qtyRight").value &&
          this.selectedTemplate == "right"
        ) {
          this.$tailorMadePrice =
            tailerItem && tailerItem.price
              ? tailerItem.price : 0;
          // this.$tailorMadePrice =
          //   tailerItem && tailerItem.price
          //     ? tailerItem.price * this.bothSidesForm.get("qtyRight").value
          //     : 0;
        } else {
          this.$tailorMadePrice =
            tailerItem && tailerItem.price
              ? tailerItem.price : 0;
          // this.$tailorMadePrice =
          //   this.selectedTemplate == "both"
          //     ? (tailerItem && tailerItem.price ? tailerItem.price : 0) *
          //       this.bothSidesForm.get("qtyRight").value *
          //       2
          //     : tailerItem && tailerItem.price
          //     ? tailerItem.price
          //     : 0;
        }
        this.$tempTailorMadePrice =
          tailerItem && tailerItem.price ? tailerItem.price : 0;
        if (tailerItem && tailerItem.price) {
          const option = {
            width: 300,
            displayTime: 3000,
            position: "bottom right",
            message:
              "Tailor Made Price: " +
              tailerItem.price +
              " " +
              "OPL Service Price",
            type: "info",
          };
          notify(option);
          // this.bothSidesForm.get("tailorMade").setErrors(null);
        } else {
        // setTimeout(() => {
        //    this.bothSidesForm.get("tailorMade").setErrors({ price: true });
        // }, 50);
        }
        
      } else {
        this.$tailorMadePrice = 0;
        this.$tempTailorMadePrice = 0;
        // setTimeout(() => {
        //   this.bothSidesForm.get("tailorMade").setErrors({ price: true });
        // }, 50);
        
      }
    } else {
      this.$tailorMadePrice = 0;
      this.$tempTailorMadePrice = 0;
      // setTimeout(() => {
      //   this.bothSidesForm.get("tailorMade").setErrors(null);
      // }, 50);
      
      
    }

   
    // END TAILOR MADE PRICING

    this.bothSidesForm.get("lhft").updateValueAndValidity();
    this.bothSidesForm.get("rhft").updateValueAndValidity();
    this.bothSidesForm.get("ipdr").updateValueAndValidity();
    this.bothSidesForm.get("ipdl").updateValueAndValidity();
    this.bothSidesForm.get("dbl").updateValueAndValidity();
    this.bothSidesForm.get("diameterRight").updateValueAndValidity();
    this.bothSidesForm.get("diameterLeft").updateValueAndValidity();
    this.bothSidesForm.get("ovalWidthLeft").updateValueAndValidity();
    this.bothSidesForm.get("ovalHeightLeft").updateValueAndValidity();
    this.bothSidesForm.get("ovalWidthRight").updateValueAndValidity();
    this.bothSidesForm.get("ovalHeightRight").updateValueAndValidity();
    this.bothSidesForm.get("frameType").updateValueAndValidity();
    // this.bothSidesForm.get("tailorMade").updateValueAndValidity();
  }
  // END

  /**
   * @name removeImage
   * @return void
   * @description reset image
   */
  removeImage() {
    $("#imgInput").val("");
    this.imageView = null;
    this.bothSidesForm.get("tracingImage").setValue("");
    this.bothSidesForm.get("tracingImageName").setValue("");
  }

  /**
   * @name refreshUrl
   * @return void
   */
  refreshUrl(): void {
    window.location.href = "/portal/sales/stock-sale-order/job-order";
  }

  /**
   * @name validateSalesOrder
   * @method POST
   * @return Promise
   * @description validation for dublicate sale order checking
   */
  openNav() {
    if (this.isPricePanel) {
      document.getElementById("mySidenav1").style.width = "0";
      document.getElementById("main1").style.marginLeft = "0";
      document.body.style.backgroundColor = "white";
      this.isPricePanel = false;
    } else {
      document.getElementById("mySidenav1").style.width = "330px";
      document.getElementById("main1").style.marginLeft = "330px";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
      this.isPricePanel = true;
    }
  }

  /**
   * @name validateSalesOrder
   * @param {formdata}
   * @return boolean and msg
   */
  validateSalesOrder(data) {
    return new Promise((resolve: any, reject: any) => {
      this.loadingIndicator = true;
      let orderLens = [];
      const payload = {
        customerId: this.customerId,
      };
      if (this.selectedTemplate == "left") {
        orderLens.push({
          itemCatalogGroupId: data.itemCatalogGroupId,
          isTranspose: data.isTranspose ? data.isTranspose : false,
          sph: data.sphLeft,
          cyl: data.cylLeft,
          addf: data.addfLeft,
          lensSideId: 1,
        });
      }
      if (this.selectedTemplate == "right") {
        orderLens.push({
          itemCatalogGroupId: data.itemCatalogGroupId,
          isTranspose: data.isTranspose ? data.isTranspose : false,
          sph: data.sphRight,
          cyl: data.cylRight,
          addf: data.addfRight,
          lensSideId: 2,
        });
      }
      if (this.selectedTemplate == "both") {
        orderLens.push(
          {
            itemCatalogGroupId: data.itemCatalogGroupId,
            isTranspose: data.isTranspose ? data.isTranspose : false,
            sph: data.sphLeft,
            cyl: data.cylLeft,
            addf: data.addfLeft,
            lensSideId: 1,
          },
          {
            itemCatalogGroupId: data.itemCatalogGroupId,
            isTranspose: data.isTranspose ? data.isTranspose : false,
            sph: data.sphRight,
            cyl: data.cylRight,
            addf: data.addfRight,
            lensSideId: 2,
          }
        );
      }
      payload["salesOrderLens"] = orderLens;
      this._salesService
        .validateSalesOrder(payload)
        .then((response: any) => {
          if (response.data.completed) {
            this.loadingIndicator = false;
            // RESOLVE TRUE
            resolve("continue");
          } else {
            this.loadingIndicator = false;
            this.saveSwal.swalOptions = {
              icon: "error",
              titleText: response.data.message,
              showConfirmButton: true,
              confirmButtonText: "Yes",
              showCancelButton: true,
              cancelButtonText: "No",
              allowOutsideClick: false,
              allowEscapeKey: false,
            };
            this.saveSwal.fire().then((res: any) => {
              if (res.value) {
                // RESOLVE CONTINUE
                resolve("continue");
              } else {
                // RESOLVE FALSE AND NOT ROUTE
                resolve("reject");
              }
            });
          }
        })
        .catch((error) => {
          this.loadingIndicator = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: error.message,
            type: "error",
          };
          notify(option);
        });
    });
  }



  /**
   * @name generateSalesOrderReport
   * @returns void
   * @description Generate Report
   */
   generateSalesOrderReport(saleOrderId: number, isUpdate: boolean) {
    this._salesService
      .generateSalesOrderReport(saleOrderId, isUpdate)
      .then((res: any) => {
        console.log("Report Successfully Generate");
      })
      .catch((error) => {
        const option = {
          width: 300,
          displayTime: 5000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }



  /**
   * @name savebothSidesForm
   * @param {FormGroup} form
   * @return form
   */
  savebothSidesForm(form: FormGroup) {
    if (form.invalid) {
      Object.keys(this.bothSidesForm.controls).forEach((key) => {
        this.bothSidesForm.get(key).markAsTouched();
      });
      this.allRequiredErrorShow = true;
      return false;
    }
    this.allRequiredErrorShow = false;
    this.loadingIndicator = true;
    this.setPriceForForm();
    if (!this.salesOrderId) {
      this.validateSalesOrder(form.value).then((res) => {
        if (res == "continue") {
          this.savePayloadToServer(form.value);
        } else {
          // NOTHING CALL
          this.loadingIndicator = false;
          return;
        }
      });
    } else {
      this.savePayloadToServer(form.value);
    }
  }

  /**
   * @name setPriceForForm
   * @return void
   * @description set price in form control
   */
  setPriceForForm(): void {
    this.bothSidesForm.addControl(
      "discountPrice",
      new FormControl(this.$discountPrice ? this.$discountPrice : 0)
    );
    this.bothSidesForm.addControl(
      "additionalPrice",
      new FormControl(this.$additionalPrice ? this.$additionalPrice : 0)
    );
    this.bothSidesForm.addControl(
      "rightDecPrice",
      new FormControl(this.$rightDecPrice ? this.$rightDecPrice : 0)
    );
    this.bothSidesForm.addControl(
      "rightOval",
      new FormControl(this.$rightOval ? this.$rightOval : 0)
    );
    this.bothSidesForm.addControl(
      "leftOval",
      new FormControl(this.$leftOval ? this.$leftOval : 0)
    );
    this.bothSidesForm.addControl(
      "hcPrice",
      new FormControl(this.$hcPrice ? this.$hcPrice : 0)
    );
    this.bothSidesForm.addControl(
      "specialLogo",
      new FormControl(this.$specialLogo ? this.$specialLogo : 0)
    );
    this.bothSidesForm.addControl(
      "lensePriceRight",
      new FormControl(this.$lensePriceRight ? this.$lensePriceRight : 0)
    );
    this.bothSidesForm.addControl(
      "lensePriceLeft",
      new FormControl(this.$lensePriceLeft ? this.$lensePriceLeft : 0)
    );
    this.bothSidesForm.addControl(
      "coatingPrice",
      new FormControl(this.$coatingPrice ? this.$coatingPrice : 0)
    );
    this.bothSidesForm.addControl(
      "tintPrice",
      new FormControl(this.$tintPrice ? this.$tintPrice : 0)
    );
    this.bothSidesForm.addControl(
      "leftPrismPrice",
      new FormControl(this.$leftPrismPrice ? this.$leftPrismPrice : 0)
    );
    this.bothSidesForm.addControl(
      "rightBaseCurvePrice",
      new FormControl(this.$rightBaseCurvePrice ? this.$rightBaseCurvePrice : 0)
    );
    this.bothSidesForm.addControl(
      "rightPrismPrice",
      new FormControl(this.$rightPrismPrice ? this.$rightPrismPrice : 0)
    );
    this.bothSidesForm.addControl(
      "leftDecPrice",
      new FormControl(this.$leftDecPrice ? this.$leftDecPrice : 0)
    );
    this.bothSidesForm.addControl(
      "tailorMadePrice",
      new FormControl(this.$tailorMadePrice ? this.$tailorMadePrice : 0)
    );
    this.bothSidesForm.addControl(
      "selectedOtherServicePrice",
      new FormControl(this.$selectedOtherServicePrice
        ? this.$selectedOtherServicePrice
        : 0)
    );
    this.bothSidesForm.addControl(
      "fittingPrice",
      new FormControl(this.$fittingPrice ? this.$fittingPrice : 0)
    );
    this.bothSidesForm.addControl(
      "leftCtPrice",
      new FormControl(this.$leftCtPrice ? this.$leftCtPrice : 0)
    );
    this.bothSidesForm.addControl(
      "leftEtPrice",
      new FormControl(this.$leftEtPrice ? this.$leftEtPrice : 0)
    );

    this.bothSidesForm.addControl(
      "mirrorPrice",
      new FormControl(this.$mirrorPrice ? this.$mirrorPrice : 0)
    );
    this.bothSidesForm.addControl(
      "leftBaseCurvePrice",
      new FormControl(this.$leftBaseCurvePrice ? this.$leftBaseCurvePrice : 0)
    );
    this.bothSidesForm.addControl(
      "rightEtPrice",
      new FormControl(this.$rightEtPrice ? this.$rightEtPrice : 0)
    );
    this.bothSidesForm.addControl(
      "rightCtPrice",
      new FormControl(this.$rightCtPrice ? this.$rightCtPrice : 0)
    );
    this.bothSidesForm.addControl(
      "engraveName",
      new FormControl(this.$engraveName ? this.$engraveName : 0)
    );
    this.bothSidesForm.addControl(
      "rightUnitPrice",
      new FormControl(this.$rightFittingPrice ? this.$rightFittingPrice : 0)
    );

    // let totalAmount =
    //   this.$rightDecPrice +
    //   this.$rightOval +
    //   this.$leftOval +
    //   this.$hcPrice +
    //   this.$specialLogo +
    //   this.$lensePriceRight +
    //   this.$lensePriceLeft +
    //   this.$coatingPrice +
    //   this.$tintPrice +
    //   this.$leftPrismPrice +
    //   this.$rightBaseCurvePrice +
    //   this.$rightPrismPrice +
    //   this.$leftDecPrice +
    //   this.$tailorMadePrice +
    //   this.$selectedOtherServicePrice +
    //   this.$fittingPrice +
    //   this.$rightFittingPrice +
    //   this.$leftCtPrice +
    //   this.$leftEtPrice +
    //   this.$mirrorPrice +
    //   this.$leftBaseCurvePrice +
    //   this.$rightEtPrice +
    //   this.$rightCtPrice +
    //   this.$engraveName;
    this.bothSidesForm.get("totalAmount").setValue(this.$Total);
  }

  /**
   * @name savePayloadToServer
   * @returns saving data to server
   * @descript Sale Both and Left Right Data
   */
  savePayloadToServer(data) {
    this.loadingIndicator = true;
    let totalAmount = 0;
    this.hideSubmitBtn = true;
    let payload = null;
    let salesOrderJob = [];
    let salesOrderLens = [];
    let loggedInBranchId = JSON.parse(
      localStorage.getItem("selectedCustomerBranch")
    ).companyBranchId;
    // totalAmount = data.totalAmount + data.additionalPrice - data.discountPrice;
    data.lensePriceLeft = this.$lensePriceLeft;
    data.lensePriceRight = this.$lensePriceRight;
    data.leftPrismPrice = this.$leftPrismPrice;
    data.rightPrismPrice = this.$rightPrismPrice;
    data.leftCtPrice = this.$leftCtPrice;
    data.rightCtPrice = this.$rightCtPrice;
    data.leftEtPrice = this.$leftEtPrice;
    data.rightEtPrice = this.$rightEtPrice;
    data.leftDecPrice = this.$leftDecPrice;
    data.rightDecPrice = this.$rightDecPrice;
    data.leftBaseCurvePrice = this.$leftBaseCurvePrice;
    data.rightBaseCurvePrice = this.$rightBaseCurvePrice;
    data.leftOval = this.$leftOval;
    data.rightOval = this.$rightOval;
    data.fittingPrice = this.$fittingPrice;
    data.unitPrice = this.$fittingPrice;
    data.totalLensPrice = this.$subTotalLeft;
    data.mirrorPrice = this.$mirrorPrice;
    data.specialLogo = this.$specialLogo;
    data.engraveName = this.$engraveName;
    data.discountPrice = this.$discountPrice;
    data.selectedOtherServicePrice = this.$selectedOtherServicePrice;
    data.tailorMadePrice = this.$tailorMadePrice;
    data.tintPrice = this.$tintPrice;
    data.hcPrice = this.$hcPrice;
    data.coatingPrice = this.$coatingPrice;
    data.additionalPrice = this.$additionalPrice;
    totalAmount = data.totalAmount;
    payload = {
      isClient: true,
      salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
      salesOrderReportFile: this.salesOrderData ? data.customerBranchId : 0, //(this.salesOrderData.departmentId == 2 ? null : this.salesOrderData.salesOrderReportFile) : null,
      salesOrderDate: this.appCons.getDate(),
      baseSalesOrderId: this.salesOrderData && this.salesOrderData.baseSalesOrderId  ? this.salesOrderData.baseSalesOrderId : 0,//(!this.salesOrderId && this.bothSidesForm.get('salesId').value) ? this.bothSidesForm.get('salesId').value : 0,
      customerId: this.customerId,
      holdSalesOrder: false,
      companyId: JSON.parse(localStorage.getItem("selectedCustomerBranch")).companyId,
      customerBranchId: data.customerBranchId,
      customerContactId: data.customerContactId,
      salesOrderTypeId: 5,
      brandMasterId: data.brandMasterId,
      itemCatalogGroupId: 0, // please remove
      isOurLens: data.isOurLens, // please remove
      cutUncutLensId: 0, // please remove
      patientName: data.patientName,
      customerTypeId: data.customerTypeId,
      urgencyTypeId: data.urgencyType,
      ponumber: data.ponumber,
      partnerOrderNumber: data.partnerOrderNumber,
      instruction: data.instruction,
      isWaitforSample: data.isWaitforSample,
      remarks: data.remarks,
      totalAmount: totalAmount ? totalAmount : 0,
      companyBranchId: JSON.parse(
        localStorage.getItem("selectedCustomerBranch")
      ).plantId,
      createdByBranchId: loggedInBranchId,
      tailorMadePrice: data.tailorMadePrice, // data.priceSource.tailor,
      additionalPrice: data.additionalPrice,
      discountPrice: data.discountPrice,
      customerAge: data.age,
      specialBase: data.specialBase,
      isCombo: this.isComboPrice,
      salesOrderDetail: {
        salesOrderJobCustomizeInfo: {
          salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
          salesOrderJobCustomizeInfoId: this.salesOrderId
            ? (data.salesOrderJobCustomizeInfoId ? data.salesOrderJobCustomizeInfoId : 0)
            : 0,
          lensShapeId: data.lensShapeId ? data.lensShapeId : 0, // data.shape,
          lensShapeCode: "nothing use", // not use in html
          lensShapeName: data.lensReference, // not use in html
          lensNoseB: 0.0, // not use in html
          rhft: data.rhft,
          lhft: data.lhft,
          bvd: data.bvd,
          pa: data.pa,
          wrap: data.wrap,
          nwd: data.nwd,
          ffv: data.ffv,
          mid: data.mid,
          // age: data.age,
          // confusion price of what
          price: 0,
          dbl: data.dbl,
          ipdr: data.ipdr,
          ipdl: data.ipdl,
          segmentHeight: data.segmentHeight,
          minThk: data.minTHK,
          maxThk: data.maxTHK,
          templeThk: data.thkTample,
          noseThk: data.thkNose,
          addDateTime: new Date(),
          addUserId: JSON.parse(localStorage.getItem("userData")).id,
          updateDateTime: new Date(),
          updateUserId: JSON.parse(localStorage.getItem("userData")).id,
          active: true,
        },
        salesOrderFrameFitting: {
          salesOrderFrameFittingId: this.salesOrderId
            ? (data.salesOrderFrameFittingId ? data.salesOrderFrameFittingId : 0)
            : 0,
          salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
          frameConditionId: data.frameCondition,
          fittingTypeId: data.fittingTypeId ? data.fittingTypeId : 0,
          frameId: data.frameType ? data.frameType : 0,
          frameTypeId: data.frameType ? data.frameType : 0,
          rightFittingTypeId: data.rightFittingTypeId
            ? data.rightFittingTypeId
            : 0,
          rightFrameTypeId: data.rightFrameTypeId ? data.rightFrameTypeId : 0,
          // brandMasterId: 0,
          frameBrandName: data.frameBrand,
          frameModel: data.frameModel,
          modelId: data.modelId,
          frameBase: 0,
          materialId: data.frameMaterial,
          colorMasterId: data.frameColor,
          isFrameCase: data.isFrameCase,
          isTracing: data.isTracing ? data.isTracing : false,
          tracingPath: data.tracingImage,
          fileName: data.tracingImageName,
          unitPrice: data.fittingPrice ? data.fittingPrice : 0,
          rightUnitPrice: data.rightUnitPrice ? data.rightUnitPrice : 0,
          fittingLocationId: data.fittingLocationId,
          isFitting: data.fitting,
          isTailorMade: data.tailorMade,
          lensReference: data.lensReference ? data.lensReference : null,
          frameAvailable: data.frameAvailable ? data.frameAvailable : false,
          shape: data.shape ? data.shape : null,
          tailorWidth: data.tailorWidth ? data.tailorWidth : null,
          tailorHeight: data.tailorHeight ? data.tailorHeight : null,
          up: data.up,
          down: data.down,
          temple: data.temple,
          nasel: data.nasel,
          frameSize: data.frameSize ? data.frameSize : null,
          accurateIPD: data.accurateIPD ? data.accurateIPD : false,
          isReceived: null,
          inspectionRemarks: null,
          inspectionDate: null,
          edgerId: null,
          isFrameBroken: null,
          qCDate: null,
          circumference: data.circumference,
          addDateTime: new Date(),
          addUserId: JSON.parse(localStorage.getItem("userData")).id,
          updateDateTime: new Date(),
          updateUserId: JSON.parse(localStorage.getItem("userData")).id,
          active: true,
        },
        salesOrderService:{
          salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
          salesOrderServiceId: this.salesOrderId
            ? (data.salesOrderServiceId ? data.salesOrderServiceId : 0)
            : 0,
          hcoatingId: data.hc,
          hcprice: data.hcPrice ? data.hcPrice : 0,
          hclocationBranchId: data.hcLocation,
          isBackOnly: data.backOnly,
          coatingBrandId: this.bothSidesForm.get('coat').value,
          coatingPrice: data.coatingPrice ? data.coatingPrice : 0,
          coatingLocationBranchId: data.coatingLocation,
          mirrorId: this.bothSidesForm.get('mirror').value,
          mirrorPrice: data.mirrorPrice ? data.mirrorPrice : 0,
          tintId: this.bothSidesForm.get('tintType').value,
          color1Id: data.color1,
          color2Id: data.color2,
          col1RefColId: 0,
          col2RefColId: 0,
          tintPercentage: data.percentage,
          tintLocationBranchId: data.tintLocation,
          tintPrice: data.tintPrice ? data.tintPrice : 0,
          otherServicesId: data.otherServices ? data.otherServices : 0,
          nameCode: data.nameCode ? data.nameCode : '',
          engraveId: data.engraveId ? data.engraveId : 0,
          otherServicePrice: data.selectedOtherServicePrice
            ? data.selectedOtherServicePrice
            : 0,
          specialLogoPrice: data.specialLogo
            ? data.specialLogo
            : 0,
          engraveNamePrice: data.engraveName
            ? data.engraveName
            : 0,
          leftCoatingPrice: this.$coatingPriceLeft ? this.$coatingPriceLeft : 0,
          rightCoatingPrice: this.$coatingPriceRight ?  this.$coatingPriceRight : 0,
          leftMirrorPrice: this.$mirrorPriceLeft ? this.$mirrorPriceLeft : 0,
          rightMirrorPrice: this.$mirrorPriceRight ? this.$mirrorPriceRight : 0,
          leftTintPrice: this.$tintPriceLeft ? this.$tintPriceLeft : 0,
          rightTintPrice: this.$tintPriceRight ? this.$tintPriceRight : 0,
          addDateTime: this.appCons.getDate(),
          addUserId: this.appCons.getUserId(),
          updateDateTime: this.appCons.getDate(),
          updateUserId: this.appCons.getUserId(),
          active: true,
        },
        addDateTime: this.appCons.getDate(),
        addUserId: this.appCons.getUserId(),
        updateDateTime: this.appCons.getDate(),
        updateUserId: this.appCons.getUserId(),
        active: true,
      },
      addDateTime: this.appCons.getDate(),
      addUserId: this.appCons.getUserId(),
      updateDateTime: this.appCons.getDate(),
      updateUserId: this.appCons.getUserId(),
      active: true,
      freeFitting:this.customerList.find((item) => item.customerId == this.customerId)?.freeFitting
    };
    if (this.selectedTemplate == "both") {
      salesOrderJob.push(
        {
          salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
          salesOrderJobId: this.salesOrderId ? (data.rightSalesOrderJobId ? data.rightSalesOrderJobId : 0) : 0,
          // salesOrderTypeId:  this.addSaleForm.get('salesOrderTypeId').value,
          size: this.bothSidesForm.get('diameterRight').value,
          sizePrice: 0,
          lensSideId: 2,
          isOval: data.isOvalRight,
          ovalWidth: data.ovalWidthRight,
          ovalHight: data.ovalHeightRight,
          ovalPrice: data.rightOval ? data.rightOval : 0,
          sph: data.sphRight,
          cyl: data.cylRight,
          axis: data.axisRight,
          addf: data.addfRight,
          ipd: data.ipdRight,
          // confusion about input field
          qty: data.qtyRight,
          lensPrice: data.lensePriceRight ? data.lensePriceRight : 0,
          prismIn: data.prismInRight,
          prismOut: data.prismOutRight,
          prismUp: data.prismUpRight,
          prismDown: data.prismDownRight,
          prismValue: data.prismValueRight,
          prismAxis: data.prismAxisRight,
          // confusion no fields exists
          prismRate: data.rightPrismPrice ? data.rightPrismPrice : 0,
          prismBase: data.baseCurveRight,
          baseCurvePrice: data.rightBaseCurvePrice
            ? data.rightBaseCurvePrice
            : 0,
          isLowerBase: true,
          // confusion no fields exists
          decin: data.decinRight,
          decout: data.decoutRight,
          decprice: data.rightDecPrice ? data.rightDecPrice : 0,
          et: data.etRight,
          ct: data.ctRight,
          ectctprice: data.rightEtPrice
            ? data.rightEtPrice
            : data.rightCtPrice
            ? data.rightCtPrice
            : 0,
            addDateTime: this.appCons.getDate(),
            addUserId: this.appCons.getUserId(),
            updateDateTime: this.appCons.getDate(),
            updateUserId: this.appCons.getUserId(),
          active: true,
        },
        {
          salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
          salesOrderJobId: this.salesOrderId ? (data.leftSalesOrderJobId ? data.leftSalesOrderJobId : 0) : 0,
          // salesOrderTypeId:  this.addSaleForm.get('salesOrderTypeId').value,
          size: this.bothSidesForm.get('diameterLeft').value,
          sizePrice: 0,
          lensSideId: 1,
          isOval: data.isOvalLeft,
          ovalWidth: data.ovalWidthLeft,
          ovalHight: data.ovalHeightLeft,
          ovalPrice: data.leftOval ? data.leftOval : 0,
          sph: data.sphLeft,
          cyl: data.cylLeft,
          axis: data.axisLeft,
          addf: data.addfLeft,
          ipd: data.ipdLeft,
          // confusion about input field
          qty: data.qtyLeft,
          lensPrice: data.lensePriceLeft ? data.lensePriceLeft : 0,
          prismIn: data.prismInLeft,
          prismOut: data.prismOutLeft,
          prismUp: data.prismUpLeft,
          prismDown: data.prismDownLeft,
          prismValue: data.prismValueLeft,
          prismAxis: data.prismAxisLeft,
          // confusion no fields exists
          prismRate: data.leftPrismPrice ? data.leftPrismPrice : 0,
          prismBase: data.baseCurveLeft,
          baseCurvePrice: data.leftBaseCurvePrice ? data.leftBaseCurvePrice : 0,
          isLowerBase: true,
          // confusion no fields exists
          decin: data.decinLeft,
          decout: data.decoutLeft,
          decprice: data.leftDecPrice ? data.leftDecPrice : 0,
          et: data.etLeft,
          ct: data.ctLeft,
          ectctprice: data.leftEtPrice
            ? data.leftEtPrice
            : data.leftCtPrice
            ? data.leftCtPrice
            : 0,
          addDateTime: this.appCons.getDate(),
          addUserId: this.appCons.getUserId(),
          updateDateTime: this.appCons.getDate(),
          updateUserId: this.appCons.getUserId(),
          active: true,
        }
      );
      salesOrderLens.push(
        {
          // tslint:disable-next-line:radix
          salesOrderId: this.salesOrderId ? parseInt(this.salesOrderId) : 0,
          salesOrderLensId: this.salesOrderId ? (data.leftSalesOrderLensId ? data.leftSalesOrderLensId : 0) : 0,
          itemCatalogGroupId: data.itemCatalogGroupId,
          vendorItemCatalogId: 0,
          lensSideId: 1,
          sph: data.sphLeft,
          cyl: data.cylLeft,
          addf: data.addfLeft,
          qty: data.qtyLeft,
          unitPrice: data.lensePriceLeft ? data.lensePriceLeft : 0,
          size: this.bothSidesForm.get('diameterLeft').value,
          axis: data.axisLeft,
          uomId: 2,
          mplDetailId: data.leftmpldetailId,
          excludeBrandDiscount: data.leftexcludebranddiscount,
          pricingTypeId: data.leftpricingTypeId,
          isOurLens: data.isOurLens, // please remove
          cutUncutLensId: data.cutUncutLensId ? data.cutUncutLensId : 0,
          totalLensPrice: this.$subTotalLeft,
          addDateTime: this.appCons.getDate(),
          addUserId: this.appCons.getUserId(),
          updateDateTime: this.appCons.getDate(),
          updateUserId: this.appCons.getUserId(),
          active: true,
        },
        {
          // tslint:disable-next-line:radix
          salesOrderId: this.salesOrderId ? parseInt(this.salesOrderId) : 0,
          salesOrderLensId: this.salesOrderId ? (data.rightSalesOrderLensId ? data.rightSalesOrderLensId : 0) : 0,
          itemCatalogGroupId: data.itemCatalogGroupId,
          vendorItemCatalogId: 0,
          lensSideId: 2,
          size: this.bothSidesForm.get('diameterRight').value,
          sph: data.sphRight,
          cyl: data.cylRight,
          addf: data.addfRight,
          qty: data.qtyRight,
          uomId: 2,
          mplDetailId: data.rightmpldetailId,
          excludeBrandDiscount: data.rightexcludebranddiscount,
          pricingTypeId: data.rightpricingTypeId,
          unitPrice: data.lensePriceRight ? data.lensePriceRight : 0,
          axis:  data.axisRight,
          isOurLens: data.isOurLens, // please remove
          cutUncutLensId: data.rightCutUncutLensId
            ? data.rightCutUncutLensId
            : 0,
          totalLensPrice: this.$subTotalRight,
          addDateTime: this.appCons.getDate(),
          addUserId: this.appCons.getUserId(),
          updateDateTime: this.appCons.getDate(),
          updateUserId: this.appCons.getUserId(),
          active: true,
        }
      );
      payload.salesOrderDetail["salesOrderJob"] = salesOrderJob;
      payload.salesOrderDetail["salesOrderLens"] = salesOrderLens;
    }
    if (this.selectedTemplate == "left") {
      salesOrderJob.push({
        salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
        salesOrderJobId: this.salesOrderId ? (data.leftSalesOrderJobId ? data.leftSalesOrderJobId : 0) : 0,
        // salesOrderTypeId:  this.addSaleForm.get('salesOrderTypeId').value,
        size: this.bothSidesForm.get('diameterLeft').value,
        sizePrice: 0,
        lensSideId: 1,
        isOval: data.isOvalLeft,
        ovalWidth: data.ovalWidthLeft,
        ovalHight: data.ovalHeightLeft,
        ovalPrice: data.leftOval ? data.leftOval : 0,
        sph: data.sphLeft,
        cyl: data.cylLeft,
        axis: data.axisLeft,
        addf: data.addfLeft,
        ipd: data.ipdLeft,
        // confusion about input field
        qty: data.qtyLeft,
        lensPrice: data.lensePriceLeft ? data.lensePriceLeft : 0,
        prismIn: data.prismInLeft,
        prismOut: data.prismOutLeft,
        prismUp: data.prismUpLeft,
        prismDown: data.prismDownLeft,
        prismValue: data.prismValueLeft,
        prismAxis: data.prismAxisLeft,
        // confusion no fields exists
        prismRate: data.leftPrismPrice ? data.leftPrismPrice : 0,
        prismBase: data.baseCurveLeft,
        baseCurvePrice: data.leftBaseCurvePrice ? data.leftBaseCurvePrice : 0,
        isLowerBase: true,
        // confusion no fields exists
        decin: data.decinLeft,
        decout: data.decoutLeft,
        decprice: data.leftDecPrice ? data.leftDecPrice : 0,
        et: data.etLeft,
        ct: data.ctLeft,
        ectctprice: data.leftEtPrice
          ? data.leftEtPrice
          : data.leftCtPrice
          ? data.leftCtPrice
          : 0,
        addDateTime: this.appCons.getDate(),
        addUserId: this.appCons.getUserId(),
        updateDateTime: this.appCons.getDate(),
        updateUserId: this.appCons.getUserId(),
        active: true,
      });
      salesOrderLens.push({
        // tslint:disable-next-line:radix
        salesOrderId: this.salesOrderId ? parseInt(this.salesOrderId) : 0,
        salesOrderLensId: this.salesOrderId ? (data.leftSalesOrderLensId ? data.leftSalesOrderLensId : 0) : 0,
        itemCatalogGroupId: data.itemCatalogGroupId,
        vendorItemCatalogId: 0,
        lensSideId: 1,
        sph: data.sphLeft,
        cyl: data.cylLeft,
        addf: data.addfLeft,
        qty: data.qtyLeft,
        unitPrice: data.lensePriceLeft ? data.lensePriceLeft : 0,
        size: this.bothSidesForm.get('diameterLeft').value,
        axis: data.axisLeft,
        mplDetailId: data.leftmpldetailId,
        excludeBrandDiscount: data.leftexcludebranddiscount,
        pricingTypeId: data.leftpricingTypeId,
        uomId: 2,
        isOurLens: data.isOurLens, // please remove
        cutUncutLensId: data.cutUncutLensId ? data.cutUncutLensId : 0,
        totalLensPrice: this.$subTotalLeft,
        addDateTime: this.appCons.getDate(),
        addUserId: this.appCons.getUserId(),
        updateDateTime: this.appCons.getDate(),
        updateUserId: this.appCons.getUserId(),
        active: true,
      });
      payload.salesOrderDetail["salesOrderJob"] = salesOrderJob;
      payload.salesOrderDetail["salesOrderLens"] = salesOrderLens;
    }
    if (this.selectedTemplate == "right") {
      salesOrderJob.push({
        salesOrderId: this.salesOrderId ? this.salesOrderId : 0,
        salesOrderJobId: this.salesOrderId ? (data.rightSalesOrderJobId ? data.rightSalesOrderJobId : 0) : 0,
        // salesOrderTypeId:  this.addSaleForm.get('salesOrderTypeId').value,
        size: this.bothSidesForm.get('diameterRight').value,
        sizePrice: 0,
        lensSideId: 2,
        isOval: data.isOvalRight,
        ovalWidth: data.ovalWidthRight,
        ovalHight: data.ovalHeightRight,
        ovalPrice: data.rightOval ? data.rightOval : 0,
        sph: data.sphRight,
        cyl: data.cylRight,
        axis: data.axisRight,
        addf: data.addfRight,
        ipd: data.ipdRight,
        // confusion about input field
        qty: data.qtyRight,
        lensPrice: data.lensePriceRight ? data.lensePriceRight : 0,
        prismIn: data.prismInRight,
        prismOut: data.prismOutRight,
        prismUp: data.prismUpRight,
        prismDown: data.prismDownRight,
        prismValue: data.prismValueRight,
        prismAxis: data.prismAxisRight,
        // confusion no fields exists
        prismRate: data.rightPrismPrice ? data.rightPrismPrice : 0,
        prismBase: data.baseCurveRight,
        baseCurvePrice: data.rightBaseCurvePrice ? data.rightBaseCurvePrice : 0,
        isLowerBase: true,
        // confusion no fields exists
        decin: data.decinRight,
        decout: data.decoutRight,
        decprice: data.rightDecPrice ? data.rightDecPrice : 0,
        et: data.etRight,
        ct: data.ctRight,
        ectctprice: data.rightEtPrice
          ? data.rightEtPrice
          : data.rightCtPrice
          ? data.rightCtPrice
          : 0,
        addDateTime: this.appCons.getDate(),
        addUserId: this.appCons.getUserId(),
        updateDateTime: this.appCons.getDate(),
        updateUserId: this.appCons.getUserId(),
        active: true,
      });
      salesOrderLens.push({
        // tslint:disable-next-line:radix
        salesOrderId: this.salesOrderId ? parseInt(this.salesOrderId) : 0,
        salesOrderLensId: this.salesOrderId ? (data.rightSalesOrderLensId ? data.rightSalesOrderLensId : 0) : 0,
        itemCatalogGroupId: data.itemCatalogGroupId,
        vendorItemCatalogId: 0,
        lensSideId: 2,
        size: this.bothSidesForm.get('diameterRight').value,
        sph: data.sphRight,
        cyl: data.cylRight,
        addf: data.addfRight,
        qty: data.qtyRight,
        mplDetailId: data.rightmpldetailId,
        excludeBrandDiscount: data.rightexcludebranddiscount,
        pricingTypeId: data.rightpricingTypeId,
        uomId: 2,
        unitPrice: data.lensePriceRight ? data.lensePriceRight : 0,
        axis: data.axisRight,
        isOurLens: data.isOurLens, // please remove
        cutUncutLensId: data.rightCutUncutLensId ? data.rightCutUncutLensId : 0,
        totalLensPrice: this.$subTotalRight,
        addDateTime: this.appCons.getDate(),
        addUserId: this.appCons.getUserId(),
        updateDateTime: this.appCons.getDate(),
        updateUserId: this.appCons.getUserId(),
        active: true,
      });
      payload.salesOrderDetail["salesOrderJob"] = salesOrderJob;
      payload.salesOrderDetail["salesOrderLens"] = salesOrderLens;
    }
    this._salesService
      .addSalesOrder(payload, this.salesOrderId)
      .then((response: any) => {
        if (response.data.completed) {
          if (this.salesOrderId && this.salesOrderData && this.salesOrderData.departmentId ==2) {
               // GENERATE REPORT FUNCTION
              // this.generateSalesOrderReport(
              //   payload.salesOrderId > 0
              //     ? payload.salesOrderId
              //     : response.data.payload,
              //     this.salesOrderId ? (this.salesOrderData.departmentId ==2 ? false : true) : false
              // );
              // END
          }
          this.loadingIndicator = false;
          let msg = this.salesOrderId
            ? "update successfully"
            : "added successfully";
          this.saveSwal.swalOptions = {
            icon: "success",
            // titleText: payload.salesOrderId > 0 ? payload.salesOrderId : response.data.payload + response.data.message,
            titleText: "Sale Order # " + response.data.payload + " " + msg,
            showConfirmButton: false,
            showCancelButton: true,
            cancelButtonText: "Ok",
            allowOutsideClick: false,
            allowEscapeKey: false,
            timer: null
          
          };
          this.saveSwal.fire().then((res: any) => {
            if (this.salesOrderId) {
              this.hideSubmitBtn = false;
              this.router.navigate(["./portal/sales/sales-inquiry/index"]);
            } else {
              // this.bothSidesForm.reset();
              this.router.navigate([
                "./portal/sales/job-order",
              ]);
              this.data = null;
             
              this.scrollToBottom(10);
              this.changeTemplate();
              if (this.isPricePanel) {
                this.openNav();
              }
              this.getInitForm();
              this.getInitCall();
              this.initReset();
              // this.bothSidesForm.get("salesOrderTypeId").setValue(5);
              this.selectedTemplate = "both";
              // this.bothSidesForm.get("customerTypeId").setValue(1);
              // this.bothSidesForm.get("urgencyTypeId").setValue(2);
              // this.initReset();
              this.hideSubmitBtn = false;
              // this.getBrandMasterByCategoryId(1);
              // this.bothSidesForm
              // .get("itemCatalogFilters")
              // .get("brandMasterId")
              // .setValue(this.brandMasterList[0].brandMasterId);
            }
          });
        } else {
          this.loadingIndicator = false;
          this.hideSubmitBtn = false;
          const option = {
            width: 300,
            displayTime: 3000,
            message: response.data.message,
            type: "error",
          };
          notify(option);
        }
      })
      .catch((error) => {
        this.loadingIndicator = false;
        this.hideSubmitBtn = false;
        const option = {
          width: 300,
          displayTime: 3000,
          message: error.message,
          type: "error",
        };
        notify(option);
      });
  }

 
  /**
   * @name setBothSideData
   * @return DataScouce
   */
  setBothSideData() {
    this.getCustomerBrandMasterByCategoryId(1, this.data.customerId);
    let editData = {
      salesId: this.data ? this.data.salesOrderId : "",
      salesOrderId : this.data ? this.data.salesOrderId : 0,
      customerBranchId: this.data ? this.data.customerBranchId : "",
      urgencyTypeId: this.data ? this.data.urgencyTypeId : 2,
      customerTypeId: this.data ? this.data.customerTypeId : "",
      instruction: this.data ? this.data.instruction : "",
      remarks: this.data ? this.data.remarks : "",
      ponumber: this.data ? this.data.ponumber : "",
      customerContactId: this.data ? this.data.customerContactId : "",
      partnerOrderNumber: this.data ? this.data.partnerOrderNumber : "",
      isCombo: this.data ? this.data.isCombo : false,
      salesOrderReportFile: this.data ? this.data.salesOrderReportFile : null,
      salesOrderJobCustomizeInfoId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo
              .salesOrderJobCustomizeInfoId
          : 0,
      salesOrderServiceId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.salesOrderServiceId
          : 0,
      salesOrderFrameFittingId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting
              .salesOrderFrameFittingId
          : 0,
      brandMasterId: this.data ? this.data.brandMasterId : "",
      isOurLens: this.data ? this.data.isOurLens : false,
      urgencyType: this.data ? this.data.urgencyTypeId : "",
      companyBranchId: this.data ? this.data.companyBranchId : "",
      searchLens: this.data && this.data.searchLens ? this.data.searchLens : "",
      patientName:
        this.data && this.data.patientName ? this.data.patientName : "",
      isWaitforSample: this.data ? this.data.isWaitforSample : "",
      material: this.data && this.data.material ? this.data.material : "",
      brandName: this.data && this.data.brandName ? this.data.brandName : "",
      filter: this.data && this.data.filter ? this.data.filter : "",
      tech: this.data && this.data.tech ? this.data.tech : "",
      focal: this.data && this.data.focal ? this.data.focal : "",
      coating: this.data && this.data.coating ? this.data.coating : "",
      rhft:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo.rhft
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.rhft
          : "",
      lhft:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo.lhft
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.lhft
          : "",
      ffv:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.ffv
          : "",
      bvd:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.bvd
          : "",
      pa:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.pa
          : "",
      wrap:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.wrap
          : "",
      nwd:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.nwd
          : "",
      mid:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.mid
          : "",
      age: this.data ? this.data.customerAge : "",
      specialBase: this.data ? this.data.specialBase : "",
      coat:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.coatingBrandId
          : "",
      coatingLocation:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.coatingLocationBranchId
          : "",
      backOnly:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.isBackOnly
          : "",
      hc:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.hcoatingId
          : "",
      hcLocation:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.hclocationBranchId
          : "",
      mirror:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.mirrorId
          : "",
      tintType:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.tintId
          : "",
      tintLocation:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.tintLocationBranchId
          : "",
      color1:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.color1Id
          : "",
      color2:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.color2Id
          : "",
      percentage:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.tintPercentage
          : "",
      otherServices:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.otherServicesId
          : "",
      nameCode:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.nameCode
          : "",
      engraveId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.engraveId
          : "",
      fitting:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.isFitting
          : false,
      rightFittingTypeId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.rightFittingTypeId
          : "",
      rightFrameTypeId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.rightFrameTypeId
          : "",
      tailorMade:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.isTailorMade
          : "",
      fittingTypeId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.fittingTypeId
          : "",
      circumference:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.circumference
          : "",
      frameType:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.frameId
          : "",
      frameCondition:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.frameConditionId
          : "",
      frameBrand:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.frameBrandName
          : "",
      frameMaterial:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.materialId
          : "",
      frameColor:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.colorMasterId
          : "",
      frameSize:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting &&
        this.data.salesOrderDetail.salesOrderFrameFitting.frameSize
          ? this.data.salesOrderDetail.salesOrderFrameFitting.frameSize
          : "",
      frameModel:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.frameModel
          : "",
      accurateIPD:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting &&
        this.data.salesOrderDetail.salesOrderFrameFitting.accurateIPD
          ? this.data.salesOrderDetail.salesOrderFrameFitting.accurateIPD
          : false,
      isTracing:
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderFrameFitting &&
      this.data.salesOrderDetail.salesOrderFrameFitting.isTracing
        ? this.data.salesOrderDetail.salesOrderFrameFitting.isTracing
        : false,

      dbl:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.dbl
          : "",
      ipdr:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.ipdr
          : "",
      ipdl:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.ipdl
          : "",
      frameRHFT:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.rhft
          : "",
      frameLHFT:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.lhft
          : "",
      segmentHeight:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.segmentHeight
          : "",
      lensReference:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo.lensShapeName
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.lensShapeName
          : "",
      tracingImage:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.tracingPath
          : "",
      tracingImageName:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.tracingPath
          : "",
      frameAvailable:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.frameAvailable
          : false,
      shape:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.shape
          : "",
      tailorWidth:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.tailorWidth
          : "",
      tailorHeight:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.tailorHeight
          : "",
      minTHK:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.minThk
          : "",
      maxTHK:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.maxThk
          : "",
      thkTample:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.templeThk
          : "",
      thkNose:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderJobCustomizeInfo
          ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.noseThk
          : "",

      isFrameCase:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.isFrameCase
          : "",
      up:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.up
          : "",
      down:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.down
          : "",
      temple:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.temple
          : "",
      nasel:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.nasel
          : "",
      fittingLocationId:
        this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderFrameFitting
          ? this.data.salesOrderDetail.salesOrderFrameFitting.fittingLocationId
          : "",
      lensShapeId: this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderJobCustomizeInfo
        ? this.data.salesOrderDetail.salesOrderJobCustomizeInfo.lensShapeId
        : ""
    };
    if (
      this.data &&
      this.data.salesOrderDetail.salesOrderJob &&
      this.data.salesOrderDetail.salesOrderJob.length > 0
    ) {
      let leftJob = this.data.salesOrderDetail.salesOrderJob.find(
        (item) => item.lensSideId == 1
      );
      let rightJob = this.data.salesOrderDetail.salesOrderJob.find(
        (item) => item.lensSideId == 2
      );
      if (leftJob) {
        editData["leftSalesOrderJobId"] = leftJob.salesOrderJobId ? leftJob.salesOrderJobId : 0;
        editData["sphLeft"] = leftJob.strSph;
        editData["cylLeft"] = leftJob.strCyl;
        editData["axisLeft"] = leftJob.axis;
        editData["addfLeft"] = leftJob.strAddf;
        editData["qtyLeft"] = leftJob.qty;
        editData["diameterLeft"] = leftJob.size;
        editData["isOvalLeft"] = leftJob.isOval;
        editData["ovalWidthLeft"] = leftJob.ovalWidth;
        editData["ovalHeightLeft"] = leftJob.ovalHight;
        editData["baseCurveLeft"] = leftJob.prismBase;
        editData["etLeft"] = leftJob.et;
        editData["ctLeft"] = leftJob.ct;
        editData["decinLeft"] = leftJob.decin;
        editData["decoutLeft"] = leftJob.decout;
        editData["ipdLeft"] = leftJob.ipdLeft;
        editData["prismInLeft"] = leftJob.prismIn;
        editData["prismOutLeft"] = leftJob.prismOut;
        editData["prismUpLeft"] = leftJob.prismUp;
        editData["prismDownLeft"] = leftJob.prismDown;
        editData["prismValueLeft"] = leftJob.prismValue;
        editData["prismAxisLeft"] = leftJob.prismAxis;
        this.$lensePriceLeft = leftJob ? leftJob.lensPrice : 0;
        this.$leftOval = leftJob ? leftJob.ovalPrice : 0;
        this.$leftEtPrice = leftJob.et ? leftJob.ectctprice : 0;
        this.$leftCtPrice = leftJob.ct ? leftJob.ectctprice : 0;
        this.$leftDecPrice = leftJob ? leftJob.decprice : 0;
        this.$leftPrismPrice = leftJob ? leftJob.prismRate : 0;
        this.$leftBaseCurvePrice = leftJob ? leftJob.baseCurvePrice : 0;
      }
      if (rightJob) {
        editData["rightSalesOrderJobId"] = rightJob.salesOrderJobId ? rightJob.salesOrderJobId : 0;
        editData["sphRight"] = rightJob.strSph;
        editData["cylRight"] = rightJob.strCyl;
        editData["axisRight"] = rightJob.axis;
        editData["addfRight"] = rightJob.strAddf;
        editData["qtyRight"] = rightJob.qty;
        editData["diameterRight"] = rightJob.size;
        editData["isOvalRight"] = rightJob.isOval;
        editData["ovalWidthRight"] = rightJob.ovalWidth;
        editData["ovalHeightRight"] = rightJob.ovalHight;
        editData["baseCurveRight"] = rightJob.prismBase;
        editData["etRight"] = rightJob.et;
        editData["ctRight"] = rightJob.ct;
        editData["decinRight"] = rightJob.decin;
        editData["decoutRight"] = rightJob.decout;
        editData["ipdRight"] = rightJob.ipdRight;
        editData["prismInRight"] = rightJob.prismIn;
        editData["prismOutRight"] = rightJob.prismOut;
        editData["prismUpRight"] = rightJob.prismUp;
        editData["prismDownRight"] = rightJob.prismDown;
        editData["prismValueRight"] = rightJob.prismValue;
        editData["prismAxisRight"] = rightJob.prismAxis;
        this.$lensePriceRight = rightJob ? rightJob.lensPrice : 0;
        this.$rightOval = rightJob ? rightJob.ovalPrice : 0;
        this.$rightEtPrice = rightJob.et ? rightJob.ectctprice : 0;
        this.$rightCtPrice = rightJob.ct ? rightJob.ectctprice : 0;
        this.$rightDecPrice = rightJob ? rightJob.decprice : 0;
        this.$rightPrismPrice = rightJob ? rightJob.prismRate : 0;
        this.$rightBaseCurvePrice = rightJob ? rightJob.baseCurvePrice : 0;
      }
    }
    // SET PRICE
    this.$coatingPriceLeft =
    this.data &&
    this.data.salesOrderDetail &&
    this.data.salesOrderDetail.salesOrderService
      ? this.data.salesOrderDetail.salesOrderService.leftCoatingPrice
      : 0;
    this.$coatingPriceRight =
    this.data &&
    this.data.salesOrderDetail &&
    this.data.salesOrderDetail.salesOrderService
      ? this.data.salesOrderDetail.salesOrderService.rightCoatingPrice
      : 0;
    this.$mirrorPriceLeft =
    this.data &&
    this.data.salesOrderDetail &&
    this.data.salesOrderDetail.salesOrderService
      ? this.data.salesOrderDetail.salesOrderService.leftMirrorPrice
      : 0;
      this.$mirrorPriceRight =
    this.data &&
    this.data.salesOrderDetail &&
    this.data.salesOrderDetail.salesOrderService
      ? this.data.salesOrderDetail.salesOrderService.rightMirrorPrice
      : 0;
      this.$tintPriceLeft =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderService
        ? this.data.salesOrderDetail.salesOrderService.leftTintPrice
        : 0;
        this.$tintPriceRight =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderService
        ? this.data.salesOrderDetail.salesOrderService.rightTintPrice
        : 0;
    // this.$coatingPrice =
    //   this.data &&
    //   this.data.salesOrderDetail &&
    //   this.data.salesOrderDetail.salesOrderService
    //     ? this.data.salesOrderDetail.salesOrderService.coatingPrice
    //     : 0;
    this.$hcPrice =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderService
        ? this.data.salesOrderDetail.salesOrderService.hcprice
        : 0;
    // this.$mirrorPrice =
    //   this.data &&
    //   this.data.salesOrderDetail &&
    //   this.data.salesOrderDetail.salesOrderService
    //     ? this.data.salesOrderDetail.salesOrderService.mirrorPrice
    //     : 0;
    // this.$tintPrice =
    //   this.data &&
    //   this.data.salesOrderDetail &&
    //   this.data.salesOrderDetail.salesOrderService
    //     ? this.data.salesOrderDetail.salesOrderService.tintPrice
    //     : 0;
    this.$fittingPrice =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderFrameFitting
        ? this.data.salesOrderDetail.salesOrderFrameFitting.unitPrice
        : 0;
    this.$rightFittingPrice =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderFrameFitting
        ? this.data.salesOrderDetail.salesOrderFrameFitting.rightUnitPrice
        : 0;
    //   this.$selectedOtherServicePrice = this.data &&
    // this.data.salesOrderDetail &&
    // this.data.salesOrderDetail.salesOrderService
    //   ? this.data.salesOrderDetail.salesOrderService.otherServicePrice
    //   : 0,
    this.$specialLogo =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderService
        ? this.data.salesOrderDetail.salesOrderService.specialLogoPrice
        : 0;
    this.$engraveName =
      this.data &&
      this.data.salesOrderDetail &&
      this.data.salesOrderDetail.salesOrderService
        ? this.data.salesOrderDetail.salesOrderService.engraveNamePrice
        : 0;
        this.$selectedOtherServicePrice = this.data &&
        this.data.salesOrderDetail &&
        this.data.salesOrderDetail.salesOrderService
          ? this.data.salesOrderDetail.salesOrderService.otherServicePrice
          : 0;
    this.$discountPrice =
      this.data && this.data.discountPrice ? this.data.discountPrice : 0;
    this.$tailorMadePrice =
      this.data && this.data.tailorMadePrice ? this.data.tailorMadePrice : 0;
    this.$additionalPrice =
      this.data && this.data.additionalPrice ? this.data.additionalPrice : 0;
    this.$tempCoatingPrice = this.$coatingPrice;
    this.$tempTintPrice = this.$tintPrice;
    this.$tempLeftPrismPrice = this.$leftPrismPrice;
    this.$tempRightPrismPrice = this.$rightPrismPrice;
    this.$tempFittingPrice = this.$fittingPrice;
    this.$tempRightFittingPrice = this.$rightFittingPrice;
    this.$tempLeftCtPrice = this.$leftCtPrice;
    this.$tempRightCtPrice = this.$rightCtPrice;
    this.$tempRightEtPrice = this.$rightEtPrice;
    this.$tempLeftEtPrice = this.$leftEtPrice;
    this.$tempMirrorPrice = this.$mirrorPrice;
    this.$tempLeftBaseCurvePrice = this.$leftBaseCurvePrice;
    this.$tempRightBaseCurvePrice = this.$rightBaseCurvePrice;
    this.$tempRightDecPrice = this.$rightDecPrice;
    this.$tempLeftDecPrice = this.$leftDecPrice;
    this.$tempTailorMadePrice = this.$tailorMadePrice;
    this.$tempEngraveName = this.$engraveName;
    this.$tempSpecialLogo = this.$specialLogo;
    this.$tempHcPrice = this.$hcPrice;
    this.$tempLeftOval = this.$leftOval;
    this.$tempRightOval = this.$rightOval;
    this.$tempLensePriceRight = this.$lensePriceRight;
    this.$tempLensePriceLeft = this.$lensePriceLeft;
    this.$tempSelectedOtherServicePrice = this.$selectedOtherServicePrice;
    this.$tempCoatingPriceRight = this.$coatingPriceRight;
    this.$tempMirrorPriceRight = this.$mirrorPriceRight;
    this.$tempTintPriceRight = this.$tintPriceRight;
    this.$tempCoatingPriceLeft = this.$coatingPriceLeft;
    this.$tempMirrorPriceLeft = this.$mirrorPriceLeft;
    this.$tempTintPriceLeft = this.$tintPriceLeft;


    // END
    if (
      this.data &&
      this.data.salesOrderDetail.salesOrderLens &&
      this.data.salesOrderDetail.salesOrderLens.length > 0
    ) {
      let leftLens = this.data.salesOrderDetail.salesOrderLens.find(
        (item) => item.lensSideId == 1
      );
      let rightLens = this.data.salesOrderDetail.salesOrderLens.find(
        (item) => item.lensSideId == 2
      );
      if (leftLens) {
        editData["leftSalesOrderLensId"] = leftLens.salesOrderLensId ? leftLens.salesOrderLensId : 0;
        editData["itemCatalogGroupId"] = leftLens.itemCatalogGroupId ? leftLens.itemCatalogGroupId : 0;
        // editData["isOurLens"] = leftLens.isOurLens;
        editData["cutUncutLensId"] = leftLens.cutUncutLensId;
        editData["leftexcludebranddiscount"] = leftLens.excludeBrandDiscount;
        editData["leftmpldetailId"] = leftLens.mplDetailId;
        editData["leftpricingTypeId"] = leftLens.pricingTypeId;
      }
      if (rightLens) {
        editData["rightSalesOrderLensId"] = rightLens.salesOrderLensId ? rightLens.salesOrderLensId : 0;
        editData["itemCatalogGroupId"] = rightLens.itemCatalogGroupId ? rightLens.itemCatalogGroupId : 0;
        editData["rightexcludebranddiscount"] = rightLens.excludeBrandDiscount;
        editData["rightmpldetailId"] = rightLens.mplDetailId;
        editData["rightpricingTypeId"] = rightLens.pricingTypeId;
        // editData["rightIsOurLens"] = rightLens.isOurLens;
        // editData["rightCutUncutLensId"] = rightLens.cutUncutLensId;
      }
    }

    this.customerId = this.data.customerId;
    this.customerBranchId = this.data.customerBranchId;
    this.getInitForm(editData);
    setTimeout(() => {
      this.changeTemplate();
      if (this.data && this.data.isCombo) {
        this.isComboPrice = true;
        if (this.bothSidesForm.get("coat").value) {
          this.comboCoatingPrice = true;
          setTimeout(() => {
            this.bothSidesForm.get("coat").disable();
          }, 50);
          
        } else {
          this.bothSidesForm.get("coat").setValue(null);
          this.bothSidesForm.get("coat").enable();
          this.comboCoatingPrice = false;
        }

        if (this.bothSidesForm.get("tintType").value) {
          this.comboTintPrice = true;
          setTimeout(() => {
            this.bothSidesForm.get("tintType").disable();
          }, 50);
          
        } else {
          this.comboTintPrice = false;
          this.bothSidesForm.get("tintType").setValue(null);
          this.bothSidesForm.get("tintType").enable();
        }

        if (this.bothSidesForm.get("mirror").value) {
          this.comboMirrorPrice = true;
          setTimeout(() => {
            this.bothSidesForm.get("mirror").disable();
          }, 50);
        } else {
          this.comboMirrorPrice = false;
          this.bothSidesForm.get("mirror").setValue(null);
          this.bothSidesForm.get("mirror").enable();
        }


        if (this.bothSidesForm.get("fittingTypeId").value) {
          this.comboFittingPrice = true;
          setTimeout(() => {
            this.bothSidesForm.get("fittingTypeId").disable();
          }, 50);
          this.toggleFrame = false;
          this.toggle("frame");
        } else {
          this.comboFittingPrice = false;
          this.bothSidesForm.get("fittingTypeId").setValue(null);
          this.bothSidesForm.get("fittingTypeId").enable();
        }
      }
     
    },1500);
  }
  restrictDecimalPlaces(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End'
    ];
  
    if (allowedKeys.includes(event.key)) {
      return; // Allow navigation and control keys
    }
  
    const input = event.target as HTMLInputElement;
  
    // Current value and what the value will be after this key is applied
    const currentValue = input.value;
    const selectionStart = input.selectionStart || 0;
    const selectionEnd = input.selectionEnd || 0;
  
    // Simulate next value if key is pressed
    const nextValue =
      currentValue.substring(0, selectionStart) +
      event.key +
      currentValue.substring(selectionEnd);
  
    // Allow only numbers and dot
    if (!/^\d*\.?\d*$/.test(event.key)) {
      event.preventDefault();
      return;
    }
  
    // Allow max 2 decimal places
    const parts = nextValue.split('.');
    if (parts.length === 2 && parts[1].length > 2) {
      event.preventDefault();
    }
  }
  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    $('#main-content').css({'background': ''});
    
  }
  getCustomerBrandMaster(customerId: number, isRx: boolean,isStock: boolean, isOther: boolean) {
    this._salesService
      .getCustomerBrandMaster(customerId, isRx, isStock, isOther)
      .then((response) => {
        if (response.data.completed) {
          if (response.data.payload.length > 0) {
            const list = [];
            response.data.payload.forEach((element: any) => {
              if (element.active) {
                list.push(element);
              }
            });
            this.brandMasterList = list;
            
          } else {
            if (response.data.payload.active) {
              this.brandMasterList = response.data.payload;
            //   if (!this.isCopySaleOrder && !this.salesOrderId) {
            //   this.bothSidesForm
            // .get("itemCatalogFilters")
            // .get("brandMasterId")
            // .setValue(response.data.payload[0].brandMasterId);
            //   }
            }
          }
          if (Object.entries(this.selectedItemCatalogObject).length > 0) {
            this.bothSidesForm
          .get("itemCatalogFilters")
          .get("brandMasterId")
          .setValue(this.selectedItemCatalogObject.brandMasterId);
          }
        }
        let brand = this.bothSidesForm.get("itemCatalogFilters").get("brandMasterId").value;
        if((this.isCopySaleOrder || this.salesOrderId) && brand){
          //this.getAllSubBrandMasterByBrandMasterId(brand);
        }
        
        this.loadingIndicator = false;
      })
      .catch((err) => {
        this.loadingIndicator = false;
        console.error("Error:  ", err);
      });
  }

  /**
   * @name warringMsg
   * @return void
   * @description if user qty value > 2 then warning 
   */
  warringMsg(value) {
    if (value && value > 2) {
      this.saveSwal.swalOptions = {
        icon: "warning",
        titleText:
          "Are you sure you want to create order with QTY?...",
        showConfirmButton: true,
        confirmButtonText: "Yes",
        showCancelButton: true,
        allowOutsideClick: false,
        allowEscapeKey: false,
        timer: null
      };
      this.saveSwal.fire().then((res: SweetAlertResult) => {
        if (res && res.dismiss && res.dismiss == Swal.DismissReason.cancel) {
          // RESET ALL API CALL AGAIN 
          this.bothSidesForm.get("qtyLeft").setValue(1);
          this.bothSidesForm.get("qtyRight").setValue(1);
        } 
      });
    }
  }
   
  
 /* getAllSubBrandMasterByBrandMasterId(brandMasterId: number) {
    if (brandMasterId) {
  
      this.subBrandList = [];
     this._salesService
       .getAllSubBrandMasterByBrandMasterId(brandMasterId)
       .then((response) => {
         if (response.data.completed) {
           if (response.data.payload.length > 0) {
             const list = [];
             response.data.payload.forEach((element: any) => {
               if (element.active) {
                 list.push(element);
               }
             });
             this.subBrandList = list;
           } else {
             if (response.data.payload.active) {
               this.subBrandList = response.data.payload;
             }
           }
         }
         
       })
       .catch((err) => {
         
         console.error("Error:  ", err);
       })
    } else {
     this.subBrandList = [];
     this.bothSidesForm.get("itemCatalogFilters").get("subBrandMasterId").setValue(null)
    }
   }*/
}
